// v2026-08-08.1 (thumbnail upload)
(function () {
  const { DGSAppBaseUrl } = window;
  const discDesignProductId = document.getElementById("disc-design-productId");
  const discDesignVariantId = document.getElementById("disc-design-variantId");

  // Get a JSON object
  const variantId = discDesignVariantId.value;
  const productId = discDesignProductId.value;
  const designKey = `discDesign-${variantId}`;
  window.designKey = designKey;

  // True whenever the canvas differs from the design last committed to the
  // cart (starts true: nothing committed yet). Cleared only on a successful
  // save/attach. Drives the add-to-cart dupe guard: an unchanged re-add reuses
  // the committed URL so Shopify merges the line instead of minting a
  // lookalike second line under a fresh URL. A spuriously-true flag is safe -
  // it just re-saves, which was the old behavior for every add.
  window.DGS_canvasDirty = true;

  // Bumped on every edit, alongside the dirty flag. A save captures it before
  // exporting and only clears the flag if it is unchanged when the upload
  // finishes: the canvas and palette stay live during the upload, so an edit
  // made then is NOT in the committed print file (order #22438: background
  // switched to green mid-upload, cart showed green, print file was white).
  window.DGS_canvasRev = 0;
  window.DGS_markCanvasDirty = function () {
    window.DGS_canvasDirty = true;
    window.DGS_canvasRev += 1;
  };

  // Storage-blocked webviews (Facebook / Instagram in-app browsers, private
  // mode, "block all cookies") throw on any localStorage access. An unguarded
  // read here aborted the entire designer setup below - the canvas never built
  // and "Choose an Image" was a dead button ("editor doesn't work"). Degrade to
  // a fresh design instead of throwing. Same for a corrupt/partial stored value.
  let discDesign = null;
  try {
    discDesign = localStorage.getItem(designKey);
  } catch (e) {
    discDesign = null;
  }
  if (discDesign) {
    try {
      discDesign = JSON.parse(discDesign);
    } catch (e) {
      discDesign = null;
    }
  }
  if (!discDesign) {
    discDesign = {
      productId,
      designKey,
      variantId,
      dataURL: "",
      json: "",
      type: "",
    };
  }

  /* ------------------------------------------------------------------------JS for creeate design tab------------------------------------------------------------------------------*/

  const wrapper = document.getElementById("canvas-wrapper");
  const overlay = document.getElementById("scrollable-overlay");
  const canvasEl = document.getElementById("disc-canvas");
  let canvas;
  
  let activeTextColor = "#000000";

  // Variables for canvas responsiveness
  let isResizing = false;
  let originalCanvasSize = 0;
  let isImporting = false;

  // Store curved text states for restoration
  let curvedTextStates = new Map();

  let images = []; // Array to store all uploaded images
  let activeImage = null; // Currently active image for scaling
  let initialDistance = 0;
  let initialScale = 1;

  // Native touch event handlers for mobile pinch zoom
  let touches = [];
  let isScaling = false;

  const hasSelectedImage = () => {
    const activeObject = canvas.getActiveObject();
    return activeObject && activeObject.type === "image";
  };
  let fillCropBtn = document.getElementById("fill-crop-btn");
  let maxSizeBtn = document.getElementById("max-size-btn");

  // Update button states based on selection for image
  function updateIamgeActionButtonStates() {
    let hasSelectedObjectImage = hasSelectedImage();

    fillCropBtn.disabled = !hasSelectedObjectImage;
    maxSizeBtn.disabled = !hasSelectedObjectImage;

    if (hasSelectedObjectImage) {
      // fillCropBtn.classList.remove("hidden");
      // maxSizeBtn.classList.remove("hidden");
      fillCropBtn.classList.remove("opacity-50", "cursor-not-allowed");
      maxSizeBtn.classList.remove("opacity-50", "cursor-not-allowed");
    } else {
      // fillCropBtn.classList.add("hidden");
      // maxSizeBtn.classList.add("hidden");
      fillCropBtn.classList.add("opacity-50", "cursor-not-allowed");
      maxSizeBtn.classList.add("opacity-50", "cursor-not-allowed");
    }
    refreshRemoveBgButton();
  }

  // The square canvas has `touch-action:none` so artwork can be dragged, which
  // also means a phone swipe anywhere on it is captured instead of scrolling the
  // page. Once there is artwork, turn the overlay into a RING over just the
  // corners outside the round disc: only that ring receives touches (it scrolls
  // the page), while the centre disc falls through to the canvas for editing.
  // Mobile only — the overlay isn't positioned over the canvas on desktop.
  function isMobileViewport() {
    return window.matchMedia("(max-width: 676px)").matches;
  }
  function setOverlayRingClip() {
    if (!overlay) return;
    const w = overlay.clientWidth;
    const h = overlay.clientHeight;
    if (!w || !h) return;
    const r = Math.min(w, h) / 2;
    const cx = w / 2;
    const cy = h / 2;
    // outer rectangle minus the centre disc, evenodd => a ring over the corners
    overlay.style.clipPath =
      "path(evenodd, \"M0 0 H" + w + " V" + h + " H0 Z " +
      "M" + cx + " " + (cy - r) + " A " + r + " " + r + " 0 1 0 " + cx + " " + (cy + r) +
      " A " + r + " " + r + " 0 1 0 " + cx + " " + (cy - r) + " Z\")";
  }

  // Function to update overlay visibility based on canvas objects
  function updateOverlay() {
    // const hasObjects = canvas.getObjects().length > 0;
    const hasUserObjects = checkUserObjects();

    if (hasUserObjects) {
      // Canvas has objects - hide overlay to allow canvas interaction
      overlay.classList.remove("active");
      if (isMobileViewport()) {
        overlay.classList.add("dgs-scroll-ring");
        setOverlayRingClip();
      } else {
        overlay.classList.remove("dgs-scroll-ring");
        overlay.style.clipPath = "";
      }
    } else {
      // Canvas is empty - show overlay to allow scrolling
      overlay.classList.add("active");
      overlay.classList.remove("dgs-scroll-ring");
      overlay.style.clipPath = "";
    }
  }
  // Keep the ring aligned to the disc when the canvas is re-sized (address bar,
  // rotation). updateOverlay recomputes the clip from the live element size.
  window.addEventListener("resize", function () {
    if (overlay.classList.contains("dgs-scroll-ring")) setOverlayRingClip();
  });

 // Add click event to overlay that checks if click is on placeholder
  overlay.addEventListener('click', function(e) {
      if (!overlay.classList.contains('active')) return;
      
      // Get click coordinates relative to canvas
      const rect = canvas.upperCanvasEl.getBoundingClientRect();
      const pointer = {
          x: e.clientX - rect.left,
          y: e.clientY - rect.top
      };
      
      // Find the image placeholder using the custom property
      const placeholder = canvas.getObjects().find(obj => obj.isImagePlaceholder === true);
      
      
      // The whole BLANK DISC opens the picker, not just the placeholder
      // graphic (owner's tester, on the phone: "the entire blank canvas
      // should be clickable to add image, not just the target button and
      // text"). Bounded to the disc CIRCLE: in the reskin, taps outside the
      // circle mean "give me the stage back" (dismiss/peek), and the reskin's
      // capture-phase interceptor still claims overlay clicks while a sheet
      // or the keyboard has the disc shrunk - so this only fires when the
      // shopper is looking at a full-size empty disc. The overlay is only
      // .active while the canvas is empty, so nothing here can ever fire
      // over real artwork.
      if (placeholder) {
          const cw = canvas.getWidth();
          const ch = canvas.getHeight();
          const inDisc =
              Math.hypot(pointer.x - cw / 2, pointer.y - ch / 2) <=
              Math.min(cw, ch) / 2;
          if (placeholder.containsPoint(pointer) || inDisc) {
              triggerImageUpload();
              e.stopPropagation();
              e.preventDefault();
          }

      }
  });

  // Make sure you have a function to trigger image upload
  function triggerImageUpload() {
      // Your existing image upload code
      const input = document.getElementById('image-upload'); // Your file input
      if (input) {
          input.click();
      }
  }



  // Improved responsive resize with debouncing
  // Debounced resize handler
  let resizeTimeout;
  let lastViewportHeight = window.innerHeight;
  let isKeyboardOpen = false;
  let keyboardDetectionThreshold = 150; // pixels
  let imagePlaceholder = null;


  const handleResize = () => {
    if (isImporting) return;

    const currentViewportHeight = window.innerHeight;
    const heightDifference = Math.abs(
      lastViewportHeight - currentViewportHeight
    );

    // Detect if this is likely a keyboard event
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      // On mobile, if height decreased significantly, it's likely keyboard opening
      if (
        currentViewportHeight < lastViewportHeight &&
        heightDifference > keyboardDetectionThreshold
      ) {
        isKeyboardOpen = true;
        // console.log("Mobile keyboard detected - skipping resize");
        return; // Don't resize canvas when keyboard opens
      }

      // If height increased significantly, keyboard might be closing
      if (
        currentViewportHeight > lastViewportHeight &&
        heightDifference > keyboardDetectionThreshold &&
        isKeyboardOpen
      ) {
        isKeyboardOpen = false;
        // console.log("Mobile keyboard closed - allowing resize");
        // Allow resize after keyboard closes
      }

      // If keyboard is open, don't resize
      if (isKeyboardOpen) {
        return;
      }
    }

    // Update last known viewport height
    lastViewportHeight = currentViewportHeight;

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      resizeCanvas();
    }, 150);
  };

  // Alternative approach using visualViewport API (modern browsers)
  const handleResizeWithVisualViewport = () => {
    if (isImporting) return;
    

    // Use Visual Viewport API if available (better mobile support)
    if (window.visualViewport) {
      const viewport = window.visualViewport;
      const heightDifference = Math.abs(window.innerHeight - viewport.height);

      // If visual viewport height is significantly less than window height,
      // keyboard is likely open
      if (heightDifference > keyboardDetectionThreshold) {
        console.log(
          "Keyboard detected via Visual Viewport API - skipping resize"
        );
        return;
      }
    }

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      resizeCanvas();
    }, 150);
  };

  function enableTabs() {
    const tabsToEnable = document.querySelectorAll(
      '.custom-tabs-nav li[data-tab="tab2"], .custom-tabs-nav li[data-tab="tab3"]'
    );

    tabsToEnable.forEach(tab => {
      if (tab.classList.contains("tabs-disabled")) {
        tab.classList.remove("tabs-disabled");
      }
    });
  }

  // --- Canvas Initialization ---
  const initializeCanvas = () => {
    // Cap max size. 500 unless the page sets window.DGS_CANVAS_MAX (a number,
    // 300-900; anything else - including unset - falls back to 500). Only the
    // v2 reskin sets it, and only in its DESKTOP layout, so v1, the portal and
    // every mobile layout keep the exact sizes (and export weights) they had.
    // The same guarded expression appears at the two resize sites below.
    const size = Math.min(wrapper.offsetWidth, (window.DGS_CANVAS_MAX >= 300 && window.DGS_CANVAS_MAX <= 900 ? window.DGS_CANVAS_MAX : 500));
    originalCanvasSize = size;

    // Set canvas element dimensions
    canvasEl.width = size;
    canvasEl.height = size;

    canvasEl.style.width = size + "px";
    canvasEl.style.height = size + "px";

    canvas = new fabric.Canvas("disc-canvas", {
      width: size,
      height: size,
      backgroundColor: "#ffffff",
      preserveObjectStacking: true, // Important: preserve stacking order
      enableRetinaScaling: true, // Automatically handles high DPI displays
      selection: false,
    });

    // Add custom metadata
    canvas.meta = {
      designId: null,
    };

    // Create circular clip path
    const clipPath = new fabric.Circle({
      radius: size / 2,
      left: size / 2,
      top: size / 2,
      originX: "center",
      originY: "center",
      absolutePositioned: true,
    });

    clipPath.set({
      left: canvas.width / 2,
      top: canvas.height / 2,
    });

    canvas.clipPath = clipPath;
    canvas.renderAll();

    

    // Enhanced event listeners
    window.removeEventListener("resize", handleResize); // Remove old listener if exists
    window.addEventListener(
      "resize",
      handleResizeWithVisualViewport || handleResize
    );

    // Additional safeguards for mobile
    if ("visualViewport" in window) {
      window.visualViewport.addEventListener("resize", () => {
        // Only handle visual viewport changes that aren't keyboard-related
        const viewport = window.visualViewport;
        const isLikelyKeyboard = viewport.height < window.innerHeight * 0.75;

        if (!isLikelyKeyboard) {
          handleResizeWithVisualViewport();
        }
      });
    }
    

    // window.addEventListener("resize", () => {
    //   const wrapperWidth = wrapper.offsetWidth;

    //   // Give padding only for mobile screens
    //   const isMobile = window.innerWidth <= 768; // you can adjust breakpoint
    //   const padding = isMobile ? 10 : 0; // 5px padding on mobile

    //   const newSize = wrapperWidth - padding * 2;

    //   canvas.setWidth(newSize);
    //   canvas.setHeight(newSize);
    //   clipPath.set({
    //     radius: newSize / 2,
    //     left: newSize / 2,
    //     top: newSize / 2,
    //   });
    //   canvas.renderAll();
    // });

    // Canvas event listeners
    canvas.on("selection:created", updateControls);
    canvas.on("selection:updated", updateControls);
    // Deselecting (tapping the bare disc, or Delete/Clear) must re-dim the
    // Object Controls too. Without this the cards stayed looking active but
    // inert, so every tap on Fill / Delete / Curve / the layer buttons was a
    // dead click with no feedback — the #1 dead-click source in Clarity, and
    // mostly on mobile where the canvas has scrolled out of sight.
    canvas.on("selection:cleared", updateControls);

    // COMPREHENSIVE LOCK EVENT HANDLING

    // 1. Before selection - prevent automatic bring-to-front
    canvas.on("before:selection:cleared", function () {
      // Store all current positions before any selection change
      canvas.getObjects().forEach((obj, index) => {
        if (obj.metadata) {
          obj.metadata.currentIndex = index;
        }
      });
    });

    canvas.on("selection:updated", function (e) {
      const activeObject = e.selected[0];
      if (activeObject) {
        handleObjectActivation(activeObject);
      }
      updateControls();
    });

    // 2. Mouse down - prevent default behavior for locked objects
    canvas.on("mouse:down", function (options) {
      // The disc is a circular clip, but Fabric's hit area is each object's
      // square bounding box, so the four corners outside the round disc still
      // grabbed the (there-invisible) artwork. On a phone those corners are what
      // people swipe to scroll past the canvas, so a scroll attempt silently
      // dragged their photo. Reject any press that lands outside the visible
      // disc: drop the selection and cancel the drag Fabric just set up.
      const pointer = canvas.getPointer(options.e);
      const radius = canvas.width / 2;
      if (Math.hypot(pointer.x - radius, pointer.y - radius) > radius) {
        canvas._currentTransform = null;
        if (canvas.getActiveObject()) {
          canvas.discardActiveObject();
          canvas.requestRenderAll();
        }
        return;
      }

      if (options.target) {
        const object = options.target;
        const currentIndex = canvas.getObjects().indexOf(object);

        // Always store current index
        if (object.metadata) {
          object.metadata.storedIndex = currentIndex;
        }

        // If object is locked, mark it for position restoration
        if ((object.metadata && object.metadata.isLocked) || object.locked) {
          object._needsPositionRestore = true;
          object._originalIndex = currentIndex;
          // console.log(`Locked object clicked at index ${currentIndex}`);
        }
        
        if (object && object.isImagePlaceholder) {
          triggerImageUpload();
          return;
        }
      } else if (!checkUserObjects()) {
        // Desktop parity for "the entire blank canvas should be clickable to
        // add image" (owner's tester). On phones the scroll overlay covers
        // the canvas and its click handler opens the picker anywhere on the
        // empty disc, but on desktop that overlay is zero-height below the
        // canvas, so only the placeholder graphic itself was clickable. The
        // outside-disc rejection above already ran, so this press is inside
        // the visible disc; with no user artwork there is nothing else a
        // press here could mean.
        triggerImageUpload();
      }
    });
    // 3. After selection - restore locked object positions
    canvas.on("selection:created", function (e) {
      const activeObject = e.selected && e.selected[0];
      if (activeObject) {
        setTimeout(() => {
          handleObjectActivation(activeObject);
          updateControls();
        }, 0);
      }
    });

    canvas.on("selection:updated", function (e) {
      const activeObject = e.selected && e.selected[0];
      if (activeObject) {
        setTimeout(() => {
          handleObjectActivation(activeObject);
          updateControls();
        }, 0);
      }
    });

    // 4. Object modified - prevent locked objects from changing layers
    canvas.on("object:modified", function (e) {
      const object = e.target;
      if ((object.metadata && object.metadata.isLocked) || object.locked) {
        restoreObjectToOriginalPosition(object);
      }

      if (e.target && e.target.type === "image") {
        bringAllTextToFront();
        canvas.renderAll();
      }
    });

    // 5. After render - ensure locked objects stay in position
    canvas.on("after:render", function () {
      // Check if any locked objects have moved and restore them
      canvas.getObjects().forEach((obj, currentIndex) => {
        if (
          ((obj.metadata && obj.metadata.isLocked) || obj.locked) &&
          obj.metadata &&
          obj.metadata.storedIndex !== undefined &&
          obj.metadata.storedIndex !== currentIndex
        ) {
          // Silently move back to correct position
          canvas.moveTo(obj, obj.metadata.storedIndex);
        }
      });
    });

    // Listen for object movements to update indices start here
    canvas.on("object:added", function (e) {
      updateOverlay();
      updateAllObjectIndices();
      // console.log("Object added. Current indices updated.");
      updatePlaceholders();
    });

    canvas.on("object:removed", function (e) {
      updateOverlay();
      updateAllObjectIndices();
      // console.log("Object removed. Current indices updated.");
      updatePlaceholders();
    });

    canvas.on("path:created", function (e) {
      updateAllObjectIndices();
    });

    canvas.on("selection:cleared", function (e) {
      updateOverlay();
      // A stray tap on the disc background is easy to do on a phone, and it
      // took every Object Control with it - including Fill the disc / Fit
      // whole photo, which is how most people size their photo. When there is
      // exactly one thing on the disc there is no ambiguity about what the
      // controls would act on, so put the selection back.
      reselectSoleObject();
      updateControls();
      bringAllTextToFront();
    });
    // Keep the mini preview in step with the disc. Debounced inside, so a
    // drag produces one snapshot when it settles rather than one per frame.
    ["object:added", "object:removed", "object:modified", "text:changed"].forEach(
      (evt) => canvas.on(evt, updateMiniPreview)
    );
    // Moves/scales reach the canvas without going through
    // handleChangeInCanvas, so the dirty flag needs its own listeners here.
    ["object:added", "object:removed", "object:modified", "text:changed"].forEach(
      (evt) =>
        canvas.on(evt, () => {
          window.DGS_markCanvasDirty();
        })
    );

    initMiniPreview();
    initJumpToCart();

    // Initial check
    updateOverlay();
    // Listen for object movements to update indices end here

    //  Images mobile scale mathod
    // Opt-in on-screen log (add ?dgsdebug=1 to the URL) so pinch can be diagnosed
    // on a real phone where no devtools are available. No-op for real shoppers.
    function dgsPinchLog(msg) {
      if (window.location.search.indexOf("dgsdebug") === -1) return;
      var el = document.getElementById("dgs-pinch-debug");
      if (!el) {
        el = document.createElement("div");
        el.id = "dgs-pinch-debug";
        el.style.cssText =
          "position:fixed;left:4px;bottom:4px;z-index:99999;max-width:92vw;" +
          "background:rgba(0,0,0,.82);color:#0f0;font:11px/1.4 monospace;" +
          "padding:6px 8px;border-radius:6px;white-space:pre-wrap;pointer-events:none";
        document.body.appendChild(el);
      }
      el.textContent = (msg + "\n" + el.textContent).slice(0, 500);
    }
    // Pinch (and wheel) may resize a photo OR a text object. Text was excluded
    // before, which is why two-finger pinch "did nothing" when only text was on
    // the disc.
    function isPinchTarget(obj) {
      return !!(
        obj &&
        (images.includes(obj) ||
          obj.type === "i-text" ||
          obj.type === "text" ||
          obj.type === "textbox")
      );
    }
    canvas.upperCanvasEl.addEventListener(
      "touchstart",
      function (e) {
        touches = Array.from(e.touches);
        dgsPinchLog("touchstart fingers=" + touches.length);
        if (touches.length === 2) {
          // Find what we're pinching. findTarget wants the EVENT (it reads the
          // first touch itself); passing a raw Touch mis-read the pointer. Fall
          // back to whatever is already selected — the usual case (tap it, then
          // pinch).
          let targetObject = canvas.findTarget(e);
          if (!isPinchTarget(targetObject)) {
            const ao = canvas.getActiveObject();
            if (isPinchTarget(ao)) targetObject = ao;
          }
          dgsPinchLog(
            "  target=" + (targetObject ? targetObject.type : "none") +
            " pinchable=" + isPinchTarget(targetObject)
          );

          if (isPinchTarget(targetObject)) {
            e.preventDefault();
            // The first finger already started a Fabric DRAG (mouse:down set up a
            // transform). Left alone it fights the pinch and the object just
            // jitters or ignores the gesture. Cancel it so only our scaling runs.
            canvas._currentTransform = null;
            isScaling = true;
            activeImage = targetObject;
            initialDistance = getDistance(touches[0], touches[1]);
            initialScale = activeImage.scaleX || 1;
            canvas.setActiveObject(activeImage);
            canvas.requestRenderAll();
          }
        }
      },
      { passive: false }
    );

    canvas.upperCanvasEl.addEventListener(
      "touchmove",
      function (e) {
        if (
          e.touches.length === 2 &&
          activeImage &&
          isScaling &&
          initialDistance > 0
        ) {
          e.preventDefault();
          e.stopPropagation();

          const currentDistance = getDistance(e.touches[0], e.touches[1]);
          const ratio = currentDistance / initialDistance;
          const newScale = initialScale * ratio;
          dgsPinchLog("  scaling ratio=" + ratio.toFixed(2));

          // Calculate minimum scale based on image and canvas size
          const minScaleX = 50 / activeImage.width; // Minimum 50px width
          const minScaleY = 50 / activeImage.height; // Minimum 50px height
          // NO third `0.05` term. It read as a floor but acted as a CEILING on
          // how small you could go: for anything wider than 1000px it beat the
          // 50px rule above, so the minimum became 5% of the SOURCE resolution
          // - a 2400px logo stuck at 120px, a 4000px photo at 200px. The
          // higher-resolution the artwork, the larger the minimum, which is
          // backwards and made a collage impossible (owner, 2026-08-27).
          const minScale = Math.max(minScaleX, minScaleY);

          // Calculate maximum scale
          const maxScale = Math.min(
            5,
            2000 / Math.min(activeImage.width, activeImage.height)
          );

          // Apply limits
          const limitedScale = Math.max(minScale, Math.min(maxScale, newScale));

          activeImage.set({
            scaleX: limitedScale,
            scaleY: limitedScale,
          });

          canvas.renderAll();
        }
      },
      { passive: false }
    );

    canvas.upperCanvasEl.addEventListener("touchend", function (e) {
      if (e.touches.length < 2) {
        isScaling = false;
        initialDistance = 0;
        // Re-enable fabric controls
        if (activeImage) {
          canvas.setActiveObject(activeImage);
        }
        activeImage = null;
      }
    });

    // Handle when all touches are lifted
    canvas.upperCanvasEl.addEventListener("touchcancel", function (e) {
      isScaling = false;
      initialDistance = 0;
      if (activeImage) {
        canvas.setActiveObject(activeImage);
      }
      activeImage = null;
    });

    // Helper function to calculate distance between two touches
    function getDistance(touch1, touch2) {
      const dx = touch1.clientX - touch2.clientX;
      const dy = touch1.clientY - touch2.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    // Mouse wheel zoom for desktop
    canvas.on("mouse:wheel", function (opt) {
      const activeObject = canvas.getActiveObject();
      if (isPinchTarget(activeObject)) {
        const delta = opt.e.deltaY;
        let zoom = activeObject.scaleX;
        zoom *= 0.999 ** delta;

        // Calculate minimum scale based on image size
        // same 50px floor as the pinch path above; see the note there for why
        // there is no 0.05 term.
        const minScaleX = 50 / activeObject.width;
        const minScaleY = 50 / activeObject.height;
        const minScale = Math.max(minScaleX, minScaleY);
        const maxScale = Math.min(
          5,
          2000 / Math.min(activeObject.width, activeObject.height)
        );

        // Apply limits
        zoom = Math.max(minScale, Math.min(maxScale, zoom));

        activeObject.set({
          scaleX: zoom,
          scaleY: zoom,
        });
        canvas.renderAll();
        opt.e.preventDefault();
        opt.e.stopPropagation();
      }
    });

    // Selection events
    canvas.on("selection:created", function (e) {
      if (e.selected && e.selected[0] && images.includes(e.selected[0])) {
        initialDistance = 0;
        initialScale = e.selected[0].scaleX;
      }
    });

    canvas.on("selection:updated", function (e) {
      if (e.selected && e.selected[0] && images.includes(e.selected[0])) {
        initialDistance = 0;
        initialScale = e.selected[0].scaleX;
      }

      const prevSelection = e.deselected[0];
      if (prevSelection && prevSelection.type === 'image') {
        bringAllTextToFront();
        canvas.renderAll();
      }
    });

    // Handle object removal
    canvas.on("object:removed", function (e) {
      const removedObject = e.target;
      const index = images.indexOf(removedObject);
      if (index > -1) {
        images.splice(index, 1); // Remove from images array
      }
    });

    // code for mobile responsiveness

    // Add constraint system to prevent objects from going outside canvas
    /* TEXT SAFE ZONE REMOVED 2026-08-28, owner's call.
       There used to be a clamp here holding text inside 94% of the radius, so it
       could never be dragged onto the rim where print warps. It went because it
       guarded the wrong half of the problem: plenty of shoppers upload IMAGES
       with text baked into the outer part, and those were always exempt
       ("filling/bleeding to the edge is wanted"), so the rule only ever
       inconvenienced people typing text while doing nothing about the actual
       rim-print risk. Rim safety is being addressed separately, across both.

       It was also fighting the centring work: the corner-pull positioned by
       BOUNDING BOX, which for text is not where the glyphs are, so it could pull
       optically-centred text back off centre - and it ran inside the scaling
       handler as well as on modify.

       Text is now treated exactly like images: free to go anywhere, including
       off the disc. */

    /* capCurvedTextScale REMOVED 2026-08-28, same call as the safe zone. It
       capped curved text so its box could never exceed the canvas, which is why
       a 2.6x drag came out as 2.2x - the last text-only size limit, and the
       "interferes when text is larger" the owner was feeling. Images never had
       an equivalent, so this was the same asymmetry as the safe zone.

       What still applies to EVERYTHING, text and photos alike, is the shared
       0.1x-6x clamp in the object:scaling handler below. Curved text scaled past
       the disc now simply clips against it, exactly as an oversized photo does,
       and applyCurveToText still shrinks-to-fit at the moment a curve is
       applied (its maxRadius branch). */

    // Double-tap / double-click is the ONLY way into text editing now — it flips
    // the per-object allow flag and enters editing (single taps just move it).
    canvas.on("mouse:dblclick", function (opt) {
      const t = opt.target;
      if (t && (t.type === "i-text" || t.type === "textbox")) {
        t.__dgsAllowEdit = true;
        t.enterEditing(opt.e);
        if (t.hiddenTextarea) t.hiddenTextarea.focus();
        canvas.requestRenderAll();
      }
    });
    /* The handler above rides the native DOM `dblclick` event - and on touch,
       that event is a browser courtesy, not a guarantee. Fabric binds
       touchstart with preventDefault() (enablePointerEvents is off in this
       build), which by spec suppresses the synthesized mouse events for that
       touch. Chrome still delivers click/dblclick because it derives them from
       the pointer-event stream, which is why double-tap works on Android; iOS
       Safari suppresses them, which silently locked iPhone shoppers (and the
       Etsy portal) out of text editing when editing became dblclick-only.

       So detect the double-TAP ourselves on Fabric's own mouse:up pipeline -
       the same internal touch processing that makes single taps select on
       every device - and re-emit it as mouse:dblclick so the handler above
       (text -> edit) and the reskin's (photo -> raise) both hear it. TOUCH
       EVENTS ONLY: on desktop the native dblclick still arrives and firing a
       second one would double-handle. 320ms matches the reskin's own
       tap-vs-double-tap boundary; the 8px gate keeps drags out. The
       hiddenTextarea.focus() then runs inside the touchend dispatch, which is
       the user-activation context iOS requires to raise the keyboard. */
    let dgsLastTap = { at: 0, target: null, x: 0, y: 0 };
    canvas.on("mouse:up", function (opt) {
      const e = opt.e;
      if (!e || typeof e.type !== "string" || e.type.indexOf("touch") !== 0) return;
      const t = opt.target;
      const now = Date.now();
      let p;
      try { p = canvas.getPointer(e); } catch (err) { return; }
      const prev = dgsLastTap;
      dgsLastTap = { at: now, target: t, x: p.x, y: p.y };
      if (!t || t.isEditing) return;
      if (prev.target !== t) return;
      if (now - prev.at > 320) return;
      if (Math.hypot(p.x - prev.x, p.y - prev.y) > 8) return;
      dgsLastTap = { at: 0, target: null, x: 0, y: 0 };   /* consume the pair */
      canvas.fire("mouse:dblclick", { target: t, e: e });
    });
    // Keep the GLYPHS put across a resize - see beginInkAnchor. Registered here
    // rather than beside its helpers because `canvas` does not exist yet at that
    // point in the file.
    canvas.on("object:scaling", function (e) {
      beginInkAnchor(e.target);
    });
    // Catches text the curve buttons never touched - notably a design restored
    // from saved JSON, which rebuilds its path directly and so never passes
    // through applyCurveToText.
    ["selection:created", "selection:updated"].forEach(function (ev) {
      canvas.on(ev, function () {
        const active = canvas.getActiveObject();
        if (active) fitHitPaddingToInk(active);
      });
    });
    canvas.on("object:modified", function (e) {
      settleInkAnchor(e && e.target);
    });

    // Prevent objects from being scaled too large
    canvas.on("object:scaling", function (e) {
      const obj = e.target;
      const maxScale = 6.0; // was 2.0 — allow ~3x larger text (owner request)
      const minScale = 0.1;

      if (obj.scaleX > maxScale) obj.scaleX = maxScale;
      if (obj.scaleX < minScale) obj.scaleX = minScale;
      if (obj.scaleY > maxScale) obj.scaleY = maxScale;
      if (obj.scaleY < minScale) obj.scaleY = minScale;
    });

    // Detect focus events on text inputs to prevent resize
    canvas.on("text:editing:entered", (e) => {
      isKeyboardOpen = true;
      // Same reason as the font change: note the glyph position while the arc
      // still matches the words, before any typing invalidates it.
      const t = e && e.target;
      if (t && isTextLike(t)) t.__dgsEditInk = measureObjectInk(t, canvas.width);
    });

    canvas.on("text:editing:exited", (e) => {
      // Editing changed the words, so the arc cut for the old ones no longer
      // fits. Re-cut on EXIT rather than per keystroke: rebuilding the path
      // under a live caret is what makes glyphs jump mid-word.
      const t = e && e.target;
      if (t) {
        const inkBefore = t.__dgsEditInk;
        delete t.__dgsEditInk;
        recurveKeepingInk(t, inkBefore);
      }
      // Delay reset to allow keyboard to close
      setTimeout(() => {
        isKeyboardOpen = false;
        
      }, 300);
    });
    // Monitor orientation changes (which should trigger resize)
    window.addEventListener("orientationchange", () => {
      // Force resize after orientation change (with delay for animation)
      setTimeout(() => {
        isKeyboardOpen = false; // Reset keyboard state
        lastViewportHeight = window.innerHeight;
        resizeCanvas();
      }, 500);
    });
  };

  
  /**
   * Placeholder lifecycle.
   *
   * Two properties of Fabric drive the whole design here:
   *   - canvas.add()/remove() fire object:added/object:removed SYNCHRONOUSLY,
   *     and both are wired to syncPlaceholder() - so any add or remove we do
   *     here re-enters this code before it has finished.
   *   - canvas.clear() fires NOTHING, so `imagePlaceholder` can outlive the
   *     object it points at.
   *
   * An earlier attempt tracked state in `imagePlaceholder` and nulled it when
   * it went stale. That nulling happened DURING the nested object:removed
   * fired by createPlaceholders' own cleanup, which unblocked the "create one"
   * branch and produced a second placeholder - orphaned, since only the
   * tracked reference was ever removed again. resizeCanvas() calls
   * createPlaceholders() unconditionally and a phone fires resize on every
   * address-bar movement, so orphans piled up and rendered over the shopper's
   * photo.
   *
   * So: one guarded function, decisions made from the canvas rather than from
   * a variable, and every flagged object cleaned up rather than just one.
   * `imagePlaceholder` is now only a convenience handle, never the source of
   * truth.
   */
  let placeholderSyncing = false;

  function placeholderObjects() {
    return canvas.getObjects().filter((obj) => obj.isImagePlaceholder === true);
  }

  function buildPlaceholder() {
    return new fabric.Group(
      [
        new fabric.Text("📷", {
          fontSize: 48,
          fill: "#999999",
          originX: "center",
          originY: "center",
          top: -10,
        }),
        new fabric.Text("Click to Add Image", {
          fontSize: 16,
          fill: "#999999",
          originX: "center",
          originY: "center",
          top: 50,
        }),
      ],
      {
        left: canvas.width / 2,
        top: canvas.height / 2,
        originX: "center",
        originY: "center",
        selectable: false,
        hoverCursor: "pointer",
        opacity: 0.5,
        isImagePlaceholder: true,
      }
    );
  }

  const checkUserObjects = () => {
    // Identify the placeholder by its flag rather than by object identity, so
    // a leftover placeholder group can never be mistaken for real artwork.
    // updateOverlay() relies on this too.
    return canvas.getObjects().some((obj) => obj.isImagePlaceholder !== true);
  };

  /** The shopper's artwork, ignoring the "Click to Add Image" prompt. */
  function userObjects() {
    return canvas.getObjects().filter((obj) => obj.isImagePlaceholder !== true);
  }

  /**
   * Keeps the control-panel headings honest about what is already on the disc.
   *
   * On a phone the canvas has scrolled out of sight by the time the shopper
   * reaches these controls, so a static "Add Your Image / Choose an Image..."
   * reads as though their photo never landed - reported from a real phone.
   * Naming the current state removes the doubt without moving anything.
   *
   * Copy only: the file input, its id and the upload handler are untouched.
   */
  function updateSectionSummaries() {
    const heading = document.getElementById("dgs-image-heading");
    const label = document.getElementById("dgs-image-label");
    if (!heading && !label) return;

    const imageCount = userObjects().filter((obj) => obj.type === "image").length;

    if (heading) {
      heading.textContent =
        imageCount === 0
          ? "Add Your Image"
          : imageCount === 1
          ? "Your Image"
          : `Your Images (${imageCount})`;
    }
    if (label) {
      // The tool stacks images rather than swapping them, so "another" is
      // accurate where "replace" would not be.
      label.textContent =
        imageCount === 0 ? "Choose an Image..." : "Add Another Image...";
    }
  }

  /**
   * Mini disc preview, and the jump-to-cart button. Both phone-only; their CSS
   * keeps them display:none above 767px, so this code is inert on desktop.
   */
  let miniPreviewTimer = null;

  function updateMiniPreview() {
    const img = document.getElementById("dgs-mini-preview-img");
    if (!img || !canvas) return;
    // Debounced: toDataURL is the expensive part and canvas changes can arrive
    // in bursts while dragging.
    clearTimeout(miniPreviewTimer);
    miniPreviewTimer = setTimeout(() => {
      // A canvas with no size returns the empty data URL "data:," which renders
      // as a broken image. The canvas is 0x0 until the modal has been opened
      // and sized, so skip rather than publishing a broken thumbnail.
      if (!canvas.width || !canvas.height) return;
      try {
        // Small multiplier - this is a 44px thumbnail, not artwork.
        const url = canvas.toDataURL({ format: "png", multiplier: 0.25 });
        if (url && url.length > 32) img.src = url;
      } catch (e) {
        /* tainted canvas or similar - the preview is cosmetic, so ignore */
      }
    }, 250);
  }

  /**
   * Reveals the mini preview once the disc has scrolled out of view.
   *
   * Uses a throttled scroll listener rather than IntersectionObserver. IO is
   * the more natural fit on paper, but it delivered NO callback at all here -
   * threshold 0, 2.5s, element on screen with a non-zero box - so the bar
   * simply never appeared. Comparing rects on scroll is dull, cheap and
   * always fires, which matters more than elegance for something whose whole
   * job is to show up at the right moment.
   */
  function initMiniPreview() {
    const bar = document.getElementById("dgs-mini-preview");
    const target = document.getElementById("canvas-wrapper");
    if (!bar || !target) return;
    const scroller = target.closest(".create-disc-wrapper");
    if (!scroller) return;

    // Tapping it returns to the disc.
    bar.addEventListener("click", function (e) {
      e.preventDefault();
      if (scroller.scrollHeight > scroller.clientHeight + 4) {
        scroller.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });

    /* Hysteresis, in px, for the reveal threshold below.

       A single threshold oscillated on iOS: revealing the bar nudged the
       layout, the nudge pushed the disc back across that one threshold, the
       bar hid, and round it went - the panel visibly bouncing with no finger
       on the screen (owner video, 2026-08-22). The CSS now makes the bar
       occupy zero flow height so it cannot nudge anything, and these two
       separate thresholds mean even a stray pixel of movement cannot flip the
       state back: once shown, the disc has to come a clear 100px back onto
       the screen before the bar goes away again. */
    const SHOW_AT = 40; // disc bottom this far above the viewport top -> show
    const HIDE_AT = 140; // ...and this far back down again -> hide

    let ticking = false;
    function sync() {
      ticking = false;
      // Only meaningful while the modal is actually scrollable, i.e. phones.
      const scrolls = scroller.scrollHeight > scroller.clientHeight + 4;
      const t = target.getBoundingClientRect();
      const s = scroller.getBoundingClientRect();
      const showing = bar.classList.contains("is-visible");
      // Gone = the disc has passed above the top of the scroll viewport.
      const gone =
        scrolls && t.bottom < s.top + (showing ? HIDE_AT : SHOW_AT);
      if (gone === showing) return;
      bar.classList.toggle("is-visible", gone);
      if (gone) updateMiniPreview();
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    }

    scroller.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    /* Belt and braces. Within one session on the dev theme, BOTH
       IntersectionObserver and scroll events failed to fire on this container
       while scrollTop was demonstrably changing. Neither is exotic, and both
       work on real phones - but this bar exists to reassure someone who has
       lost sight of their design, so it must not be the thing that silently
       stops working in some webview. A rect comparison twice a second, and
       only while the modal is open, costs nothing measurable. */
    setInterval(function () {
      if (!document.body.classList.contains("dgs-modal-open")) return;
      sync();
    }, 500);

    sync();
  }

  /**
   * Smooth-scrolls to the quantity + Add to Cart bar.
   *
   * Measured from bounding rects rather than offsetTop, because the buy bar's
   * offsetParent is not the scroll container.
   */
  function initJumpToCart() {
    const btn = document.getElementById("dgs-jump-to-cart");
    if (!btn) return;
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      const cart = document.querySelector(
        ".create-disc-wrapper .modal-cart-wrapper"
      );
      if (!cart) return;
      const scroller = cart.closest(".create-disc-wrapper");
      if (scroller && scroller.scrollHeight > scroller.clientHeight + 4) {
        const delta =
          cart.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
        tweenScroll(scroller, scroller.scrollTop + delta - 12);
      } else {
        cart.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });
  }

  /**
   * Deliberately unhurried scroll to a position in a container.
   *
   * Not scrollTo({behavior:'smooth'}): its duration is fixed by the browser and
   * is quick enough that the sections in between are a blur. The point of
   * scrolling rather than jumping is that the shopper registers Add Text,
   * Canvas Color and Create with AI going past and can stop at one, so the
   * pace is the feature. It also ran on the same frame machinery as
   * requestAnimationFrame, which did not tick at all in the browser this was
   * tested in - the call simply returned without moving.
   *
   * Timer-driven for that reason, with an easeInOut curve so it starts and
   * finishes gently instead of lurching.
   */
  function tweenScroll(el, to, duration) {
    duration = duration || 1200;
    const from = el.scrollTop;
    const distance = to - from;
    if (Math.abs(distance) < 2) return;

    const started = Date.now();
    clearInterval(el._dgsScrollTimer);
    el._dgsScrollTimer = setInterval(function () {
      const t = Math.min(1, (Date.now() - started) / duration);
      // easeInOutQuad
      const eased = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      el.scrollTop = from + distance * eased;
      if (t >= 1) {
        clearInterval(el._dgsScrollTimer);
        el._dgsScrollTimer = null;
      }
    }, 16);

    // A touch during the animation should win over it.
    ["touchstart", "wheel"].forEach(function (evt) {
      el.addEventListener(
        evt,
        function stop() {
          clearInterval(el._dgsScrollTimer);
          el.removeEventListener(evt, stop);
        },
        { passive: true, once: true }
      );
    });
  }

  /**
   * Re-selects the only object on the disc after a deselect.
   *
   * Every Object Control reads canvas.getActiveObject(), so losing the
   * selection disables all of them - and on a phone it is very easy to tap the
   * background by accident. With one object there is nothing else the controls
   * could mean, so the selection is restored rather than left empty.
   *
   * Deliberately does nothing with two or more objects: silently re-selecting
   * one of several would be guessing at intent.
   */
  function reselectSoleObject() {
    if (isImporting) return false;
    const objs = userObjects();
    if (objs.length !== 1) return false;
    const only = objs[0];
    if (only.selectable === false) return false;
    if (canvas.getActiveObject() === only) return false;
    canvas.setActiveObject(only);
    canvas.renderAll();
    return true;
  }

  /**
   * Brings the canvas to exactly one placeholder, or none. Safe to call from
   * anywhere, including from the object:added/object:removed handlers it
   * triggers itself - the guard makes those re-entries no-ops.
   */
  function updatePlaceholders() {
    if (placeholderSyncing) return;
    placeholderSyncing = true;
    try {
      const bgColor = canvas.backgroundColor;
      const isWhiteBg =
        !bgColor ||
        bgColor === "white" ||
        bgColor === "#ffffff" ||
        bgColor === "rgb(255,255,255)";
      const wanted = !checkUserObjects() && isWhiteBg;
      const existing = placeholderObjects();

      if (!wanted) {
        // Remove EVERY placeholder, not just the tracked one.
        existing.forEach((obj) => canvas.remove(obj));
        imagePlaceholder = null;
      } else if (existing.length === 0) {
        imagePlaceholder = buildPlaceholder();
        canvas.add(imagePlaceholder);
      } else {
        // Adopt the survivor and clear up any duplicates.
        imagePlaceholder = existing[0];
        existing.slice(1).forEach((obj) => canvas.remove(obj));
      }

      // Always snap the placeholder to the CURRENT canvas centre. buildPlaceholder
      // captures canvas.width once, and a placeholder built or adopted while the
      // canvas was mid-resize could otherwise sit off in a corner - which is what
      // left "Click to Add Image" stranded top-left after Clear Canvas. Reading
      // the live centre here makes the position self-correcting.
      if (imagePlaceholder) {
        imagePlaceholder.set({
          left: canvas.width / 2,
          top: canvas.height / 2,
          originX: "center",
          originY: "center",
        });
        imagePlaceholder.setCoords();
      }
      canvas.renderAll();
    } finally {
      placeholderSyncing = false;
    }
  }

  /**
   * Re-establishes the canvas dimensions, retina transform and clip path.
   *
   * The bug this exists for: after repeated resizes fabric's retina scaling can
   * desync from the backing store - the element ends up e.g. 600x600 while
   * fabric renders in a 300x300 logical space WITHOUT the 2x context transform.
   * canvas.clear() and the white background then only paint the top-left of the
   * backing, so a centred photo survives in the rest - the "ghost after Clear
   * Canvas" reported from a phone, plus off-centre placeholders and uploads.
   *
   * The fix is to let fabric OWN the sizing. setDimensions re-runs fabric's
   * retina init, which re-applies the context transform correctly - manually
   * assigning canvasEl.width (as the older code and resizeCanvas do) resets that
   * transform to identity and relies on fabric re-applying it, which is exactly
   * what was failing. Guard-free except for a zero-width wrapper (modal
   * mid-transition), which it leaves untouched rather than collapsing to zero.
   */
  /**
   * Clears the raw pixels of both fabric layers (lower = content, upper =
   * selection) to bare transparency, resetting each context transform to
   * identity first so the ENTIRE backing is reached - a clearRect left under a
   * retina transform only covers a fraction of it. Used by the clear path as a
   * last-resort guarantee no stale image survives; fabric then repaints.
   */
  function wipeCanvasLayers() {
    const els = [
      canvas.lowerCanvasEl || canvasEl,
      canvas.upperCanvasEl,
    ];
    els.forEach((el) => {
      if (!el || !el.getContext) return;
      try {
        const c = el.getContext("2d");
        c.save();
        c.setTransform(1, 0, 0, 1, 0, 0);
        c.clearRect(0, 0, el.width, el.height);
        c.restore();
      } catch (e) {
        /* cosmetic - never let it throw */
      }
    });
  }

  function resyncCanvasSize() {
    if (!canvasEl || !wrapper || typeof canvas.setDimensions !== "function") return;
    const isMobile = window.innerWidth <= 768;
    const padding = isMobile ? 10 : 0;
    let w = wrapper.offsetWidth;
    if (w > padding * 2) w = w - padding * 2;
    const size = Math.min(w, (window.DGS_CANVAS_MAX >= 300 && window.DGS_CANVAS_MAX <= 900 ? window.DGS_CANVAS_MAX : 500));
    if (!size) return;

    // Bounce through a 1px size first. When the target size equals the current
    // one, setDimensions skips reassigning the backing store - so it never
    // clears - which is why the ghost survived on some Clear Canvas presses but
    // not others (it alternated). Forcing the backing to actually change
    // guarantees a real reset of both the pixels and the retina transform.
    canvas.setDimensions({ width: 1, height: 1 });
    canvas.setDimensions({ width: size, height: size });

    const clipPath = canvas.clipPath;
    if (clipPath) {
      clipPath.set({ radius: size / 2, left: size / 2, top: size / 2 });
    }
    if (typeof canvas.calcOffset === "function") canvas.calcOffset();
    canvas.renderAll();
  }

  /**
   * Called after the canvas is resized, where the placeholder has to be
   * rebuilt against the new dimensions. Drops what is there and lets
   * updatePlaceholders decide whether one is wanted at all - on a canvas that
   * already holds artwork, the answer is no.
   */
  function createPlaceholders() {
    if (placeholderSyncing) return;
    placeholderSyncing = true;
    try {
      placeholderObjects().forEach((obj) => canvas.remove(obj));
      imagePlaceholder = null;
    } finally {
      placeholderSyncing = false;
    }
    updatePlaceholders();
  }

  

  // --- UI Control Elements ---
  const objectControls = document.getElementById("object-controls");
  const noObjectSelected = document.getElementById("no-object-selected");
  const textEffectsControls = document.getElementById("text-effects-controls");
  const aiLoadingIndicator = document.getElementById("ai-loading-indicator");
  const aiErrorMsg = document.getElementById("ai-error-msg");
  const generateAiImageBtn = document.getElementById("generate-ai-image-btn");

  const lockUnlockBtn = document.getElementById("lock-unlock-btn");
  const lockBtnText = document.getElementById("lock-btn-text");

  const updateControls = () => {
    const activeObject = canvas.getActiveObject();
    const fontSelect = document.getElementById("font-family");
    if (activeObject) {
      // objectControls.classList.remove("hidden");
      // Dimming is applied to the cards inside, not to this container - see the
      // .dgs-oc-inert rule in create-disc-design.liquid. A parent's opacity
      // cannot be undone by a child, and the Review & Add to Cart button lives
      // in here now; a checkout button must never look half-disabled.
      objectControls.classList.remove("dgs-oc-inert", "cursor-not-allowed");
      noObjectSelected.classList.add("hidden");

      if (activeObject.type === "i-text" || activeObject.type === "textbox") {
        // textEffectsControls.classList.remove("hidden");
        textEffectsControls.classList.remove(
          "opacity-50",
          "cursor-not-allowed"
        );
        // Update font dropdown
        if (fontSelect) {
          const fontFamily =
            activeObject.fontFamily ||
            activeObject.metadata?.textInfo?.fontFamily;
          if (fontFamily) {
            fontSelect.value = fontFamily;
            fontSelect.style.fontFamily = fontFamily;
          }
        }
      } else {
        // textEffectsControls.classList.add("hidden");
        textEffectsControls.classList.add("opacity-50", "cursor-not-allowed");
      }
      // Update button states of image
      updateIamgeActionButtonStates();

      // Update lock button based on object state
      if (activeObject.locked) {
        if (lockBtnText) {
          lockBtnText.textContent = "🔒 Unlock Object";
          lockUnlockBtn.classList.remove(
            "bg-yellow-500",
            "hover:bg-yellow-600"
          );
          lockUnlockBtn.classList.add("bg-green-500", "hover:bg-green-600");
        }
      } else {
        if (lockBtnText) {
          lockBtnText.textContent = "🔓 Lock Object";
          lockUnlockBtn.classList.remove("bg-green-500", "hover:bg-green-600");
          lockUnlockBtn.classList.add("bg-yellow-500", "hover:bg-yellow-600");
        }
      }
    } else {
      // objectControls.classList.add("hidden");
      objectControls.classList.add("dgs-oc-inert", "cursor-not-allowed");
      // textEffectsControls.classList.add("hidden");
      textEffectsControls.classList.add("opacity-50", "cursor-not-allowed");
      noObjectSelected.classList.remove("hidden");
      // Re-disable Fill / Fit when nothing is selected. This branch used to skip
      // it, so after selecting a photo then deselecting, both stayed enabled but
      // did nothing on tap — the "Fill the disc" dead clicks.
      updateIamgeActionButtonStates();
    }
  };

  // --- Background Color Palette Logic ---
  const bgColorPalette = document.getElementById("bg-color-palette");
  bgColorPalette.addEventListener("click", (e) => {
    if (e.target.tagName === "BUTTON") {
      bgColorPalette.querySelector(".selected")?.classList.remove("selected");
      e.target.classList.add("selected");
      const newBgColor = e.target.dataset.color;
      canvas.setBackgroundColor(newBgColor, canvas.renderAll.bind(canvas));
      handleChangeInCanvas();
    }
  });

  async function ensureFontLoaded(fontFamily) {
    const testFont = `16px "${fontFamily}"`;
    try {
      await document.fonts.load(testFont);
      await document.fonts.ready;
      // console.log(`✅ Font loaded: ${fontFamily}`);
    } catch (err) {
      console.warn(`⚠️ Font failed to load: ${fontFamily}`, err);
    }
  }

  // --- Text Color Palette Logic ---
  const textColorPalette = document.getElementById("text-color-palette");
  textColorPalette.addEventListener("click", (e) => {
    if (e.target.tagName === "BUTTON") {
      textColorPalette.querySelector(".selected")?.classList.remove("selected");
      e.target.classList.add("selected");
      activeTextColor = e.target.dataset.color;
      const activeObject = canvas.getActiveObject();
      // if (activeObject && activeObject.set) {
      if (activeObject && activeObject.type === "i-text") {
        activeObject.set("fill", activeTextColor);
        canvas.renderAll();
      }
    }
  });

  // --- Font Family Logic ---
  const fontFamilySelect = document.getElementById("font-family");
  fontFamilySelect.addEventListener("change", (e) => {
    (async () => {
      let fontFamily = e.target.value;
      // Set initial font
      fontFamilySelect.style.fontFamily = fontFamily;
      const activeObject = canvas.getActiveObject();
      if (activeObject && activeObject.type === "i-text") {
        await ensureFontLoaded(fontFamily);
        // Note where the glyphs are while the path still matches the text, then
        // change the font, then re-cut the arc for the new width and put the
        // glyphs back. Order matters - see recurveKeepingInk.
        const inkBefore = measureObjectInk(activeObject, canvas.width);
        activeObject.set("fontFamily", fontFamily);
        recurveKeepingInk(activeObject, inkBefore);
        canvas.renderAll();
      }
    })();
  });

  

  // --- Curved Text Management ---
  // Fixed storeCurvedTextState function
  const storeCurvedTextState = (textObj) => {
    if (textObj.type === "i-text" && textObj.path) {
      const curveDirection = getTextCurveDirection(textObj);

      curvedTextStates.set(textObj, {
        curveDirection: curveDirection, // This will be "up", "down", or "straight"
        originalLeft: textObj.left,
        originalTop: textObj.top,
      });
    }
  };
  const straightenCurvedText = (textObj) => {
    if (textObj.type === "i-text" && textObj.path) {
      storeCurvedTextState(textObj);
      /* Remember where the GLYPHS sit, as a fraction of the canvas, so the
         re-curve on the other side of the resize can put them back.

         The resize flow is straighten -> scale everything -> re-curve, and that
         changes the bounding box twice while left/top tracks the box CENTRE. So
         without this, a resize round trip walked the text down the disc:
         measured 0.3% of the diameter off centre before a 360 -> 288 -> 360
         trip and 4% after it, compounding on every rotation or keyboard open.

         Captured here rather than in storeCurvedTextState because this runs
         while canvas.width is still the OLD size (setWidth comes later in the
         same flow), which is exactly the denominator the fraction needs. */
      const ink = measureObjectInk(textObj, canvas.width);
      const state = curvedTextStates.get(textObj);
      if (ink && state) {
        state.inkFracX = ink.centerX / canvas.width;
        state.inkFracY = ink.centerY / canvas.width;
      }
      textObj.set({ path: null });
      console.log("Straightened text:", textObj.text);
    }
  };

  const restoreCurvedText = (textObj, newCanvasSize) => {
    if (textObj.type === "i-text" && curvedTextStates.has(textObj)) {
      const state = curvedTextStates.get(textObj);
      console.log(
        "Restoring curve:",
        state.curveDirection,
        "for text:",
        textObj.text
      );

      if (state.curveDirection !== "straight" && !state.wasRestored) {
        /* This runs on CANVAS RESIZE, not on loading a saved design: the resize
           flow straightens every curved text, scales everything, then re-curves
           here. Loading a saved design is a different path entirely - it
           rebuilds the path from the SAVED path data (see the
           storedMetadata.originalPath branch), never through applyCurveToText -
           so the tight arc leaves already-saved designs rendering exactly as
           they were saved.

           What DOES need compensating is the box changing shape twice across
           the straighten/scale/re-curve trip - see straightenCurvedText for the
           measured drift. Put the glyphs back on the fraction of the canvas
           they occupied before it. */
        applyCurveToText(textObj, state.curveDirection, newCanvasSize);

        if (state.inkFracX != null) {
          const size = canvas.width; // already the NEW size by now
          const ink = measureObjectInk(textObj, size);
          if (ink) {
            textObj.left += clampInkNudge(
              state.inkFracX * size - ink.centerX,
              size
            );
            textObj.top += clampInkNudge(
              state.inkFracY * size - ink.centerY,
              size
            );
            textObj.setCoords();
          }
        }
        state.wasRestored = true;
      }
    }
  };
  /* ---- optical centring for text -----------------------------------------
     Fabric positions objects by their bounding box, which for text is the FONT
     METRIC box, not the glyphs. Two consequences, both measured on a 360-unit
     canvas with one line at fontSize 50:

       straight text  box 58 tall, ink 48.5  -> ink sits 2.3 BELOW box centre
       curved text    box 109 tall, ink 59.5 -> ink sits 23.8 BELOW box centre

     Setting a `path` on an IText nearly doubles the reported height and adds
     essentially all of the extra box ABOVE the glyphs, so text that is centred
     by the book lands a quarter of a radius low. That is the owner's report:
     "centered vertically but g is much closer to edge". Their guess was the
     descender; the descender is the 2.3, the curve is the 23.8.

     Rather than model the arc, MEASURE the ink - render the object alone to a
     scratch canvas and scan the alpha channel. Two facts make that safe, both
     verified on the sandbox before this was written: `top` stays authoritative
     once a path is set (top += 30 moved the glyphs exactly 30), and the
     ink-to-box drift is constant for a given object, so one measured
     correction holds rather than needing to be re-applied.

     Object.render() uses the object's absolute transform and the canvas
     viewport is identity here, so a same-size scratch context reproduces
     canvas coordinates exactly (checked: 203.0 vs 203.8, the difference being
     the real canvas being scanned at 2x device resolution). */
  let inkScratchCanvas = null;

  /* Measures over a region that COVERS THE WHOLE OBJECT, not just the disc.
     This started out scanning a scratch canvas of exactly canvas.width, which
     was fine while text was capped to the disc. Removing the text size caps
     broke that assumption: text may now hang well outside the canvas, the scan
     saw only the part that fell inside it, and the "centre" of that clipped
     fragment is not the centre of the text. Toggling curve up/down on large text
     then nudged it by a wrong delta every press - the owner's "seems to mess up
     text and cause it to reflect or move in odd ways".

     So derive the region from the object's own bounding rect (padded, because
     for path-text the ink reaches outside the box) unioned with the canvas, and
     downscale it to keep the pixel count bounded. Returns canvas coordinates
     either way. */
  const INK_MAX_SIDE = 640;

  function measureObjectInk(obj, size) {
    try {
      const br = obj.getBoundingRect(true, true);
      const pad = Math.max(br.width, br.height) * 0.75 + 8;
      const x0 = Math.floor(Math.min(0, br.left - pad));
      const y0 = Math.floor(Math.min(0, br.top - pad));
      const x1 = Math.ceil(Math.max(size, br.left + br.width + pad));
      const y1 = Math.ceil(Math.max(size, br.top + br.height + pad));
      const regionW = x1 - x0;
      const regionH = y1 - y0;
      if (regionW <= 0 || regionH <= 0) return null;

      // One scan is never allowed to get expensive; sub-pixel precision is
      // irrelevant for centring.
      const scale = Math.min(1, INK_MAX_SIDE / Math.max(regionW, regionH));
      const w = Math.max(1, Math.ceil(regionW * scale));
      const h = Math.max(1, Math.ceil(regionH * scale));

      if (!inkScratchCanvas) inkScratchCanvas = document.createElement("canvas");
      if (inkScratchCanvas.width !== w || inkScratchCanvas.height !== h) {
        inkScratchCanvas.width = w;
        inkScratchCanvas.height = h;
      }
      const ctx = inkScratchCanvas.getContext("2d", {
        willReadFrequently: true,
      });
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, w, h);
      // Region -> scratch: shift the region's origin to 0,0 then downscale.
      ctx.setTransform(scale, 0, 0, scale, -x0 * scale, -y0 * scale);
      obj.render(ctx);
      ctx.setTransform(1, 0, 0, 1, 0, 0);

      const data = ctx.getImageData(0, 0, w, h).data;
      let minX = w,
        maxX = -1,
        minY = h,
        maxY = -1;
      for (let y = 0; y < h; y++) {
        const row = y * w * 4;
        for (let x = 0; x < w; x++) {
          // alpha > 12 of 255: ignore antialiasing crumbs, keep thin strokes
          if (data[row + x * 4 + 3] > 12) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      // Nothing drawn: whitespace-only text, or a colour that renders invisible.
      if (maxY < 0) return null;
      return {
        centerX: ((minX + maxX) / 2) / scale + x0,
        centerY: ((minY + maxY) / 2) / scale + y0,
        left: minX / scale + x0,
        top: minY / scale + y0,
        right: maxX / scale + x0,
        bottom: maxY / scale + y0,
      };
    } catch (err) {
      // Any Fabric-internal surprise degrades to plain bounding-box behaviour,
      // which is what shipped before this. Never lose the button over it.
      console.warn("DGS: ink measure failed, using bounding box", err);
      return null;
    }
  }

  function isTextLike(obj) {
    return (
      !!obj &&
      (obj.type === "i-text" || obj.type === "text" || obj.type === "textbox")
    );
  }

  // Every correction is capped. A pathological measurement - a glyph that
  // renders almost entirely off the disc, say - should nudge the text, never
  // fling it off the canvas.
  function clampInkNudge(delta, size) {
    const cap = size * 0.25;
    return Math.max(-cap, Math.min(cap, delta));
  }

  /* Curving changes the metric box far more than it changes the glyphs, so
     applying a curve visibly drops the text ~24 units even though nothing
     asked it to move. Anchor on the ink instead: note where the glyphs are,
     curve, then put the glyphs back.

     ONLY the explicit curve buttons route through here. restoreCurvedText()
     above deliberately still calls applyCurveToText() raw - a reloaded design
     must land exactly where it was saved, or it would stop matching the print
     file that was already produced from it. */
  function curveTextKeepingInkInPlace(textObj, direction) {
    const size = canvas.width;
    const before = isTextLike(textObj)
      ? measureObjectInk(textObj, size)
      : null;

    applyCurveToText(textObj, direction);

    if (!before) return;
    const after = measureObjectInk(textObj, size);
    if (!after) return;

    textObj.left += clampInkNudge(before.centerX - after.centerX, size);
    textObj.top += clampInkNudge(before.centerY - after.centerY, size);
    textObj.setCoords();
    fitHitPaddingToInk(textObj);
  }

  /* NO pathStartOffset CORRECTION. There was one here briefly, nudging the text
     along the arc to even up the selection frame's slack (Fabric leaves most of
     it on one side). It measured beautifully - frame asymmetry exactly 0 - and it
     was WRONG: a negative offset puts the first glyph before the path start, and
     Fabric wraps that glyph round to the far END of the arc. The owner saw
     "Testing" render as "estingT" with the T mirrored in the top corner. The
     guard it shipped with watched the ink HEIGHT for signs of glyphs falling off
     the path, and a single wrapped capital barely changes the height, so it
     sailed through.

     The frame therefore keeps slightly more slack on its left than its right.
     That is cosmetic - the LETTERS are centred on the disc to within a unit,
     which is what prints - and it is a much better trade than glyphs that can
     teleport. pathStartOffset is now pinned to 0 in applyCurveToText so no
     leftover value from an earlier session or a saved design can reintroduce it. */

  /* The arc is sized from the text's width, so anything that changes that width
     invalidates it. Changing the FONT did exactly that and nothing rebuilt the
     path: the letters then ran past the end of an arc cut for the old font and
     wrapped round it - the owner's "when fonts are switched the text is
     reflecting and curve is being completely ruined". Editing the words does the
     same.

     `inkBefore` must be measured BEFORE the metrics change. Measuring after is
     what left two of the six fonts 7.5 units right of centre: by then the glyphs
     are already sitting on a path that no longer fits them, so the "current"
     centre being preserved is a wrapped one. */
  function recurveKeepingInk(obj, inkBefore) {
    if (!obj || !isTextLike(obj)) return;
    const size = canvas.width;

    if (obj.path) {
      const direction = getTextCurveDirection(obj);
      if (direction !== "straight") applyCurveToText(obj, direction);
    }

    if (inkBefore) {
      const after = measureObjectInk(obj, size);
      if (after) {
        obj.left += clampInkNudge(inkBefore.centerX - after.centerX, size);
        obj.top += clampInkNudge(inkBefore.centerY - after.centerY, size);
        obj.setCoords();
      }
    }
    fitHitPaddingToInk(obj);
    canvas.requestRenderAll();
  }

  /* THE GRAB AREA HAS TO COVER THE LETTERS.
     Fabric hit-tests text against its bounding box (perPixelTargetFind is off
     for text objects here), and for curved text that box is the ARC's box - far
     thinner than the letters standing on it. Measured at scale 3 before
     pathAlign was fixed: the glyphs overflowed the box by 51.7 units above it,
     so most of the visible word was outside its own target and a finger landing
     on a letter grabbed nothing. Owner: "hard to grab and move... maybe allowing
     small padding above centre where a finger naturally lands".

     pathAlign:"center" makes that overflow symmetric, and this closes the rest.
     Fabric's `padding` expands lineCoords, which is exactly what containsPoint
     uses - verified: padding 10 took the hit box from 53.4 to 73.4 tall. It is
     in canvas units and does NOT scale with the object, so it cannot be a fixed
     constant; measure the overflow and cover it, plus a finger's worth of margin.

     It also draws the selection frame that far out, which is the wanted side
     effect: the dashed box ends up around the LETTERS rather than around an arc
     the shopper cannot see. */
  const INK_FINGER_MARGIN = 8;   // canvas units of extra grab room
  const INK_MAX_PADDING = 70;    // never let a rogue measurement swallow the disc

  function fitHitPaddingToInk(obj) {
    if (!isTextLike(obj)) return;
    const ink = measureObjectInk(obj, canvas.width);
    if (!ink) return;
    obj.padding = 0;             // measure the box on its own terms
    obj.setCoords();
    const br = obj.getBoundingRect(true, true);
    const overflow = Math.max(
      br.top - ink.top,
      ink.bottom - (br.top + br.height),
      br.left - ink.left,
      ink.right - (br.left + br.width),
      0
    );
    obj.padding = Math.min(
      INK_MAX_PADDING,
      Math.round(overflow) + INK_FINGER_MARGIN
    );
    obj.setCoords();
  }

  /* SCALING re-opens the same gap, because whatever offset remains between the
     glyphs and the box is multiplied by the object's scale. Measured before the
     tight arc: text centred at scale 1 sat 27.5 units low at 2.2x and ~57 at 4x.
     The tight arc cuts that offset roughly in half but cannot remove it - the
     glyphs sit ON the arc and extend a font ascent above it, and no path
     geometry can express that, since translating a path only moves its own
     bounding box with it.

     So anchor the ink across a resize too: note where the glyphs are when a
     scale gesture starts, and put them back when it ends. The practical effect
     is that resizing text grows it about its own centre, which is what a
     shopper centring artwork on a round disc expects anyway.

     The two listeners live next to the safe-zone clamp's own handlers rather
     than here: `canvas` does not exist yet at this point in the file, so
     registering them here threw on load and took the whole engine with it. */
  function beginInkAnchor(obj) {
    if (!isTextLike(obj) || obj.__dgsInkAnchor) return;
    // First event of the gesture: the scale delta so far is a few pixels of
    // drag, which is close enough to "before".
    obj.__dgsInkAnchor = measureObjectInk(obj, canvas.width);
  }

  function settleInkAnchor(obj) {
    if (!obj || !obj.__dgsInkAnchor) return;
    const before = obj.__dgsInkAnchor;
    delete obj.__dgsInkAnchor;

    const size = canvas.width;
    const after = measureObjectInk(obj, size);
    if (!after) return;
    obj.left += clampInkNudge(before.centerX - after.centerX, size);
    obj.top += clampInkNudge(before.centerY - after.centerY, size);
    obj.setCoords();
    fitHitPaddingToInk(obj);
    canvas.requestRenderAll();
  }

  // Fixed applyCurveToText function
  const applyCurveToText = (textObj, direction, canvasSize = canvas.width) => {
    if (direction === "straight") {
      textObj._dgsCurveDir = null;
      textObj.set({ path: null });
      textObj.setCoords();
      canvas.renderAll();
      return;
    }

    // Use the RENDERED width (base width × scaleX). Enlarged text keeps the same
    // base width but a big scaleX, and ignoring it gave the arc too small a
    // radius, so big curved text spilled past the disc (owner report).
    const renderedWidth =
      (textObj.calcTextWidth ? textObj.calcTextWidth() : textObj.width) *
      (textObj.scaleX || 1);

    // Add 20% extra space to prevent cramping.
    const minRadiusForText = (renderedWidth / Math.PI) * 1.2;
    let radius = Math.max(minRadiusForText, canvasSize * 0.3);

    // Keep the whole arc inside the disc: cap the radius so the arc top can't
    // leave the circle. If the text is too big to fit that arc, shrink it to fit
    // rather than let it (and its box) run off-canvas.
    const maxRadius = canvasSize * 0.44;
    if (radius > maxRadius) {
      const shrink = maxRadius / radius;
      textObj.set({
        scaleX: (textObj.scaleX || 1) * shrink,
        scaleY: (textObj.scaleY || 1) * shrink,
      });
      radius = maxRadius;
    }

    const pathRadius = radius / Math.abs(textObj.scaleX || 1);
    const cx = canvasSize / 2;
    const cy = canvasSize / 2;

    let curveDirection;
    if (direction === "up" || direction === "curve up") {
      curveDirection = 0;
    } else if (direction === "down" || direction === "curve down") {
      curveDirection = 1;
    } else {
      curveDirection = 0;
    }
    // Stamp the direction on the object so getTextCurveDirection can answer
    // from fact instead of re-deriving it from path geometry (which Fabric
    // has rewritten into Béziers by then - see the note there).
    textObj._dgsCurveDir = curveDirection === 1 ? "down" : "up";

    /* Arc only as far as the text actually reaches.
       This used to be a full 180 degrees regardless of how much of it the text
       covered, and Fabric takes a path-text object's BOUNDING BOX from the PATH,
       not from the glyphs. So the box was the whole semicircle: measured 97.9
       tall for a 54-tall line, with all of the slack on one side of the glyphs
       because they sit ON the arc. That slack scales with the text, which is why
       enlarged curved text drifted ~28 units off centre at 2.2x and ~57 at 4x -
       the owner's "curved text still does not look centered".

       A tight arc of the SAME radius renders identical glyphs, because
       textAlign:center puts them at the apex either way. Measured on the
       sandbox: box 97.9 -> 34.2, glyphs unchanged, and the selection handles
       finally sit around the text instead of a phantom semicircle. It also
       made the text safe-zone clamp workable on curved text again - though that
       clamp has since been removed at the owner's request.

       Geometry: circle centre (cx, cy), apex at cy +/- radius depending on the
       sweep. Endpoints sit half-angle either side of the apex, so at
       halfAngle = 90deg this reduces to the old semicircle exactly. */
    const textLength = textObj.calcTextWidth
      ? textObj.calcTextWidth()
      : textObj.width;
    // 6% of margin so the first and last glyph are not balanced on the path's
    // very ends, where Fabric's per-character placement gets unreliable.
    const halfAngle = Math.min(
      Math.PI / 2,
      (textLength * 1.06) / pathRadius / 2 || Math.PI / 2
    );
    const halfChord = pathRadius * Math.sin(halfAngle);
    const apexDrop = pathRadius * Math.cos(halfAngle);
    // sweep 0 arcs through the point BELOW cy, sweep 1 through the point above;
    // the endpoints move to the matching side so the apex stays where it was.
    const endY = curveDirection === 0 ? cy + apexDrop : cy - apexDrop;

    const pathData = `M ${cx - halfChord}, ${endY} A ${pathRadius},${pathRadius} 0 0,${curveDirection} ${
      cx + halfChord
    }, ${endY}`;

    const path = new fabric.Path(pathData, {
      visible: false,
      strokeWidth: 0,
      fill: null,
    });

    textObj.set({
      path: path,
      textAlign: "center",
      /* Fabric's default is pathAlign:"baseline" - each glyph stands ON the
         arc, so the whole line of letters sits an ascent ABOVE it. Since the
         object's bounding box IS the arc's box, that put the box 27 units below
         the glyphs (measured, scale 3): the selection frame drawn low and to one
         side of the letters, and - because Fabric hit-tests text on that box -
         a finger landing on a visible letter grabbed nothing at all. Both of
         the owner's complaints came out of that one offset.

         "center" straddles the glyphs on the arc instead. Measured: box-to-glyph
         offset 27.1 -> 0.1, and the remaining overflow becomes symmetric (26.7
         above / 26.5 below instead of 51.7 / -2.5). The curve itself is
         unchanged - the letters follow the same arc, they just reference its
         middle rather than their baseline. */
      pathAlign: "center",
      // Pinned: any leftover offset wraps the first glyph to the far end - see
      // the note above applyCurveToText's callers.
      pathStartOffset: 0,
    });

    textObj.setCoords();
    canvas.requestRenderAll();
  };

  function getTextCurveDirection(obj) {
    if (!obj.path) {
      return "straight";
    }

    // Stamped by applyCurveToText - authoritative when present. The geometry
    // below is only the fallback for reloaded saved designs, whose paths were
    // rebuilt from stored path data without ever passing through the stamp.
    if (obj._dgsCurveDir === "up" || obj._dgsCurveDir === "down") {
      return obj._dgsCurveDir;
    }

    // Extract path data
    const pathData = obj.path.path || obj.path;

    // Fabric parses the "A" arc we wrote into cubic Bézier segments, so the
    // direction has to be read off a "C". Compare each control point against
    // the SEGMENT START, not the segment end: control points always bow
    // toward the apex, but the end only sits at the apex on a half-circle
    // arc. Comparing against the end read the tight arcs (2026-08-26)
    // BACKWARDS, so every canvas resize's straighten/re-curve trip applied
    // the inverted direction - the "opening the Text sheet flips my curve"
    // report of 2026-08-30. In this file's naming, "up" is the sweep-0 arc
    // that bows BELOW its endpoints (larger y on screen).
    let prevY = null;
    for (let cmd of pathData) {
      const type = cmd[0];
      if (type === "M") {
        prevY = cmd[2];
        continue;
      }
      if (type === "A") {
        // Arc command: rx ry x-axis-rotation large-arc-flag sweep-flag x y
        return cmd[5] === 0 ? "up" : "down";
      }
      if ((type === "Q" || type === "C") && prevY != null) {
        const cpY = cmd[2];
        if (cpY > prevY) return "up";
        if (cpY < prevY) return "down";
      }
      if (cmd.length >= 3) prevY = cmd[cmd.length - 1];
    }

    return "straight";
  }
  
  const updateClipPath = (size) => {
    const clipPath = new fabric.Circle({
      radius: size / 2,
      left: size / 2,
      top: size / 2,
      originX: "center",
      originY: "center",
    });
    canvas.clipPath = clipPath;
  };

  // --- Enhanced Responsive Canvas Resize with Curve Text Management ---
  // Improved version of your existing resizeCanvas function with mobile checks
  const resizeCanvas = () => {
    let currentTab= window.getActiveTabId();
    if (isResizing || isImporting || isKeyboardOpen || currentTab!="tab1") return;
    // Additional mobile keyboard check
    const isMobile = window.innerWidth <= 768;
    if (isMobile && window.visualViewport) {
      const viewport = window.visualViewport;
      const heightDifference = window.innerHeight - viewport.height;

      if (heightDifference > keyboardDetectionThreshold) {
        console.log("Resize blocked - keyboard still detected");
        return;
      }
    }
    isResizing = true;

    const oldSize = canvas.width;
    // Give padding only for mobile screens
    let wrapperWidth = wrapper.offsetWidth;

    const padding = isMobile ? 10 : 0; // 5px padding on mobile
    if (wrapperWidth > padding * 2) {
      wrapperWidth = wrapper.offsetWidth - padding * 2;
    }
    const newSize = Math.min(wrapperWidth, (window.DGS_CANVAS_MAX >= 300 && window.DGS_CANVAS_MAX <= 900 ? window.DGS_CANVAS_MAX : 500));
    if (!newSize) {
      isResizing = false;
      return;
    }

    const applyCanvasSize = (size) => {
      canvasEl.width = size;
      canvasEl.height = size;
      canvasEl.style.width = size + "px";
      canvasEl.style.height = size + "px";
      canvas.setWidth(size);
      canvas.setHeight(size);

      const clipPath = canvas.clipPath;
      if (clipPath) {
        clipPath.set({
          radius: size / 2,
          left: size / 2,
          top: size / 2,
        });
      }

      canvas.renderAll();
      enableTabs();
      createPlaceholders();
    };

    if (oldSize == null || oldSize === 0) {
      applyCanvasSize(newSize);
      isResizing = false;
      return;
    }

    if (oldSize === newSize) {
      isResizing = false;
      return;
    }
    const scaleFactor = newSize / oldSize;

    // Store the current active object to restore later
    const activeObject = canvas.getActiveObject();
    canvas.discardActiveObject();

    // Step 1: Straighten all curved text and store their states
    const objects = canvas.getObjects();
    const textObjectsToRestore = [];

    objects.forEach((obj) => {
      if (obj.type === "i-text") {
        if (obj.path) {
          straightenCurvedText(obj);
          textObjectsToRestore.push(obj);
        }
      }
    });

    // Render canvas after straightening text
    canvas.renderAll();

    // Step 2: Scale all objects proportionally AFTER straightening text
    objects.forEach((obj) => {
      if (obj.type === "i-text" || obj.type === "text") {
        // For text objects, handle differently to maintain position accuracy
        const currentLeft = obj.left;
        const currentTop = obj.top;

        // Calculate relative position (0-1 scale)
        const relativeLeft = currentLeft / oldSize;
        const relativeTop = currentTop / oldSize;

        // Apply new absolute position
        let newLeft = relativeLeft * newSize;
        let newTop = relativeTop * newSize;

        // Same 5% the images branch below uses. It was 10% - a second, stricter
        // text-only guard that pulled text inward on every rotation and keyboard
        // open, on top of the safe-zone clamp that has now gone. Text is meant to
        // behave like an image here.
        const padding = newSize * 0.05;
        newLeft = Math.max(padding, Math.min(newSize - padding, newLeft));
        newTop = Math.max(padding, Math.min(newSize - padding, newTop));

        // Scale with the canvas, and NO fixed ceiling. This used to be
        // Math.min(obj.fontSize * scaleFactor, 40): text is added at ~50, so the
        // first canvas resize of a session silently shrank it about 20% and it
        // could never grow back, because every later resize re-applied the same
        // 40. A cap in absolute px is meaningless anyway when the canvas it sits
        // on changes size - proportional scaling is the whole point of this loop.
        const fontSize = obj.fontSize * scaleFactor;

        obj.set({
          left: newLeft,
          top: newTop,
          fontSize: fontSize,
        });
      } else {
        // For images and other objects, use the original scaling method
        let newLeft = obj.left * scaleFactor;
        let newTop = obj.top * scaleFactor;

        // Constrain images within canvas boundaries
        const padding = newSize * 0.05; // 5% padding for images
        newLeft = Math.max(padding, Math.min(newSize - padding, newLeft));
        newTop = Math.max(padding, Math.min(newSize - padding, newTop));

        obj.set({
          left: newLeft,
          top: newTop,
          scaleX: obj.scaleX * scaleFactor,
          scaleY: obj.scaleY * scaleFactor,
        });
      }

      obj.setCoords();
    });

    // Step 3: Resize canvas AFTER scaling objects
    canvas.setWidth(newSize);
    canvas.setHeight(newSize);

    // Update clip path
    const clipPath = canvas.clipPath;
    if (clipPath) {
      clipPath.set({
        radius: newSize / 2,
        left: newSize / 2,
        top: newSize / 2,
      });
    }

    // Step 4: Restore curved text after resize is complete
    setTimeout(() => {     

      textObjectsToRestore.forEach((textObj) => {
        // Reset the wasRestored flag before restoration
        if (curvedTextStates.has(textObj)) {
          curvedTextStates.get(textObj).wasRestored = false;
        }

        restoreCurvedText(textObj, newSize);
      });

      // Restore active object if it existed
      if (activeObject) {
        canvas.setActiveObject(activeObject);
      }

      canvas.renderAll();
      
      isResizing = false;

      // enable teh tabs
      enableTabs();
      createPlaceholders();

    }, 200); // Increased delay to ensure canvas resize is complete
    // Add placehoder
    
  };
  

  // Version 1
  function createIText(text, fontFamily, baseFontSize) {
    const textObj = new fabric.IText(text, {
      left: canvas.width / 2,
      top: canvas.height / 2,
      fill: activeTextColor,
      fontFamily: fontFamily,
      fontSize: baseFontSize, // 40
      originX: "center",
      originY: "center",
      textAlign: "center",
      cornerColor: "#4299e1",
      cornerSize: 12,
      // Slightly larger finger hit area for the corner handles — but NOT so big
      // it swallows the text body (44 made it impossible to grab the middle to
      // move the text). The 2x default text size does most of the de-clumping.
      touchCornerSize: 28,
      transparentCorners: false,
      lockScalingFlip: true,
    });
    // Corner handles + rotate only. The four mid-edge handles both cluttered the
    // box on small text and let a drag stretch the text non-uniformly / flip it.
    textObj.setControlsVisibility({ ml: false, mr: false, mt: false, mb: false });
    // A single tap must only SELECT/MOVE the text. Entering edit mode (and
    // popping the keyboard) on a tap was the main reason moving felt broken —
    // especially on curved text, whose glyphs sit at the top of a tall box so a
    // "grab to move" reads as a click. Editing now requires a double-tap, which
    // sets __dgsAllowEdit (see the canvas "mouse:dblclick" handler).
    textObj.enterEditing = function (e) {
      if (!this.__dgsAllowEdit) return this;
      this.__dgsAllowEdit = false;
      return fabric.IText.prototype.enterEditing.call(this, e);
    };
    return textObj;
  }

  const textInput = document.getElementById("text-input");
  textInput.addEventListener("keydown", stopInputEnterPropagation);

  function stopInputEnterPropagation(event) {
    if (event.key === "Enter") {
      event.preventDefault(); // Stop form submission
    }
  }
  // --- Add Text Functionality with Dynamic Responsive Sizing ---
  document.getElementById("add-text-btn").addEventListener("click", () => {
    (async () => {
      
      const text = textInput.value.trim();
      const fontFamily = fontFamilySelect.value;
      if (!text) {
        alert("Please enter some text first!");
        return;
      }

      // Calculate responsive font size based on current canvas size

      const currentCanvasSize = canvas.width;
      let baseFontSize = Math.max(currentCanvasSize * 0.08, 16);
      baseFontSize = Math.min(baseFontSize, 40);

      if (currentCanvasSize <= 300) {
        baseFontSize = Math.max(currentCanvasSize * 0.06, 16);
      } else if (currentCanvasSize <= 400) {
        baseFontSize = Math.max(currentCanvasSize * 0.07, 20);
      } else if (currentCanvasSize <= 500) {
        baseFontSize = Math.max(currentCanvasSize * 0.08, 24);
      } else {
        baseFontSize = Math.max(currentCanvasSize * 0.08, 28);
      }

      /* Default starting size. This was * 2 (capped 90) from an earlier owner
         request to make new text bigger; the owner asked for ~30% off it on
         2026-08-28 after seeing it on a phone, so 2 -> 1.4 and the cap comes
         down by the same 30%. On a 323px canvas that is 45.2 -> 31.7.
         Both numbers move together on purpose: trimming the multiplier alone
         would leave big canvases pinned at the old ceiling. */
      baseFontSize = Math.min(baseFontSize * 1.4, 63);

      // ✅ Ensure font is loaded before rendering text
      await ensureFontLoaded(fontFamily);
      // Calculate appropriate width for text wrapping (80% of canvas width)
      const maxWidth = canvas.width * 1;
      // let textObj = createTextBox(text, fontFamily, maxWidth);

      let textObj = createIText(text, fontFamily, baseFontSize);

      // Add metadata to the text object
      addMetadataToObject(textObj, {
        text: text,
        fontFamily: fontFamily,
        color: activeTextColor,
        userCreated: true,
      });

      canvas.add(textObj);
      canvas.setActiveObject(textObj);
      canvas.renderAll();
      textInput.value = "";
      handleChangeInCanvas();
    })();
  });

 
  // --- IMPROVED CURVE BUTTON LOGIC ---
  function applyCurve(direction) {
    const activeObject = canvas.getActiveObject();
    if (activeObject && activeObject.type === "i-text") {
      // Store the curve state
      const curveDir = direction === 0 ? "up" : "down";
      curvedTextStates.set(activeObject, {
        curveDirection: curveDir,
        originalLeft: activeObject.left,
        originalTop: activeObject.top,
        wasRestored: false,
      });

      console.log("Applying curve:", curveDir, "to text:", activeObject.text);
      applyCurveToText(activeObject, curveDir);
      canvas.renderAll();
      handleChangeInCanvas();
    }
  }

  // document
  //   .getElementById("curve-up-btn")
  //   .addEventListener("click", () => applyCurve(0));

  document.getElementById("curve-up-btn").addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject && activeObject.type === "i-text") {
      curveTextKeepingInkInPlace(activeObject, "up");
      canvas.renderAll();
      // Bring the disc back on screen so the shopper sees the result — the curve
      // buttons sit well below the canvas on a phone.
      if (wrapper) wrapper.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });
  // document
  //   .getElementById("curve-down-btn")
  //   .addEventListener("click", () => applyCurve(1));

  document.getElementById("curve-down-btn").addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject && activeObject.type === "i-text") {
      curveTextKeepingInkInPlace(activeObject, "down");
      canvas.renderAll();
      if (wrapper) wrapper.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });
  document.getElementById("straighten-btn").addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (
      activeObject &&
      (activeObject.type === "textbox" || activeObject.type === "i-text")
    ) {
      // Straightening drops the box from 109 back to 58, which without the ink
      // anchor jumps the glyphs UP by the same ~21 the curve pushed them down.
      curveTextKeepingInkInPlace(activeObject, "straight");

      // Update stored state to straight
      curvedTextStates.set(activeObject, {
        curveDirection: "straight",
        originalLeft: activeObject.left,
        originalTop: activeObject.top,
        // wasRestored: false,
      });

      console.log("Making text straight:", activeObject.text);

      activeObject.set({ path: null });
      canvas.renderAll();
    }
  });

  const imageUploadErrorMsg = document.getElementById("image-upload-error-msg");

  // --- Add Image From Upload Functionality with Responsive Sizing (HEIC SUPPORT ADDED) ---
document.getElementById("image-upload").addEventListener("change", async (e) => {
  let file = e.target.files[0];
  if (!file) return;

  const imageUploadErrorMsg = document.getElementById("image-upload-error-msg");
  imageUploadErrorMsg.classList.add("hidden");
  imageUploadErrorMsg.innerHTML = ``;
  // The PDF note below recolours this line; every new upload starts red again.
  imageUploadErrorMsg.style.color = "";

  const MAX_SIZE_MB = 20;
  const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

  // 1. HEIC/HEIF Conversion Logic
  // Detect HEIC/HEIF by filename, MIME type, OR file content. Facebook /
  // Instagram in-app browsers frequently hand over an iPhone HEIC with an empty
  // file.type - and sometimes a renamed file with no .heic extension - which the
  // name+MIME checks alone miss. The photo then fails the JPEG/PNG validation
  // below and "won't upload". As a last-resort fallback, sniff the ISO-BMFF
  // 'ftyp' brand from the file header. The sniff only runs when the cheap
  // name/MIME checks are false (short-circuit), so it costs a 32-byte read at
  // most.
  let isHeic =
    /\.(heic|heif)$/i.test(file.name || "") ||
    file.type === "image/heic" ||
    file.type === "image/heif";
  if (!isHeic) {
    try {
      const head = new Uint8Array(await file.slice(0, 32).arrayBuffer());
      if (head[4] === 0x66 && head[5] === 0x74 && head[6] === 0x79 && head[7] === 0x70) {
        // bytes 4-8 are 'ftyp'; the major/compatible brands follow at byte 8
        const brand = String.fromCharCode.apply(null, head.subarray(8, 32)).toLowerCase();
        isHeic = /heic|heix|heim|heis|hevc|hevx|mif1|msf1|heif/.test(brand);
      }
    } catch (e) {
      /* slice/arrayBuffer unsupported or unreadable - fall through */
    }
  }
  if (isHeic) {
    try {
      // Show a temporary loading state if you have a loader, or just change button text
      // console.log("HEIC detected, converting...");
      
      const convertedBlob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.8
      });

      // Handle case where heic2any returns an array (rare, but possible for multi-image heic)
      const finalBlob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;

      // Create a new File object to mimic a standard JPEG upload
      file = new File([finalBlob], file.name.replace(/\.(heic|heif)$/i, ".jpg"), {
        type: "image/jpeg",
        lastModified: new Date().getTime()
      });
      
    } catch (error) {
      console.error("HEIC conversion failed:", error);
      imageUploadErrorMsg.classList.remove("hidden");
      // Same reasoning as the unsupported-type message: name the file and the
      // reason, so a phone-only report carries its own diagnosis.
      const why = (error && (error.message || error.name)) || "unknown error";
      imageUploadErrorMsg.innerHTML =
        `Error: Could not process this HEIC image (${file.name || "unnamed"}: ${String(why).slice(0, 80)}). Please try converting it to JPEG first.`;
      e.target.value = "";
      return;
    }
  }

  // 1b. PDF -> PNG. Designers export PDFs; the canvas cannot read one, so it is
  // rasterised here, exactly where HEIC becomes a JPEG, and everything after
  // this point (validation, layering, the native-bytes cart upload, the 2400px
  // print export, QC) only ever sees an ordinary PNG File. Detect by name,
  // MIME, or the "%PDF" header - in-app browsers hand over empty file.type for
  // PDFs just as they do for photos.
  let pdfPageCount = 0;
  let isPdf = /\.pdf$/i.test(file.name || "") || file.type === "application/pdf";
  if (!isPdf && (!file.type || file.type === "application/octet-stream")) {
    try {
      const head = new Uint8Array(await file.slice(0, 5).arrayBuffer());
      isPdf = head[0] === 0x25 && head[1] === 0x50 && head[2] === 0x44 && head[3] === 0x46; // %PDF
    } catch (e) {
      /* unreadable slice - fall through */
    }
  }
  if (isPdf) {
    // Check the PDF's own size before rendering; the PNG it becomes is checked
    // again below like any other upload.
    if (file.size > MAX_SIZE_BYTES) {
      imageUploadErrorMsg.classList.remove("hidden");
      imageUploadErrorMsg.innerHTML = `Error: File is too large. Please upload a PDF smaller than ${MAX_SIZE_MB} MB.`;
      e.target.value = "";
      return;
    }
    try {
      // 2400 = the print ceiling (8" at 300 DPI), same as PRINT_MAX_EDGE in the
      // export code below.
      const out = await convertPdfToPng(file, 2400);
      pdfPageCount = out.pageCount;
      file = out.file;
    } catch (error) {
      console.error("PDF conversion failed:", error);
      imageUploadErrorMsg.classList.remove("hidden");
      const code = (error && error.name) || "";
      let why;
      if (code === "PasswordException") {
        why = "it is password-protected. Please remove the password and try again";
      } else if (code === "DGSBlankPdf") {
        why = "the first page looks blank. Please check the file and try again";
      } else if (code === "DGSPdfLoad") {
        why = "the PDF reader could not be loaded. Please check your connection and try again, or upload a PNG or JPEG instead";
      } else {
        why = `${String((error && (error.message || error.name)) || "unknown error").slice(0, 80).replace(/[.\s]+$/, "")}. Please try saving it as a PNG or JPEG`;
      }
      imageUploadErrorMsg.innerHTML =
        `Error: Could not read this PDF (${file.name || "unnamed"}) - ${why}.`;
      e.target.value = "";
      return;
    }
  }

  // Normalize an empty/unknown MIME type from the filename extension. In-app
  // browsers (FB/IG) and Android content-URI uploads often report no file.type
  // for a perfectly valid image, which the strict validTypes check below would
  // then reject as "Unsupported" ("won't upload photo"). Re-wrap the same bytes
  // with the inferred type so validation, the SVG branch, and export all work.
  if (!file.type || file.type === "application/octet-stream") {
    const extMime = {
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      webp: "image/webp",
      bmp: "image/bmp",
      svg: "image/svg+xml",
    }[(file.name.split(".").pop() || "").toLowerCase()];
    if (extMime) {
      file = new File([file], file.name, {
        type: extMime,
        lastModified: file.lastModified,
      });
    } else {
      // No usable extension either. Android content-URI picks and some in-app
      // browsers hand over a perfectly good photo named "content-1234" or
      // "image" with an empty type, and the strict validTypes check below then
      // rejects it as "Unsupported file type" - the shopper sees a photo they
      // can see in their gallery refuse to upload, with no way to tell why.
      // The HEIC path above already sniffs the header for exactly this reason;
      // do the same for the ordinary formats. Magic bytes are cheap (16 of
      // them) and are the ONLY honest source when name and MIME are both mute.
      try {
        const h = new Uint8Array(await file.slice(0, 16).arrayBuffer());
        const ascii = (a, b) => String.fromCharCode.apply(null, h.subarray(a, b));
        let sniffed = null;
        if (h[0] === 0x89 && h[1] === 0x50 && h[2] === 0x4e && h[3] === 0x47) {
          sniffed = "image/png";
        } else if (h[0] === 0xff && h[1] === 0xd8 && h[2] === 0xff) {
          sniffed = "image/jpeg";
        } else if (ascii(0, 4) === "GIF8") {
          sniffed = "image/gif";
        } else if (ascii(0, 4) === "RIFF" && ascii(8, 12) === "WEBP") {
          sniffed = "image/webp";
        } else if (h[0] === 0x42 && h[1] === 0x4d) {
          sniffed = "image/bmp";
        }
        if (sniffed) {
          file = new File([file], file.name, {
            type: sniffed,
            lastModified: file.lastModified,
          });
        }
      } catch (e) {
        /* unreadable slice - fall through to the validation below */
      }
    }
  }

  // 2. Standard Validation (Updated to include converted file)
  const validTypes = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/webp",
    "image/bmp",
    "image/svg+xml"
  ];

  if (!validTypes.includes(file.type)) {
    imageUploadErrorMsg.classList.remove("hidden");
    // Say what was actually received. A shopper reporting "it won't let me add
    // my photo" from a phone we cannot attach a console to is otherwise a dead
    // end - name and MIME are exactly the two facts that identify which picker
    // path they came through, and they are safe to show.
    const seen = `${file.name || "unnamed"}, ${file.type || "no file type"}`;
    imageUploadErrorMsg.innerHTML =
      `Error: Unsupported file type (${seen}). Please upload a JPEG, PNG, GIF, WebP, BMP, HEIC, SVG, or PDF file.`;
    e.target.value = "";
    return;
  }

  if (file.size > MAX_SIZE_BYTES) {
    imageUploadErrorMsg.classList.remove("hidden");
    imageUploadErrorMsg.innerHTML = `Error: File is too large. Please upload an image smaller than ${MAX_SIZE_MB} MB.`;
    e.target.value = "";
    return;
  }

  // 3. Existing Loading Logic
  const reader = new FileReader();
  reader.onload = async (f) => {
    let dataUrl = f.target.result;

    try {
      // ✅ Convert SVG to PNG if needed
      if (file.type === "image/svg+xml") {
        dataUrl = await convertSvgToPng(dataUrl, 3000);
      } 
    } catch (err) {
      imageUploadErrorMsg.classList.remove("hidden");
      imageUploadErrorMsg.innerHTML = `Error: Failed to convert SVG to PNG.`;
      e.target.value = "";
      return;
    }

    fabric.Image.fromURL(dataUrl, (img) => {
      // A file with a healthy name and MIME type but unreadable bytes (a
      // truncated download, a corrupted photo) decodes to a 0×0 element.
      // Without this guard Fabric adds an invisible object that counts as
      // artwork, so Add to Cart un-gates over an empty-looking disc and the
      // shopper could order a blank print. Same reject pattern as HEIC above.
      const el = img && img.getElement && img.getElement();
      if (!img || !img.width || !img.height || (el && el.naturalWidth === 0)) {
        imageUploadErrorMsg.classList.remove("hidden");
        imageUploadErrorMsg.innerHTML =
          `Error: Could not read this image (${file.name || "unnamed"}) - the file may be corrupted. Please try a different copy of the photo.`;
        e.target.value = "";
        return;
      }
      // Calculate responsive image size
      const maxSize = canvas.width * 0.4;
      const scaleFactor = Math.min(maxSize / img.width, maxSize / img.height);

      const canvasCenterX = canvas.width / 2;
      const canvasCenterY = canvas.height / 2;

      // Scale image to fit canvas nicely
      const maxWidth = canvas.width * 0.6;
      const maxHeight = canvas.height * 0.6;

      // Calculate initial scale to fit image properly
      const scaleX = maxWidth / img.width;
      const scaleY = maxHeight / img.height;
      
      // Position images with slight offset for multiple uploads
      let i = 0; // Note: In your original code, 'i' was defined but not incremented globally? 
                 // Assuming you might want to track this globally or just keep it 0 for now.

      img.set({
        scaleX: scaleFactor,
        scaleY: scaleFactor,
        left: canvasCenterX,
        top: canvasCenterY,
        originX: "center",
        originY: "center",
        selectable: true,
        moveable: true,
      });

      // Add metadata to the image object
      addMetadataToObject(img, {
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type,
        uploadedAt: new Date().toISOString(),
        source: "user_upload",
      });

      // Stash the exact source File so Add-to-Cart can upload the native bytes
      // untouched (full resolution, no recompression). HEIC has already been
      // converted to a JPEG File above; SVG stays as-is here and is rasterized
      // in the fallback path. This prop is not serialized into canvas.json.
      img._dgsSourceFile = file;

      canvas.add(img);
      canvas.setActiveObject(img);
      images.push(img);
      // Default layering: PNG logos ride on top of JPEG photos. A newly added
      // photo drops below any existing logos; a new logo stays on top.
      placeUploadByType(img);
      // Keep text ABOVE every photo so tapping the text always selects the text,
      // not a photo that happens to sit under it (owner: "hard to select/move
      // text when an image is underneath"). The image stays selected/editable.
      bringAllTextToFront();
      canvas.renderAll();

      // Update button states
      updateIamgeActionButtonStates();
      handleChangeInCanvas();

      // A multi-page PDF silently became its first page; say so, in grey, in
      // the same line errors use (the v2 shell surfaces that line on mobile).
      if (pdfPageCount > 1) {
        imageUploadErrorMsg.style.color = "#4b5563";
        imageUploadErrorMsg.innerHTML =
          `Your PDF has ${pdfPageCount} pages - we added page 1. Upload a one-page PDF to use a different page.`;
        imageUploadErrorMsg.classList.remove("hidden");
      }
    });
  };
  
  reader.readAsDataURL(file);
  e.target.value = "";
});

  // PDF -> PNG converter. Page 1 only. Two renders: a small probe to find the
  // artwork's bounding box (transparent AND near-white pixels count as
  // background, so a logo on a Letter page does not arrive as a huge white
  // sheet), then the cropped region at the print ceiling on the long edge.
  // The loader lives in create-disc-design.liquid (window.DGS_loadPdfJs) so
  // the version, URLs and integrity hash sit next to the heic2any loader.
  async function convertPdfToPng(pdfFile, targetEdge = 2400) {
    if (typeof window.DGS_loadPdfJs !== "function") {
      const err = new Error("PDF reader unavailable");
      err.name = "DGSPdfLoad";
      throw err;
    }
    let pdfjs;
    try {
      pdfjs = await window.DGS_loadPdfJs();
    } catch (e) {
      const err = new Error((e && e.message) || "PDF reader failed to load");
      err.name = "DGSPdfLoad";
      throw err;
    }
    const base = window.DGS_PDFJS_BASE || "";
    const data = new Uint8Array(await pdfFile.arrayBuffer());
    const doc = await pdfjs.getDocument({
      data,
      isEvalSupported: false,
      cMapUrl: base ? base + "cmaps/" : undefined,
      cMapPacked: true,
      standardFontDataUrl: base ? base + "standard_fonts/" : undefined,
    }).promise;
    try {
      const page = await doc.getPage(1);
      const unit = page.getViewport({ scale: 1 });
      const transparent = "rgba(0,0,0,0)";

      // Pass 1: probe render to find where the ink is.
      const probeEdge = 600;
      const probeScale = probeEdge / Math.max(unit.width, unit.height);
      const probeVp = page.getViewport({ scale: probeScale });
      const probe = document.createElement("canvas");
      probe.width = Math.max(1, Math.ceil(probeVp.width));
      probe.height = Math.max(1, Math.ceil(probeVp.height));
      await page.render({
        canvasContext: probe.getContext("2d"),
        viewport: probeVp,
        background: transparent,
      }).promise;
      const box = inkBounds(probe);
      if (!box) {
        const err = new Error("blank page");
        err.name = "DGSBlankPdf";
        throw err;
      }
      // Back to page units with a one-probe-pixel margin, clamped to the page.
      const x0 = Math.max(0, (box.x0 - 1) / probeScale);
      const y0 = Math.max(0, (box.y0 - 1) / probeScale);
      const x1 = Math.min(unit.width, (box.x1 + 2) / probeScale);
      const y1 = Math.min(unit.height, (box.y1 + 2) / probeScale);
      const cropW = Math.max(1, x1 - x0);
      const cropH = Math.max(1, y1 - y0);

      // Pass 2: the cropped artwork at the print ceiling. Vector stays sharp
      // at any scale; a placed photo inside the PDF is capped by its own pixels.
      const scale = targetEdge / Math.max(cropW, cropH);
      const vp = page.getViewport({
        scale,
        offsetX: -x0 * scale,
        offsetY: -y0 * scale,
      });
      const out = document.createElement("canvas");
      out.width = Math.max(1, Math.round(cropW * scale));
      out.height = Math.max(1, Math.round(cropH * scale));
      await page.render({
        canvasContext: out.getContext("2d"),
        viewport: vp,
        background: transparent,
      }).promise;

      const blob = await new Promise((resolve, reject) => {
        out.toBlob((b) => (b ? resolve(b) : reject(new Error("PNG encode failed"))), "image/png");
      });
      const name = String(pdfFile.name || "artwork").replace(/\.pdf$/i, "") + ".png";
      return {
        file: new File([blob], name, { type: "image/png", lastModified: Date.now() }),
        pageCount: doc.numPages,
      };
    } finally {
      try { doc.destroy(); } catch (e) { /* ignore */ }
    }
  }

  // Bounding box of the non-background pixels of a canvas, or null if none.
  // Background = (nearly) transparent, or opaque near-white: the disc itself
  // is white, so white page margins carry no print and only get in the way.
  function inkBounds(cv) {
    const w = cv.width, h = cv.height;
    const px = cv.getContext("2d").getImageData(0, 0, w, h).data;
    let x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (let y = 0; y < h; y++) {
      const row = y * w * 4;
      for (let x = 0; x < w; x++) {
        const i = row + x * 4;
        if (px[i + 3] < 16) continue;
        // Near-white at ANY alpha: pdf.js leaves a translucent white column
        // along the page's fractional-pixel edge, which otherwise counts as
        // ink and drags the box out to the full page.
        if (px[i] >= 250 && px[i + 1] >= 250 && px[i + 2] >= 250) continue;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
      }
    }
    return x1 < 0 ? null : { x0, y0, x1, y1 };
  }

  // ✅ SVG to PNG converter function
  async function convertSvgToPng(svgDataUrl, targetWidth = 2000) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        // ✅ Scale up to high resolution
        const aspectRatio = img.height / img.width;
        const canvasEl = document.createElement("canvas");
        canvasEl.width = targetWidth;
        canvasEl.height = targetWidth * aspectRatio;

        const ctx = canvasEl.getContext("2d");
        ctx.drawImage(img, 0, 0, canvasEl.width, canvasEl.height);

        try {
          const pngDataUrl = canvasEl.toDataURL("image/png");
          resolve(pngDataUrl);
        } catch (e) {
          reject(e);
        }
      };
      img.onerror = reject;
      img.src = svgDataUrl;
    });
  }
  const aiPromptInput = document.getElementById("ai-prompt-input");
  aiPromptInput.addEventListener("keydown", stopInputEnterPropagation);

  // --- AI Image Generation ---
  generateAiImageBtn.addEventListener("click", async () => {
   
    const prompt = aiPromptInput.value;
    if (!prompt) {
      aiErrorMsg.textContent = "Please enter a prompt to generate an image.";
      aiErrorMsg.classList.remove("hidden");
      setTimeout(() => aiErrorMsg.classList.add("hidden"), 3000);
      return;
    }

    // Ensure customerEmail is always defined now that AI is allowed for all users.
    // Logged-in customers use their Shopify email.
    // Etsy portal guests and regular logged-out guests get a temporary placeholder email.
    let customerEmail = window.ShopifyCustomerEmail || "";

    if (!customerEmail) {
      const urlParams = new URLSearchParams(window.location.search);
      const etsyOrderId = urlParams.get("etsy");

      if (etsyOrderId) {
        customerEmail = `guest-etsy-${etsyOrderId}@temp.com`;
      } else {
        let guestAiId = null;
        try {
          guestAiId = sessionStorage.getItem("dgs_guest_ai_id");
        } catch (e) {
          guestAiId = null;
        }

        if (!guestAiId) {
          guestAiId = Date.now() + "-" + Math.random().toString(36).slice(2, 10);
          try {
            sessionStorage.setItem("dgs_guest_ai_id", guestAiId);
          } catch (e) {
            // storage blocked - keep the in-memory id for this session
          }
        }

        customerEmail = `guest-web-${guestAiId}@temp.com`;
      }
    }

    aiLoadingIndicator.classList.remove("hidden");
    generateAiImageBtn.disabled = true;
    generateAiImageBtn.classList.add("opacity-50", "cursor-not-allowed");
    aiErrorMsg.classList.add("hidden");

    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      

      const response = await fetch(
        `${DGSAppBaseUrl}/disc-designs/generate-image`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ prompt, customerEmail, timezone }),
        }
      );

            const responseText = await response.text();
      let result;

      try {
        result = JSON.parse(responseText);
      } catch (parseError) {
        throw new Error(
          "AI image generation is temporarily busy. Please wait a minute and try again."
        );
      }

            if (!response.ok) {
        throw new Error(
          result.message ||
          result.error ||
          "AI image generation is temporarily busy. Please wait a minute and try again."
        );
      }
      let { status, message, data = {}, error = {} } = result || {};
      let imagePath;

      if (status === true) {
        imagePath = data.imagePath;
        let { origin } = window.location;
        let imageUrl = origin + "/" + imagePath;

        fabric.Image.fromURL(imageUrl, (img) => {
          // // Calculate responsive image size for AI images
          // const maxSize = canvas.width * 1;
          // const scaleFactor = Math.min(
          //   maxSize / img.width,
          //   maxSize / img.height
          // );
          // img.set({
          //   left: 0,
          //   top: 0,
          //   originX: "left",
          //   originY: "top",
          //   scaleX: scaleFactor,
          //   scaleY: scaleFactor,
          //   selectable: true,
          //   cornerColor: "#4299e1",
          //   cornerSize: 12,
          //   transparentCorners: false,
          // });

          const canvasWidth = canvas.width;
          const canvasHeight = canvas.height;
          const imgWidth = img.width;
          const imgHeight = img.height;

          // Calculate scale to fill the canvas completely
          const scaleX = canvasWidth / imgWidth;
          const scaleY = canvasHeight / imgHeight;
          const fillScale = Math.max(scaleX, scaleY); // Use max to fill entire canvas

          img.set({
            left: canvasWidth / 2,
            top: canvasHeight / 2,
            originX: "center",
            originY: "center",
            scaleX: fillScale,
            scaleY: fillScale,
            selectable: true,
            cornerColor: "#4299e1",
            cornerSize: 12,
            transparentCorners: false,
            fillMode: "cover", // Add this to track that it's meant to fill
          });

          // Add metadata to the AI-generated image object
          addMetadataToObject(img, {
            prompt: prompt,
            imagePath: imagePath,
            imageUrl: imageUrl,
            generatedAt: new Date().toISOString(),
            source: "ai_generated",
            customerEmail: customerEmail,
            timezone: timezone,
            aiProvider: "open ai", // or whatever AI service you're using
          });

          canvas.add(img);
          canvas.setActiveObject(img);
          canvas.renderAll();
          images.push(img); // Add to images array

          // Update button states
          updateIamgeActionButtonStates();
          handleChangeInCanvas();
        });
      } else {
        throw new Error(
          message || error.message || "Failed to generate image."
        );
      }
        } catch (error) {
      console.error("AI Image Generation Error:", error);
      aiErrorMsg.textContent =
        error.message ||
        "AI image generation is temporarily busy. Please wait a minute and try again.";
      aiErrorMsg.classList.remove("hidden");
    } finally {
      aiLoadingIndicator.classList.add("hidden");
      generateAiImageBtn.disabled = false;
      generateAiImageBtn.classList.remove("opacity-50", "cursor-not-allowed");
    }
  });

  // Every press answers. Fit/Fill applied to an image that is ALREADY at the
  // target is a perfect no-op, and a silent no-op reads as a dead button -
  // measured in a live session the night of the cutover: three "Fit whole
  // photo" taps (first worked, two silent), a rapid-tap storm on the canvas,
  // then an exit. When the action changes nothing, pulse the image 4% out and
  // back so the button visibly acknowledged the press; when it does change,
  // the change itself is the feedback. Skipped under prefers-reduced-motion
  // (those users asked for stillness; the action still ran). try/catch:
  // feedback must never be able to break the action it decorates.
  // Generation token: any newer Fit/Fill press or any touch on the canvas
  // cancels a running pulse (fabric's per-frame `abort` hook). Without this,
  // a rapid follow-up inside the 200ms window - no-op Fit, then Fill, or a
  // quick pinch - would have its new scale clobbered by the pulse's
  // remaining frames restoring the OLD scale: the follow-up press would
  // read as dead, the very failure this pulse exists to fix.
  let dgsPulseGen = 0;
  let dgsPulseCancelHooked = false;
  function dgsAcknowledgeNoop(obj) {
    try {
      /* Registered LAZILY on the first pulse - this outer scope runs at
         script evaluation, before `canvas` is assigned, and a top-level
         canvas.on() here threw and killed everything after it in this file
         (caught on the sandbox; never shipped). By the first pulse a canvas
         necessarily exists - a button press on a selected image got us here. */
      if (!dgsPulseCancelHooked) {
        canvas.on("mouse:down", function () { dgsPulseGen++; });
        dgsPulseCancelHooked = true;
      }
      if (window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      const gen = ++dgsPulseGen;
      const stale = () => gen !== dgsPulseGen;
      const sx = obj.scaleX, sy = obj.scaleY;
      const apply = (f) => {
        if (stale()) return;
        obj.set({ scaleX: sx * f, scaleY: sy * f });
        canvas.requestRenderAll();
      };
      fabric.util.animate({
        startValue: 1, endValue: 0.96, duration: 90, onChange: apply, abort: stale,
        onComplete: () => {
          if (stale()) return;
          fabric.util.animate({
            startValue: 0.96, endValue: 1, duration: 110, onChange: apply, abort: stale,
            onComplete: () => {
              if (stale()) return;
              obj.set({ scaleX: sx, scaleY: sy });
              obj.setCoords();
              canvas.requestRenderAll();
            },
          });
        },
      });
    } catch (e) { /* feedback only */ }
  }
  // The state Fit/Fill actually mutate, joined for a cheap before/after
  // equality check. Origin is included: the FIRST press also normalises
  // origin to center, so it always counts as a change even at equal scale.
  function dgsFitFillState(o) {
    return [o.scaleX.toFixed(4), Math.round(o.left), Math.round(o.top), o.originX, o.originY].join("|");
  }

  // "Fill the disc" (#fill-crop-btn) - cover: scale the selected image to fill
  // the canvas, edges clipped by the disc. Button label was "Fill and Crop".
  function fillAndCrop() {
    dgsPulseGen++;   /* a new press cancels any running pulse first */
    const activeObject = canvas.getActiveObject();
    if (!activeObject || activeObject.type !== "image") return;

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
    const imgWidth = activeObject.width;
    const imgHeight = activeObject.height;

    // Calculate scale to fill the canvas (cover behavior)
    const scaleX = canvasWidth / imgWidth;
    const scaleY = canvasHeight / imgHeight;
    const scale = Math.max(scaleX, scaleY)*1.1;

    const dgsBefore = dgsFitFillState(activeObject);
    activeObject.set({
      scaleX: scale,
      scaleY: scale,
      left: canvasWidth / 2,
      top: canvasHeight / 2,
      originX: "center",
      originY: "center",
    });

    // After fill and crop, text goes on top
    bringAllTextToFront();

    canvas.renderAll();
    if (dgsFitFillState(activeObject) === dgsBefore) dgsAcknowledgeNoop(activeObject);
    // Refresh the phone mini-thumbnail right away. Fill/Fit reposition the photo
    // programmatically (no object:modified fires), so without this the
    // "Your disc so far" preview stayed stale until the next scroll.
    updateMiniPreview();
  }

  // "Fit whole photo" (#max-size-btn) - contain: fit the entire selected image
  // within the canvas, may leave space. Button label was "Max Full Size".
  function maxFullSize() {
    dgsPulseGen++;   /* a new press cancels any running pulse first */
    const activeObject = canvas.getActiveObject();
    if (!activeObject || activeObject.type !== "image") return;

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
    const imgWidth = activeObject.width;
    const imgHeight = activeObject.height;

    // Calculate scale to fit within canvas (contain behavior)
    const scaleX = canvasWidth / imgWidth;
    const scaleY = canvasHeight / imgHeight;
    const scale = Math.min(scaleX, scaleY);

    const dgsBefore = dgsFitFillState(activeObject);
    activeObject.set({
      scaleX: scale,
      scaleY: scale,
      left: canvasWidth / 2,
      top: canvasHeight / 2,
      originX: "center",
      originY: "center",
    });
    // After fill and crop, text goes on top
    bringAllTextToFront();

    canvas.renderAll();
    if (dgsFitFillState(activeObject) === dgsBefore) dgsAcknowledgeNoop(activeObject);
    // Refresh the phone mini-thumbnail right away. Fill/Fit reposition the photo
    // programmatically (no object:modified fires), so without this the
    // "Your disc so far" preview stayed stale until the next scroll.
    updateMiniPreview();
  }

  fillCropBtn.addEventListener("click", fillAndCrop);
  maxSizeBtn.addEventListener("click", maxFullSize);

  /* --- Remove background ------------------------------------------------
   *
   * One tap cuts the subject out of the selected photo; the same button then
   * reads "Restore background" and puts the original back, so the result is
   * never forced. Both versions are kept on the object, so toggling after the
   * first cut is instant and never calls the service twice.
   *
   * The service (AWS Lambda -> Photoroom, channels=alpha) returns ONLY a
   * grayscale mask. The mask is applied here to the photo's own pixels at
   * print resolution (<= PRINT_MAX_EDGE), so the cut-out keeps the customer's
   * exact colours and the response stays small. What the service receives is
   * a white-flattened JPEG at the same size - transparency it can't see is
   * kept anyway, because the mask multiplies the existing alpha.
   *
   * The swap goes through setSrc with a PNG data URL, so canvas.json carries
   * the cut-out exactly like an upload, and _dgsSourceFile becomes the PNG so
   * exportAssetsImages uploads those bytes as the print asset untouched.
   *
   * No endpoint configured -> the button is removed from view entirely.
   */
  // `var`, not const/let: refreshRemoveBgButton is hoisted and runs from
  // updateIamgeActionButtonStates, which can fire before this line executes.
  // Undefined here just means "not ready" instead of a TDZ ReferenceError.
  // AWS Lambda dgs-bg-removal (us-east-2) function URL; source + setup notes
  // live in the Design Tool folder's bg-removal-lambda/. Set to "" to switch
  // the feature off without touching anything else.
  var BG_REMOVAL_ENDPOINT =
    window.DGS_BG_REMOVAL_URL ||
    "https://zjeo4d5ijtkghyj3ga6y3j4yqe0nlcmy.lambda-url.us-east-2.on.aws/";
  var removeBgBtn = document.getElementById("remove-bg-btn");
  var removeBgLabel = document.getElementById("remove-bg-label");
  var bgRemovalBusy = false;

  if (removeBgBtn && !BG_REMOVAL_ENDPOINT) {
    removeBgBtn.disabled = true;
    // inline !important: the v2 chip rule forces display with !important too
    removeBgBtn.style.setProperty("display", "none", "important");
  }

  function refreshRemoveBgButton() {
    if (!removeBgBtn || !BG_REMOVAL_ENDPOINT) return;
    const active = canvas && canvas.getActiveObject();
    const isImage =
      !!active && active.type === "image" && !active.isImagePlaceholder;
    // Already see-through (a transparent PNG logo or cut-out): nothing to
    // remove, and every tap would still cost a Photoroom image. Our own
    // cut-outs keep the button, because there it reads "Restore background".
    const alreadyClear =
      isImage && !active._dgsBgUndo && hasClearBackground(active);
    if (alreadyClear) {
      removeBgBtn.disabled = true;
      removeBgBtn.classList.add("opacity-50", "cursor-not-allowed");
      removeBgLabel.textContent = "Remove background";
      removeBgBtn.title = "This image already has a see-through background.";
      return;
    }
    // Busy is NOT `disabled`: v2 hides disabled chips, and the shopper should
    // keep seeing "Cutting out..." where they tapped. Repeat taps are ignored
    // in removeBackgroundFlow instead.
    removeBgBtn.disabled = !isImage;
    removeBgBtn.classList.toggle("opacity-50", !isImage || bgRemovalBusy);
    removeBgBtn.classList.toggle("cursor-not-allowed", !isImage);
    removeBgBtn.classList.toggle("cursor-wait", bgRemovalBusy);
    removeBgBtn.setAttribute("aria-busy", bgRemovalBusy ? "true" : "false");
    if (bgRemovalBusy) return; // keep the "Cutting out" label while working
    const restoring = isImage && !!active._dgsBgUndo;
    removeBgLabel.textContent = restoring
      ? "Restore background"
      : "Remove background";
    removeBgBtn.title = restoring
      ? "Puts your original photo back, background and all."
      : "Cuts out the people, pets or objects in your photo and removes what's behind them.";
  }

  // Does this image ALREADY have a see-through background? A file being a PNG
  // says nothing (plenty of PNGs are opaque photos), so look at the pixels:
  // most of the outer edge must be transparent AND a real share of the whole
  // image (>=15%, so a ROUND logo on a clear background - ~21% clear, and
  // common for club discs - counts). Rounded-corner photos fail the edge test
  // and keep the button; a circle-cropped photo PNG is treated as already
  // clear, a rare case accepted to stop paid taps on round logos. Probed at
  // <=128px, cached per source element, so selection changes stay instant.
  // Any read error (e.g. a cross-origin image) -> false: show the button.
  function hasClearBackground(img) {
    const el = img.getElement && img.getElement();
    if (!el) return false;
    if (img.__dgsClearBgEl === el) return img.__dgsClearBg;
    let clear = false;
    try {
      const w0 = el.naturalWidth || el.width || 0;
      const h0 = el.naturalHeight || el.height || 0;
      if (w0 && h0) {
        const k = Math.min(1, 128 / Math.max(w0, h0));
        const w = Math.max(2, Math.round(w0 * k));
        const h = Math.max(2, Math.round(h0 * k));
        const pc = document.createElement("canvas");
        pc.width = w;
        pc.height = h;
        const pctx = pc.getContext("2d");
        pctx.drawImage(el, 0, 0, w, h);
        const d = pctx.getImageData(0, 0, w, h).data;
        let clearAll = 0;
        let edge = 0;
        let clearEdge = 0;
        for (let y = 0; y < h; y++) {
          for (let x = 0; x < w; x++) {
            const see = d[(y * w + x) * 4 + 3] < 128;
            if (see) clearAll++;
            if (x === 0 || y === 0 || x === w - 1 || y === h - 1) {
              edge++;
              if (see) clearEdge++;
            }
          }
        }
        clear = clearEdge / edge >= 0.6 && clearAll / (w * h) >= 0.15;
      }
    } catch (e) {
      clear = false;
    }
    img.__dgsClearBgEl = el;
    img.__dgsClearBg = clear;
    return clear;
  }

  // A small status pill above everything. Self-contained so it reads the same
  // in v1 and in the v2 shell, and never moves or restyles engine nodes.
  let bgToastEl = null;
  let bgToastTimer = null;
  function bgToast(message, opts) {
    const o = opts || {};
    if (!bgToastEl) {
      bgToastEl = document.createElement("div");
      bgToastEl.id = "dgs-bg-toast";
      bgToastEl.setAttribute("role", "status");
      bgToastEl.setAttribute("aria-live", "polite");
      bgToastEl.style.cssText =
        "position:fixed;left:50%;bottom:calc(96px + env(safe-area-inset-bottom,0px));" +
        "transform:translateX(-50%);z-index:2147483000;max-width:min(92vw,420px);" +
        "padding:12px 18px;border-radius:999px;background:#1f2937;color:#fff;" +
        "font:600 15px/1.35 system-ui,-apple-system,sans-serif;text-align:center;" +
        "box-shadow:0 6px 24px rgba(0,0,0,.25);display:none;align-items:center;gap:10px;";
      document.body.appendChild(bgToastEl);
      if (!document.getElementById("dgs-bg-toast-style")) {
        const st = document.createElement("style");
        st.id = "dgs-bg-toast-style";
        st.textContent =
          "@keyframes dgsBgSpin{to{transform:rotate(360deg)}}" +
          "#dgs-bg-toast .dgs-bg-spin{width:18px;height:18px;flex:none;border-radius:50%;" +
          "border:2.5px solid rgba(255,255,255,.35);border-top-color:#fff;" +
          "animation:dgsBgSpin .8s linear infinite}";
        document.head.appendChild(st);
      }
    }
    clearTimeout(bgToastTimer);
    bgToastEl.innerHTML = "";
    if (o.spinner) {
      const sp = document.createElement("span");
      sp.className = "dgs-bg-spin";
      bgToastEl.appendChild(sp);
    }
    const txt = document.createElement("span");
    txt.textContent = message;
    bgToastEl.appendChild(txt);
    bgToastEl.style.display = "flex";
    if (!o.sticky) {
      bgToastTimer = setTimeout(() => {
        bgToastEl.style.display = "none";
      }, o.ms || 4500);
    }
  }

  function loadImageEl(src) {
    return new Promise((resolve, reject) => {
      const im = new Image();
      im.onload = () => resolve(im);
      im.onerror = () => reject(new Error("mask image failed to decode"));
      im.src = src;
    });
  }

  function canvasToBlob(c, type, quality) {
    return new Promise((resolve, reject) => {
      c.toBlob(
        (b) => (b ? resolve(b) : reject(new Error("toBlob returned null"))),
        type,
        quality
      );
    });
  }

  // Swap the pixels behind a fabric image while keeping how it sits on the
  // disc: same displayed size, same centre, same rotation. The new source can
  // have different pixel dimensions (a >2400px original is cut at 2400px).
  function swapImageSource(img, version) {
    return new Promise((resolve, reject) => {
      const shownW = img.width * img.scaleX;
      const shownH = img.height * img.scaleY;
      const centre = img.getCenterPoint();
      img.setSrc(
        version.src,
        (o, isError) => {
          if (isError || !img.width || !img.height) {
            reject(new Error("image swap failed"));
            return;
          }
          img.set({
            scaleX: shownW / img.width,
            scaleY: shownH / img.height,
          });
          img.setPositionByOrigin(centre, "center", "center");
          img.setCoords();
          img._dgsSourceFile = version.file || undefined;
          if (img.metadata) {
            img.metadata.fileType = version.fileType || "";
            // The uploaded print asset is named from these (exportAssetsImages),
            // so a cut-out ships as "<name>-cutout.png" and production can tell.
            img.metadata.fileName = version.fileName;
            img.metadata.originalFileName = version.originalFileName;
          }
          canvas.requestRenderAll();
          resolve();
        },
        { crossOrigin: img.crossOrigin || "anonymous" }
      );
    });
  }

  async function cutOutImage(img) {
    const el = img.getElement();
    const srcW = el.naturalWidth || img.width;
    const srcH = el.naturalHeight || img.height;
    const scale = Math.min(1, PRINT_MAX_EDGE / Math.max(srcW, srcH));
    const w = Math.max(1, Math.round(srcW * scale));
    const h = Math.max(1, Math.round(srcH * scale));

    // The photo's own pixels at print size - the mask is applied to these.
    const pix = document.createElement("canvas");
    pix.width = w;
    pix.height = h;
    const pctx = pix.getContext("2d");
    pctx.drawImage(el, 0, 0, w, h);

    // What the service sees: the same pixels flattened onto white, as JPEG.
    const up = document.createElement("canvas");
    up.width = w;
    up.height = h;
    const uctx = up.getContext("2d");
    uctx.fillStyle = "#ffffff";
    uctx.fillRect(0, 0, w, h);
    uctx.drawImage(pix, 0, 0);
    const upload = await canvasToBlob(up, "image/jpeg", 0.92);

    const controller =
      typeof AbortController !== "undefined" ? new AbortController() : null;
    const timeout = controller ? setTimeout(() => controller.abort(), 45000) : null;
    let res;
    try {
      res = await fetch(BG_REMOVAL_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "image/jpeg" },
        body: upload,
        signal: controller ? controller.signal : undefined,
      });
    } finally {
      if (timeout) clearTimeout(timeout);
    }
    if (!res.ok) throw new Error(`background removal failed: ${res.status}`);
    const maskBlob = await res.blob();
    const maskUrl = URL.createObjectURL(maskBlob);
    let maskImg;
    try {
      maskImg = await loadImageEl(maskUrl);
    } finally {
      URL.revokeObjectURL(maskUrl);
    }

    const mk = document.createElement("canvas");
    mk.width = w;
    mk.height = h;
    const mctx = mk.getContext("2d");
    mctx.drawImage(maskImg, 0, 0, w, h);
    const m = mctx.getImageData(0, 0, w, h).data;
    const out = pctx.getImageData(0, 0, w, h);
    const d = out.data;
    let kept = 0;
    for (let i = 0; i < d.length; i += 4) {
      // grayscale mask: R carries the coverage
      const a = Math.round((d[i + 3] * m[i]) / 255);
      d[i + 3] = a;
      if (a > 16) kept++;
    }
    // Nothing (or almost nothing) recognised as a subject: don't hand the
    // shopper an empty disc.
    if (kept < w * h * 0.005) {
      const err = new Error("no subject found");
      err.dgsNoSubject = true;
      throw err;
    }
    pctx.putImageData(out, 0, 0);

    const dataUrl = pix.toDataURL("image/png");
    const meta = img.metadata || {};
    const base = String(
      meta.originalFileName || meta.fileName || "photo"
    ).replace(/\.(jpe?g|png|gif|webp|bmp|svg|heic|heif|pdf)$/i, "");
    const file = new File([dataURLtoBlob(dataUrl)], `${base}-cutout.png`, {
      type: "image/png",
      lastModified: Date.now(),
    });
    return {
      src: dataUrl,
      file: file,
      fileType: "image/png",
      fileName: file.name,
      originalFileName: `${base}-cutout`,
    };
  }

  async function removeBackgroundFlow() {
    if (!BG_REMOVAL_ENDPOINT || bgRemovalBusy) return;
    const img = canvas.getActiveObject();
    if (!img || img.type !== "image" || img.isImagePlaceholder) return;
    if (!img._dgsBgUndo && hasClearBackground(img)) {
      refreshRemoveBgButton();
      return;
    }

    bgRemovalBusy = true;
    removeBgLabel.textContent = img._dgsBgUndo
      ? "Restoring…"
      : "Cutting out…";
    refreshRemoveBgButton();

    try {
      if (img._dgsBgUndo) {
        // Restore: one tap, instant, nothing sent anywhere.
        await swapImageSource(img, img._dgsBgUndo);
        delete img._dgsBgUndo;
        bgToast("Your original photo is back.");
      } else {
        const original = {
          src: img.getSrc(),
          file: img._dgsSourceFile,
          fileType: (img.metadata && img.metadata.fileType) || "",
          fileName: img.metadata && img.metadata.fileName,
          originalFileName: img.metadata && img.metadata.originalFileName,
        };
        if (!img._dgsBgCut) {
          bgToast("Cutting out your photo…", { spinner: true, sticky: true });
          img._dgsBgCut = await cutOutImage(img);
        }
        // The shopper may have deleted the photo while it was being cut.
        if (canvas.getObjects().indexOf(img) === -1) {
          bgToast("That photo was removed, so nothing was changed.");
          return;
        }
        await swapImageSource(img, img._dgsBgCut);
        img._dgsBgUndo = original;
        bgToast("Background removed. Not quite right? Tap “Restore background”.", {
          ms: 6000,
        });
      }
      bringAllTextToFront();
      canvas.renderAll();
      window.DGS_markCanvasDirty();
      updateMiniPreview();
    } catch (err) {
      console.error("Remove background:", err);
      bgToast(
        err && err.dgsNoSubject
          ? "We couldn't find a clear subject to cut out in this photo. It's unchanged."
          : "Sorry, we couldn't remove the background just now. Your photo is unchanged — please try again.",
        { ms: 6500 }
      );
    } finally {
      bgRemovalBusy = false;
      refreshRemoveBgButton();
    }
  }

  if (removeBgBtn) removeBgBtn.addEventListener("click", removeBackgroundFlow);

  // Send all images to back
  function bringAllTextToFront() {
    // Keep text above all images so it's always tappable — WITHOUT reordering
    // the images among themselves. The old version sent every image to back in
    // turn, which reversed the order of two images on every edit and fought
    // both manual layering and the photo-under-logo upload default.
    const textObjects = canvas
      .getObjects()
      .filter(
        (obj) =>
          obj.type === "text" || obj.type === "i-text" || obj.type === "textbox"
      );
    textObjects.forEach((text) => canvas.bringToFront(text));
  }

  // A "photo" is an opaque JPEG (incl. HEIC converted to JPEG on upload); it
  // forms the bottom band. Everything else uploaded — PNG/SVG/WebP/GIF/BMP —
  // is treated as an overlay ("logo") that sits above photos by default.
  function isOpaquePhoto(imgObj) {
    const t =
      (imgObj._dgsSourceFile && imgObj._dgsSourceFile.type) ||
      (imgObj.metadata && imgObj.metadata.fileType) ||
      "";
    return /image\/jpe?g/i.test(t);
  }

  // Default layering at UPLOAD time only: a new photo drops below any logos
  // already on the canvas so uploaded PNG logos stay visible on top. A new
  // logo needs no move — canvas.add() already placed it above existing photos.
  // Users can still reorder freely afterward with Bring Forward / Send Backward.
  function placeUploadByType(newImg) {
    if (!isOpaquePhoto(newImg)) return; // logos stay on top

    const objs = canvas.getObjects();
    let firstOverlayIdx = -1;
    for (let i = 0; i < objs.length; i++) {
      const o = objs[i];
      if (o === newImg) continue;
      if (o.type === "image" && !isOpaquePhoto(o)) {
        firstOverlayIdx = i;
        break;
      }
    }
    if (firstOverlayIdx === -1) return; // no logos present → leave photo on top

    const curIdx = objs.indexOf(newImg);
    // moveTo removes then re-inserts; if the photo currently sits below the
    // target, removing it shifts the target index down by one.
    let target = curIdx < firstOverlayIdx ? firstOverlayIdx - 1 : firstOverlayIdx;
    canvas.moveTo(newImg, Math.max(0, target));
  }

  /* --- Undo for destructive actions -------------------------------------
   *
   * Stores the actual fabric object INSTANCES that were removed, not a JSON
   * snapshot. That is deliberate: curvedTextStates is a Map keyed by object
   * identity, and the curve/lock/font rehydration needed to rebuild an object
   * from JSON lives inline inside handleUseSavedDesignAction. Re-adding the
   * same instances sidesteps all of it, so undo cannot corrupt the canvas_json
   * that goes to fulfilment.
   *
   * Scope: Delete Selected and Clear Canvas - the two actions that destroy
   * work. Moves, resizes and color changes are not undoable (they are not
   * destructive and would need the JSON path).
   */
  const undoStack = [];
  const UNDO_LIMIT = 20;

  function pushUndo(entry) {
    // Ultimate print profiles can change the printable canvas diameter while
    // removed objects are in history. Remember their coordinate space; this
    // is local undo state only, never part of a saved design or upload.
    if (wrapper.dataset.dgsDiscProfile === "ultimate") entry.canvasSize = canvas.width;
    undoStack.push(entry);
    if (undoStack.length > UNDO_LIMIT) undoStack.shift();
    refreshUndoButton();
  }

  function refreshUndoButton() {
    const btn = document.getElementById("undo-btn");
    if (!btn) return;
    const next = undoStack[undoStack.length - 1];
    btn.disabled = undoStack.length === 0;
    btn.title = next ? `Undo ${next.label}` : "Nothing to undo yet";
    const label = document.getElementById("undo-btn-label");
    if (label) label.textContent = next ? `Undo ${next.label}` : "Undo";
  }

  function performUndo() {
    const entry = undoStack.pop();
    if (!entry) return;

    if (wrapper.dataset.dgsDiscProfile === "ultimate" && entry.canvasSize > 0 && entry.canvasSize !== canvas.width) {
      const factor = canvas.width / entry.canvasSize;
      // Scale the existing instances, including an existing text path as a
      // whole. Rebuilding text or paths here would change the restored artwork.
      entry.objects.forEach((obj) => {
        obj.set({
          left: obj.left * factor,
          top: obj.top * factor,
          scaleX: obj.scaleX * factor,
          scaleY: obj.scaleY * factor,
        });
        obj.setCoords();
      });
      if (entry.curveStates) {
        entry.curveStates.forEach(([, state]) => {
          if (Number.isFinite(state.originalLeft)) state.originalLeft *= factor;
          if (Number.isFinite(state.originalTop)) state.originalTop *= factor;
        });
      }
    }

    entry.objects.forEach((obj) => canvas.add(obj));

    // Restore curve state for any object that had it when it was removed.
    if (entry.curveStates) {
      entry.curveStates.forEach(([obj, state]) => curvedTextStates.set(obj, state));
    }

    if (entry.backgroundColor !== undefined) {
      canvas.setBackgroundColor(entry.backgroundColor, canvas.renderAll.bind(canvas));
    }

    canvas.discardActiveObject();
    canvas.renderAll();
    refreshUndoButton();
    handleChangeInCanvas();
  }

  // Captures everything currently on the canvas, for Clear Canvas.
  function snapshotAllForUndo(label) {
    const objects = canvas.getObjects().slice();
    if (!objects.length && canvas.backgroundColor === "#ffffff") return;
    const curveStates = objects
      .filter((o) => curvedTextStates.has(o))
      .map((o) => [o, curvedTextStates.get(o)]);
    pushUndo({
      label,
      objects,
      curveStates,
      backgroundColor: canvas.backgroundColor,
    });
  }
  // Exposed so clearCanvas() can record state before wiping.
  window.DGS_snapshotAllForUndo = snapshotAllForUndo;

  document.getElementById("undo-btn")?.addEventListener("click", performUndo);
  refreshUndoButton();

  // --- General Object Controls (STABLE LAYERING) ---
  document.getElementById("delete-btn").addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      const curveState = curvedTextStates.has(activeObject)
        ? [[activeObject, curvedTextStates.get(activeObject)]]
        : [];

      if (curvedTextStates.has(activeObject)) {
        curvedTextStates.delete(activeObject);
      }

      pushUndo({
        label: "delete",
        objects: [activeObject],
        curveStates: curveState,
      });

      canvas.remove(activeObject);
      canvas.discardActiveObject();
      canvas.renderAll();
      handleChangeInCanvas();
    }
  });

  document.getElementById("bring-forward-btn").addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      canvas.bringForward(activeObject);
      // Force complete re-render
      canvas.discardActiveObject();
      canvas.renderAll();
      // canvas.setActiveObject(activeObject);
      canvas.fire("path:created"); // Trigger refresh event
    }
  });

  document.getElementById("send-backward-btn").addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      canvas.sendBackwards(activeObject);
      // Force complete re-render
      canvas.discardActiveObject();
      canvas.renderAll();
      // canvas.setActiveObject(activeObject);
      canvas.fire("path:created"); // Trigger refresh event
    }
  });

  // Center the selected object on the disc, one axis at a time. The canvas
  // centre IS the disc centre (the clip circle is built from canvas.width/2),
  // so no offset is needed.
  //
  // Fabric's centerObjectH/V position by BOUNDING BOX, which is right for an
  // image and wrong for text: the text box is the font metric box, and for
  // curved text it is nearly twice the height of the glyphs with all the slack
  // on top. Box-centred curved text therefore sat ~24 units low on a 360-unit
  // disc. So for text, follow the box centring with a measured correction onto
  // the glyphs themselves - see measureObjectInk.
  function centerActiveObject(axis) {
    const activeObject = canvas.getActiveObject();
    if (!activeObject) return;
    if (axis === "h") {
      canvas.centerObjectH(activeObject);
    } else {
      canvas.centerObjectV(activeObject);
    }
    activeObject.setCoords();

    if (isTextLike(activeObject)) {
      const size = canvas.width;
      const ink = measureObjectInk(activeObject, size);
      if (ink) {
        if (axis === "h") {
          activeObject.left += clampInkNudge(size / 2 - ink.centerX, size);
        } else {
          activeObject.top += clampInkNudge(size / 2 - ink.centerY, size);
        }
        activeObject.setCoords();
      }
      fitHitPaddingToInk(activeObject);
    }

    canvas.renderAll();
    // Programmatic moves fire no object:modified on their own; firing it here
    // runs the text safe-zone clamp, the mini-preview refresh and the dirty
    // flag — the same trio a hand-drag would have triggered.
    canvas.fire("object:modified", { target: activeObject });
  }

  document
    .getElementById("center-h-btn")
    ?.addEventListener("click", () => centerActiveObject("h"));
  document
    .getElementById("center-v-btn")
    ?.addEventListener("click", () => centerActiveObject("v"));

  // Last line of defence against dead clicks in Object Controls: if a shopper
  // taps Delete / a curve preset / a layer button while nothing is selected,
  // don't just no-op. On a phone the canvas has usually scrolled away, so most
  // of these taps are people who can't see that selection was lost. Run in the
  // capture phase, before the per-button handlers:
  //   - exactly one piece of artwork  -> select it (the tap becomes useful and
  //     the controls light up), and swallow this tap so nothing destructive
  //     fires on it; the next tap acts on the now-selected object.
  //   - otherwise -> flash the "Select an object" hint and scroll the disc back
  //     into view, so the tap produces a visible response.
  const objectControlsEl = document.getElementById("object-controls");
  if (objectControlsEl) {
    objectControlsEl.addEventListener(
      "click",
      (e) => {
        const btn = e.target.closest("button");
        if (!btn || btn.disabled) return;
        // Undo and Clear Canvas act on the whole canvas / history, not on a
        // selection, so never intercept them — otherwise this swallowed the tap
        // while nothing was selected and Clear Canvas looked dead.
        if (btn.id === "undo-btn" || btn.id === "clear-canvas-button") return;
        if (canvas.getActiveObject()) return; // normal path — let it through
        const objs = userObjects();
        if (objs.length === 1) {
          canvas.setActiveObject(objs[0]);
          canvas.renderAll();
          updateControls();
        } else {
          noObjectSelected.classList.remove("hidden");
          noObjectSelected.classList.add("dgs-hint-flash");
          setTimeout(
            () => noObjectSelected.classList.remove("dgs-hint-flash"),
            1200
          );
          (wrapper || canvasEl).scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        e.stopImmediatePropagation();
        e.preventDefault();
      },
      true
    );
  }

  let sucessMessageDisappearTime = 1500;

  // Check if canvas has at least one text input or image
  const hasValidObjects = () => {
    let saveDesignBtn = document.getElementById("save-design-btn");
    let saveGuestDesignBtn = document.getElementById("save-guest-design-btn");
    const clearCanvasBtn = document.getElementById("clear-canvas-button");
    const productQuantityHtmlWrapper = document.querySelector(
      ".create_design_product_quantity_html_wrapper"
    );
    const createDesignAddToCartBtn = document.querySelector(
      ".createDesignAddToCartBtn"
    );

    const objects = canvas.getObjects();

    const hasText = objects.some(
      (obj) =>
        ["textbox", "i-text", "text"].includes(obj.type) &&
        obj.text &&
        obj.text.trim() !== ""
    );

    const hasImage = objects.some((obj) => obj.type === "image");

    const bgColor = canvas.backgroundColor;
    const isWhiteBg =
      !bgColor ||
      bgColor === "white" ||
      bgColor === "#ffffff" ||
      bgColor === "rgb(255,255,255)";

    let isValid = hasText || hasImage || !isWhiteBg;

    // These controls are disabled with pointer-events:none, so they can never
    // show a tooltip explaining themselves. State the requirement in the page
    // instead, and only while it is actually unmet.
    const requirementHint = document.getElementById("design-requirement-hint");
    requirementHint?.classList.toggle("hidden", isValid);

    // The quantity stepper is deliberately NOT gated here: quantity does not
    // depend on artwork, and the stepper is seeded from the product page's
    // picker, so locking it (pointer-events:none via disabled-save-btn) just
    // produced dead taps on an empty canvas. Add to Cart keeps the gate.
    productQuantityHtmlWrapper?.classList.remove("disabled-save-btn");

    if (isValid) {
      saveDesignBtn?.classList.remove("disabled-save-btn");
      saveGuestDesignBtn?.classList.remove("disabled-save-btn");
      clearCanvasBtn?.classList.remove("disabled-save-btn");

      createDesignAddToCartBtn?.classList.remove("disabled-save-btn");
    } else {
      saveDesignBtn?.classList.add("disabled-save-btn");
      saveGuestDesignBtn?.classList.add("disabled-save-btn");
      clearCanvasBtn?.classList.add("disabled-save-btn");

      createDesignAddToCartBtn?.classList.add("disabled-save-btn");
    }

    // Only offer the shortcut to the buy bar once there is something to buy;
    // before that it would just invite skipping the design step.
    document
      .getElementById("dgs-jump-to-cart")
      ?.classList.toggle("hidden", !isValid);

    // Drives the "discard your design?" guard in customize-disc-design-1.js and
    // the "this will be replaced" confirm in load-disc-designs.js.
    //
    // The add-image PLACEHOLDER is a canvas object too, so a bare
    // `objects.length > 0` was true on a completely blank disc - both prompts
    // fired when there was nothing to lose. Count only real artwork.
    const realObjects = objects.filter((obj) => obj.isImagePlaceholder !== true);
    window.DGS_hasCanvasWork = realObjects.length > 0 || !isWhiteBg;

    // For the cart-state banner: DGS_hasCanvasWork stays true on a cleared
    // disc because the "Click to Add" placeholders are canvas objects too -
    // the banner must track real design content only.
    window.DGS_canvasHasValidContent = isValid;

    updateCartStateBanner();

    return isValid;
  };

  /**
   * "This design is in your cart" banner (storefront only - the element is
   * not rendered on the Etsy portal). Shown when the canvas still holds work
   * AND a design URL has been committed to the cart form: the canvas
   * deliberately survives an add, and shoppers read the leftover design as
   * "I can only order one design" (or edit it expecting the cart to update).
   * Runs from hasValidObjects(), so it re-evaluates on every canvas change
   * and on every modal open.
   */
  function updateCartStateBanner() {
    const banner = document.getElementById("dgs-cart-state-banner");
    if (!banner) return;

    const url = document.getElementById("disc-design-data-url")?.value || "";
    const committed = url.indexOf("http") === 0;

    // Editing after an add invalidates the post-add confirmation state: the
    // wrapper must offer the real Add to Cart again for the edited design.
    if (window.DGS_canvasDirty === true) window.DGS_hideAddedState?.();

    // While the post-add confirmation is on screen it already says all this.
    const addedStateShowing = !!document.querySelector(
      ".modal-cart-wrapper.dgs-added"
    );

    banner.classList.toggle(
      "hidden",
      !(
        committed &&
        window.DGS_canvasHasValidContent === true &&
        !addedStateShowing
      )
    );

    // Once the canvas differs from the committed design, "THIS design is in
    // your cart" would be false - switch to the variant that says the earlier
    // design is safe and this one will be added as a new disc.
    banner.classList.toggle(
      "dgs-csb-changed",
      window.DGS_canvasDirty === true
    );
  }

  /**
   * Re-evaluates the disabled/hint state on demand.
   *
   * hasValidObjects() otherwise only runs from handleChangeInCanvas(), i.e.
   * after the user changes something - so on a freshly opened, empty canvas
   * the hint explaining why Save and Add to Cart are greyed out stayed hidden
   * at precisely the moment it was most useful. Called by openModal().
   * Guarded because `canvas` is undefined until initializeCanvas() runs.
   */
  window.DGS_refreshDesignValidity = () => {
    if (!canvas) return;
    hasValidObjects();
    // Reopening the modal must not show "Add Your Image" over a disc that
    // already has one - the canvas now survives a save.
    updateSectionSummaries();
  };

  // --- Save Guest Design Selectors---
  const saveGuuestLoadingIndicator = document.getElementById(
    "save-guest-loading-indicator"
  );
  const saveGuestDesignBtn = document.getElementById("save-guest-design-btn");

  // --- Save Design Selectors---
  const saveLoadingIndicator = document.getElementById(
    "save-loading-indicator"
  );
  const saveDesignBtn = document.getElementById("save-design-btn");

  //--- Save as Design Selectors ----
  const saveAsLoadingIndicator = document.getElementById(
    "save-as-loading-indicator"
  );
  const saveAsDesignBtn = document.getElementById("save-as-continue-btn");

  // Enhanced JSON export with complete metadata preservation
  function exportCanvasWithMetadata() {
    // Get base canvas data
    // const canvasData = canvas.toJSON();
    const canvasData = canvas.toJSON(["clipPath"]);

    // Add comprehensive metadata for all objects
    canvasData.objects = canvasData.objects.map((obj, index) => {
      const fabricObj = canvas.getObjects()[index];

      // Base object data with metadata
      let enhancedObj = {
        ...obj,
        // Preserve existing metadata if it exists
        metadata: fabricObj.metadata
          ? {
              ...fabricObj.metadata,
              exportedAt: new Date().toISOString(),
              currentIndex: index,
            }
          : {
              id: generateUniqueId(),
              type: obj.type,
              currentIndex: index,
              exportedAt: new Date().toISOString(),
              category: getObjectCategory(obj.type),
            },
      };

      // Add curve metadata for text objects with paths
      if ((obj.type === "i-text" || obj.type === "textbox") && obj.path) {
        let curveDirection = 0; // up
        let curveRadius = canvas.width * 0.4;
        let curveCenterX = obj.left;
        let curveCenterY = obj.top;

        if (obj.path && obj.path.path) {
          const pathCommands = obj.path.path;

          // Analyze path to extract curve parameters
          for (let i = 0; i < pathCommands.length; i++) {
            const command = pathCommands[i];

            if (command[0] === "M") {
              const startX = command[1];
              const startY = command[2];

              // Look for curve command
              const nextCommand = pathCommands[i + 1];
              if (nextCommand && nextCommand[0] === "C") {
                const endX = nextCommand[5] || nextCommand[3];
                const endY = nextCommand[6] || nextCommand[4];
                const controlY1 = nextCommand[2];
                const controlY2 = nextCommand[4];

                // Calculate curve parameters
                curveCenterX = (startX + endX) / 2;
                curveCenterY = startY;
                curveRadius = Math.abs(endX - startX) / 2;

                // Determine direction
                if (controlY1 < startY || controlY2 < startY) {
                  curveDirection = 1; // down
                }
              }
              break;
            }
          }
        }

        // Add curve metadata
        enhancedObj.curveMetadata = {
          hasCurve: true,
          direction: curveDirection,
          radius: curveRadius,
          centerX: curveCenterX,
          centerY: curveCenterY,
          originalLeft: obj.left,
          originalTop: obj.top,
        };

        // Also add to main metadata
        enhancedObj.metadata.curveInfo = enhancedObj.curveMetadata;
      }

      // Add lock metadata
      if (
        fabricObj.locked ||
        (fabricObj.metadata && fabricObj.metadata.isLocked)
      ) {
        enhancedObj.metadata.lockInfo = {
          isLocked: true,
          storedIndex: fabricObj.metadata
            ? fabricObj.metadata.storedIndex
            : index,
          lockedAt: fabricObj.metadata
            ? fabricObj.metadata.lockedAt
            : new Date().toISOString(),
        };
      }

      // Add type-specific metadata
      if (obj.type === "image") {
        enhancedObj.metadata.imageInfo = {
          originalWidth: fabricObj.width,
          originalHeight: fabricObj.height,
          currentScaleX: fabricObj.scaleX,
          currentScaleY: fabricObj.scaleY,
        };
      }

      if (obj.type === "i-text" || obj.type === "textbox") {
        enhancedObj.metadata.textInfo = {
          originalText: fabricObj.text,
          fontFamily: fabricObj.fontFamily,
          fontSize: fabricObj.fontSize,
          fill: fabricObj.fill,
        };
      }

      return enhancedObj;
    });

    // Add canvas-level metadata
    canvasData.canvasMetadata = {
      exportedAt: new Date().toISOString(),
      totalObjects: canvasData.objects.length,
      canvasWidth: canvas.width,
      canvasHeight: canvas.height,
      backgroundColor: canvas.backgroundColor,
      version: "2.0",
      canvasSize: canvas.width,
      deviceType: window.innerWidth < 768 ? "mobile" : "desktop",
      windowWidth: window.innerWidth,
      fabricVersion: fabric.version,
    };

    return canvasData;
  }

 const checkMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  };

  // Decode a dataURL into an <img> for pixel work. Rejects on decode failure.
  const decodeDataURL = (dataURL) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = dataURL;
    });

  // Print files were always lossless PNG, so a photo-heavy disc exported at
  // 3-7 MB - a 30-60s upload on mobile data, and the payload behind the
  // 2026-08-29 webview save failures (uploads reached S3 but the connection
  // died before the client saw success). When the area INSIDE the disc circle
  // is fully opaque, the same pixels as a q0.92 JPEG are ~10x smaller with no
  // visible print difference at 300 DPI - the wedding/floral/groomsman
  // designers have shipped exactly such white-cornered print JPEGs through
  // the same batch pipeline since August. Any transparency inside the circle
  // keeps PNG so bare-plastic/logo designs never gain a white box behind the
  // art (the concern that deferred this in the 2026-08-11 upload-perf pass).
  // The corners OUTSIDE the circle are transparent by construction (clipPath),
  // so the probe must ignore them - checking the whole frame would always
  // find alpha and JPEG would never trigger.
  const maybeFlattenToJpeg = async (pngDataURL) => {
    try {
      const img = await decodeDataURL(pngDataURL);

      // Probe alpha on a 64px thumbnail, only inside 95% of the disc radius
      // (the inset skips the clip edge's antialiased ring).
      const P = 64;
      const probe = document.createElement("canvas");
      probe.width = P;
      probe.height = P;
      const pctx = probe.getContext("2d", { willReadFrequently: true });
      pctx.drawImage(img, 0, 0, P, P);
      const px = pctx.getImageData(0, 0, P, P).data;
      const c = P / 2;
      const r2 = Math.pow(c * 0.95, 2);
      for (let y = 0; y < P; y++) {
        for (let x = 0; x < P; x++) {
          if (Math.pow(x - c + 0.5, 2) + Math.pow(y - c + 0.5, 2) > r2) continue;
          if (px[(y * P + x) * 4 + 3] < 250) return pngDataURL; // transparency -> keep PNG
        }
      }

      // Fully opaque inside the disc: flatten onto white and re-encode.
      const flat = document.createElement("canvas");
      flat.width = img.naturalWidth;
      flat.height = img.naturalHeight;
      const fctx = flat.getContext("2d");
      fctx.fillStyle = "#ffffff";
      fctx.fillRect(0, 0, flat.width, flat.height);
      fctx.drawImage(img, 0, 0);
      const jpeg = flat.toDataURL("image/jpeg", ASSET_REENCODE_JPEG_QUALITY);
      // A JPEG bigger than its PNG (solid-color art) would be pure loss.
      return jpeg.length < pngDataURL.length ? jpeg : pngDataURL;
    } catch (e) {
      // Decode/probe trouble -> old behavior, never block the save.
      console.warn("Print-file JPEG flatten skipped:", e);
      return pngDataURL;
    }
  };

  // Upload name matching the export's actual format, so the S3 key and
  // Content-Type agree with the bytes.
  const previewUploadName = (blob) =>
    blob && blob.type === "image/jpeg" ? "preview.jpg" : "preview.png";

  const exportCanvasImage = async () => {
    let isMobileDevice = checkMobileDevice();
    // Store original state
    const originalClipPath = canvas.clipPath;
    const originalWidth = canvas.width;
    const originalHeight = canvas.height;

    // Store object positions
    const objectStates = canvas.getObjects().map((obj) => ({
      obj: obj,
      left: obj.left,
      top: obj.top,
    }));

    // Expand canvas 2x
    const expansionFactor = isMobileDevice ? 4 : 3; // 4x for mobile, 3x for web
    // The print file is always PRINT_MAX_EDGE (2400px = 8" at 300 DPI) across,
    // whatever size the canvas has on screen. The old fixed 6x/4x multiplier
    // made print resolution track the customer's screen: canvases squeezed to
    // ~120-180px exported 708-750px files from 2400px photos (#22385, #22399,
    // ~90 DPI) while desktop gave 2000px. Photos are drawn from their full-res
    // source and text is vector, so a larger multiplier adds real detail.
    const exportMultiplier = PRINT_MAX_EDGE / Math.max(1, originalWidth);
    const newWidth = originalWidth * expansionFactor;
    const newHeight = originalHeight * expansionFactor;
    const offset = (newWidth - originalWidth) / 2;

    // Resize canvas
    canvas.setWidth(newWidth);
    canvas.setHeight(newHeight);

    // Create new expanded circular clip path
    const expandedClipPath = new fabric.Circle({
      radius: originalWidth / 2, // Keep original circle size
      left: newWidth / 2,
      top: newHeight / 2,
      originX: "center",
      originY: "center",
      absolutePositioned: true,
    });

    canvas.clipPath = expandedClipPath;

    // Reposition objects to center
    objectStates.forEach((state) => {
      state.obj.set({
        left: state.left + offset,
        top: state.top + offset,
      });
      state.obj.setCoords();
    });

    canvas.renderAll();

    // Export the original region at high resolution
    const dataURL = canvas.toDataURL({
      format: "png",
      quality: 1.0,
      multiplier: exportMultiplier,
      left: offset,
      top: offset,
      width: originalWidth,
      height: originalHeight,
    });

    // Restore canvas
    canvas.setWidth(originalWidth);
    canvas.setHeight(originalHeight);

    objectStates.forEach((state) => {
      state.obj.set({
        left: state.left,
        top: state.top,
      });
      state.obj.setCoords();
    });

    canvas.clipPath = originalClipPath;
    canvas.renderAll();

    return maybeFlattenToJpeg(dataURL);
  };

  // Save Guest function
  const saveGuestDesignFunction = async (targetBtn) => {
    let saveGustBtnLable = "save-guest-design";
    try {
      const assetContainer = targetBtn
        .closest(".customize-disc-container")
        .querySelector(".disc-assets-container");
      // A desynced/zero-sized canvas exports 'data:,' and the save dies with
      // an unreadable TypeError (seen in in-app webviews where layout/rAF
      // stall). Re-assert the size from the wrapper before exporting.
      if (canvas.getWidth() < 10) {
        resyncCanvasSize();
      }
      canvas.discardActiveObject();
      canvas.renderAll();

      // Export with full metadata
      const canvasDataWithMetadata = exportCanvasWithMetadata();

      // Save JSON string of canvas with metadata
      const json = JSON.stringify(canvasDataWithMetadata);

      discDesign.json = json;
      discDesign.type = "json";

      const revAtExport = window.DGS_canvasRev;
      const dataURL = await exportCanvasImage();

      let id = window.generateUniqueId();

      // Disable save btns and show the save-btn loader
      // enableDisableSaveBtns(true, saveGustBtnLable);
      // create function is called
      result = await saveDesignAsGuestInDB(dataURL);

      // Enable save btns and hide the save-btn loader
      // enableDisableSaveBtns(false, saveGustBtnLable);

      let { status, message, imageURL, assets } = result || {};

      let saveGuestConfirmMsg = document.getElementById(
        "save-guest-confirm-msg"
      );
      // Handling response for add  case start here
      if (result.status === true) {

        // --- PORTAL HANDOFF SAFETY START ---
// On the Etsy design portal, never fall back to the normal storefront
// "View the created design" flow. If the portal submit hook is missing,
// show a clear error instead of creating a false-success state.
const isEtsyPortalFlow =
    window.DGS_PORTAL_MODE === true ||
    typeof window.DGS_SubmitDesign === "function" ||
    new URLSearchParams(window.location.search).has("etsy");

if (isEtsyPortalFlow) {
    if (typeof window.DGS_SubmitDesign !== "function") {
        console.error("❌ [Portal] DGS_SubmitDesign missing after design upload.", {
            imageURL
        });

        if (saveGuestConfirmMsg) {
            saveGuestConfirmMsg.classList.remove("hidden", "text-green-700");
            saveGuestConfirmMsg.classList.add("text-red-700");
            saveGuestConfirmMsg.innerHTML =
                "Your design image uploaded, but we could not submit it to your order. Please refresh the page and try again.";
        }

        alert(
            "Your design image uploaded, but we could not submit it to your order. Please refresh the page and try again."
        );

        enableDisableSaveBtns(false, saveGustBtnLable);
        return;
    }

    console.log("✅ Upload Complete. Handing off URL to Portal:", imageURL);
    await window.DGS_SubmitDesign(imageURL);

    // Re-enable buttons locally so they aren't stuck disabled if the user comes back
    enableDisableSaveBtns(false, saveGustBtnLable);
    return; // Do not show the normal storefront preview UI.
}
// --- PORTAL HANDOFF SAFETY END ---
        
        uploadProgress.finish();
        addUnqiueValueInProductProperty();
        // Save the canvas assets
        if (Array.isArray(assets) && assets.length > 0) {
          addValuesToAssetContainer(assetContainer, assets);
        }
        const viewPreviewWrapper = document.getElementById("view-disc-design-preview-wrapper");
        if (viewPreviewWrapper) {
          viewPreviewWrapper.classList.remove("tw-hidden", "hidden");
        }
        // Update the latest image url in hidden input
        document.getElementById("disc-design-data-url").value = imageURL;

        document.getElementById("disc-design-data-url-type").value = "Internal";
        if (window.DGS_canvasRev === revAtExport) window.DGS_canvasDirty = false;
        uploadThumbnailQuietly(dataURL);

        saveGuestConfirmMsg.classList.add("text-green-700");

        saveGuestConfirmMsg.innerHTML =
          " Design link is generated! Continuing to the next step...";

        clearSelectedDesigns();
        window.resetAndRefethDesigns();
      } else {
        uploadProgress.fail();
        saveGuestConfirmMsg.classList.add("text-red-700");
        // was written into #save-as-continue-msg, which only exists for
        // logged-in customers — for guests that crashed with a null
        // innerHTML error and swallowed the real failure reason
        saveGuestConfirmMsg.innerHTML =
          message || "Something went wrong uploading your design. Please try again.";
        showRetryOption(saveGuestConfirmMsg, targetBtn);
      }

      saveGuestConfirmMsg.classList.remove("hidden");
      // Success: swap to the "added to cart" fork and keep the modal open
      // behind the cart drawer (close it only where that markup is missing).
      // Failure keeps the modal open too, so the error stays readable.
      if (status === true) {
        setTimeout(() => {
          saveGuestConfirmMsg.classList.add("hidden");
          if (!window.DGS_showAddedState()) window.closeModal();
        }, sucessMessageDisappearTime);
      }
    } catch (error) {
      console.log("Error on saving the design : ", error);
      // surface it — a silent failure here left customers stuck with no clue
      uploadProgress.fail();
      var guestErrMsg = document.getElementById("save-guest-confirm-msg");
      if (guestErrMsg) {
        guestErrMsg.classList.remove("hidden", "text-green-700");
        guestErrMsg.classList.add("text-red-700");
        guestErrMsg.innerHTML =
          "Something went wrong preparing your design. Please try again — if it keeps happening, refresh the page or open this site in your regular browser." +
          (error && error.message ? " (" + String(error.message).slice(0, 120) + ")" : "");
        showRetryOption(guestErrMsg, targetBtn);
      }
    } finally {
      // Disable save btns and show the save-btn loader
      enableDisableSaveBtns(false, saveGustBtnLable);
    }
  };

  // --- Save Guest Design ---
  saveGuestDesignBtn?.addEventListener("click", (event) => {
    const targetBtn = event.currentTarget;
    enableDisableSaveBtns(true, "save-guest-design"); // disable instantly
    // queue after current stack, but don't wait for a full animation frame
    setTimeout(() => saveGuestDesignFunction(targetBtn), 0);
  });

  // --- Save  Design ---
  const saveDesignFunction = async (targetBtn) => {
    try {     
      const assetContainer = targetBtn
        .closest(".customize-disc-container")
        .querySelector(".disc-assets-container");

      // check user is logged in or not
      if (
        window.ShopifyCustomerLoggedIn !== true &&
        window.ShopifyCustomerLoggedIn !== "true"
      ) {
        if (
          confirm(
            "You need to log in to save your design. Would you like to log in now?"
          )
        ) {
          window.location.href = window.ShopifyLoginUrl;
        }
        return;
      }

      document.getElementById("save-confirm-msg").innerHTML = "";
      document.getElementById("save-confirm-msg").classList.remove("hidden");
      if (!hasValidObjects()) {
        let message =
          "Please add text, image, or change background color before saving your design.";
        document
          .getElementById("save-confirm-msg")
          .classList.add("text-red-700");
        document.getElementById("save-confirm-msg").innerHTML = message;
        return false;
      }
      canvas.discardActiveObject();
      canvas.renderAll();

      // Export with full metadata
      const canvasDataWithMetadata = exportCanvasWithMetadata();

      // Save JSON string of canvas with metadata
      const json = JSON.stringify(canvasDataWithMetadata);

      discDesign.json = json;
      discDesign.type = "json";

      const dataURL = await exportCanvasImage();

      // let check design is edited.
      let previousDesigns = window.previousDesigns;
      let designIndex = previousDesigns.findIndex((item) => {
        return item.id === canvas.meta.designId;
      });

      let latestImageUrl = "";
      document.getElementById("save-confirm-msg").innerHTML = "";
      document.getElementById("save-confirm-msg").classList.remove("hidden");
      document
        .getElementById("save-confirm-msg")
        .classList.remove("text-green-700");
      document
        .getElementById("save-confirm-msg")
        .classList.remove("text-red-700");

      let isDesignEdited = false;
      let result;
      let responseMessage = "";

      // Disable save btns and show the save-btn loader
      // enableDisableSaveBtns(true, "save-btn");

      // Design is being edited
      if (designIndex !== -1) {
        isDesignEdited = true;
        previousDesigns[designIndex] = {
          id: canvas.meta.designId,
          src: dataURL,
          json,
        };

        // Update function  called
        result = await updateDesignInDB(canvas.meta.designId, json, dataURL);

        // Enable save btns and hide the save-btn loader
        // enableDisableSaveBtns(false, "save-btn");

        let { status, message, imageURL, assets } = result || {};
        successMessage =
          "Design updated! You can now add the product to your cart.";
        latestImageUrl = imageURL;
        responseMessage = message;
        setTimeout(() => {
          clearSelectedDesigns();
          window.previousDesigns = previousDesigns;
          window.loadPreviousDesign(previousDesigns);
        }, 400);
      } else {
        // New Design is being created

        // let id = window.generateUniqueId();
        // previousDesigns.push({ id, src: dataURL, json });

        // create function is called
        result = await saveDesignInDB(json, dataURL);

        // Enable save btns and hide the save-btn loader
        // enableDisableSaveBtns(false, "save-btn");

        let { status, message, imageURL, assets } = result || {};
        successMessage =
          "Design saved! You can now add the product to your cart.";
        latestImageUrl = imageURL;
        responseMessage = message;
      }

      // Handling response for add and edit case start here
      const { status, message, imageURL, assets } = result || {};
      if (status === true) {
  // --- ETSY PORTAL HANDOFF FOR LOGGED-IN USERS START ---
  // If a logged-in Shopify customer opens an Etsy portal link,
  // this function is used instead of the guest save function.
  // In portal mode, submit the saved image back to the Etsy order
  // and never show the normal "View the created design" flow.
  const isEtsyPortalFlow =
    window.DGS_PORTAL_MODE === true ||
    new URLSearchParams(window.location.search).has("etsy");

  if (isEtsyPortalFlow) {
    const portalImageURL = imageURL || latestImageUrl;

    if (!portalImageURL) {
      const debugCode = `DGS-PORTAL-MISSING-IMAGE-${Date.now()}`;

      console.error("❌ [Portal] Missing image URL after logged-in save.", {
        debugCode,
        result
      });

      document
        .getElementById("save-confirm-msg")
        .classList.remove("text-green-700");

      document
        .getElementById("save-confirm-msg")
        .classList.add("text-red-700");

      document.getElementById("save-confirm-msg").innerHTML =
        `Your design was saved, but we could not submit it to your Etsy order. Please refresh and try again. If it keeps happening, contact us and include this code: ${debugCode}`;

      return;
    }

    if (typeof window.DGS_SubmitDesign !== "function") {
      const debugCode = `DGS-PORTAL-HOOK-MISSING-${Date.now()}`;

      console.error("❌ [Portal] DGS_SubmitDesign missing after logged-in save.", {
        debugCode,
        portalImageURL
      });

      document
        .getElementById("save-confirm-msg")
        .classList.remove("text-green-700");

      document
        .getElementById("save-confirm-msg")
        .classList.add("text-red-700");

      document.getElementById("save-confirm-msg").innerHTML =
        `Your design was saved, but we could not submit it to your Etsy order. Please refresh and try again. If it keeps happening, contact us and include this code: ${debugCode}`;

      return;
    }

    try {
      console.log("✅ Logged-in portal save complete. Handing off URL to Portal:", portalImageURL);
      await window.DGS_SubmitDesign(portalImageURL);
      return;
    } catch (portalSubmitError) {
      const debugCode = `DGS-PORTAL-SUBMIT-FAILED-${Date.now()}`;

      console.error("❌ [Portal] Logged-in portal submit failed.", {
        debugCode,
        portalImageURL,
        portalSubmitError
      });

      document
        .getElementById("save-confirm-msg")
        .classList.remove("text-green-700");

      document
        .getElementById("save-confirm-msg")
        .classList.add("text-red-700");

      document.getElementById("save-confirm-msg").innerHTML =
        `Your design was saved, but we could not submit it to your Etsy order. Please refresh and try again. If it keeps happening, contact us and include this code: ${debugCode}`;

      return;
    }
  }
  // --- ETSY PORTAL HANDOFF FOR LOGGED-IN USERS END ---

  uploadProgress.finish();
  addUnqiueValueInProductProperty();
        // Save the canvas assets
        if (Array.isArray(assets) && assets.length > 0) {
          addValuesToAssetContainer(assetContainer, assets);
        }

        // Show the image preview btn
        const viewPreviewWrapper = document.getElementById("view-disc-design-preview-wrapper");
        if (viewPreviewWrapper) {
          viewPreviewWrapper.classList.remove("tw-hidden", "hidden");
        }
        document.getElementById("disc-design-data-url").value = latestImageUrl;
        document.getElementById("disc-design-data-url-type").value = "Internal";
        // fresh export just uploaded — generate the matching cart thumbnail
        uploadThumbnailQuietly(dataURL);

        document
          .getElementById("save-confirm-msg")
          .classList.add("text-green-700");

        document.getElementById("save-confirm-msg").innerHTML = successMessage;

        // The canvas is deliberately left intact. Wiping it here meant that
        // reopening the customizer showed a blank disc instead of the design
        // the customer had just saved, which read as data loss. Keeping the
        // live canvas also avoids round-tripping the design through the JSON
        // rehydration path, so the artwork cannot drift on the way back.
        // "Clear Canvas" remains available for starting over.

        if (isDesignEdited === false) {
          clearSelectedDesigns();
          window.resetAndRefethDesigns();
        }
      } else {
        uploadProgress.fail();
        document
          .getElementById("save-confirm-msg")
          .classList.add("text-red-700");
        document.getElementById("save-confirm-msg").innerHTML = responseMessage;
        showRetryOption(document.getElementById("save-confirm-msg"), targetBtn);
      }

      // Close the modal and hide the status message
      setTimeout(() => {
        document.getElementById("save-confirm-msg").classList.add("hidden");
        window.closeModal();
      }, sucessMessageDisappearTime);

      // Handling response for add and edit case end here
    } catch (error) {
      console.log("Error on saving the design : ", error);
    } finally {
      // Disable save btns and show the save-btn loader
      enableDisableSaveBtns(false, "save-btn");
    }
  };

  // Add to Cart for a LOGGED-IN customer: upload the artwork the order needs
  // (preview + assets, same as the guest path) but create NO saved-design
  // record — saving is the explicit Save button's job. Before this, every
  // logged-in add-to-cart wrote a row to Saved Designs (or silently UPDATED
  // a loaded saved design), which the owner did not want (2026-08-08).
  const attachDesignForCart = async (targetBtn) => {
    try {
      const assetContainer = targetBtn
        .closest(".customize-disc-container")
        .querySelector(".disc-assets-container");
      const msg = document.getElementById("save-confirm-msg");
      msg.innerHTML = "";
      msg.classList.remove("hidden", "text-green-700", "text-red-700");
      if (!hasValidObjects()) {
        msg.classList.add("text-red-700");
        msg.innerHTML =
          "Please add text, image, or change background color before saving your design.";
        return false;
      }
      if (canvas.getWidth() < 10) {
        resyncCanvasSize();
      }
      canvas.discardActiveObject();
      canvas.renderAll();

      const revAtExport = window.DGS_canvasRev;
      const dataURL = await exportCanvasImage();
      // uploads preview + assets to S3 only — no DB record, despite the name
      const result = await saveDesignAsGuestInDB(dataURL);

      if (result.status === true) {
        uploadProgress.finish();
        const { imageURL, assets } = result;
        addUnqiueValueInProductProperty();
        if (Array.isArray(assets) && assets.length > 0) {
          addValuesToAssetContainer(assetContainer, assets);
        }
        const viewPreviewWrapper = document.getElementById(
          "view-disc-design-preview-wrapper"
        );
        if (viewPreviewWrapper) {
          viewPreviewWrapper.classList.remove("tw-hidden", "hidden");
        }
        document.getElementById("disc-design-data-url").value = imageURL;
        document.getElementById("disc-design-data-url-type").value = "Internal";
        if (window.DGS_canvasRev === revAtExport) window.DGS_canvasDirty = false;
        uploadThumbnailQuietly(dataURL);

        msg.classList.add("text-green-700");
        msg.innerHTML = " Design attached! Adding it to your cart...";
      } else {
        uploadProgress.fail();
        msg.classList.add("text-red-700");
        msg.innerHTML = result.message || "Something went wrong. Please try again.";
        showRetryOption(msg, targetBtn);
      }

      // Success: swap to the "added to cart" fork and keep the modal open
      // behind the cart drawer. Keep the error readable otherwise.
      if (result.status === true) {
        setTimeout(() => {
          msg.classList.add("hidden");
          if (!window.DGS_showAddedState()) window.closeModal();
        }, sucessMessageDisappearTime);
      }
    } catch (error) {
      console.log("Error attaching the design for cart: ", error);
      uploadProgress.fail();
      var attachErrMsg = document.getElementById("save-confirm-msg");
      if (attachErrMsg) {
        attachErrMsg.classList.remove("hidden", "text-green-700");
        attachErrMsg.classList.add("text-red-700");
        attachErrMsg.innerHTML =
          "Something went wrong preparing your design. Please try again — if it keeps happening, refresh the page or open this site in your regular browser." +
          (error && error.message ? " (" + String(error.message).slice(0, 120) + ")" : "");
        showRetryOption(attachErrMsg, targetBtn);
      }
    } finally {
      enableDisableSaveBtns(false, "save-btn");
    }
  };

  saveDesignBtn?.addEventListener("click", (event) => {
    const targetBtn = event.currentTarget;
    enableDisableSaveBtns(true, "save-btn"); // disable instantly
    
    // queue after current stack, but don't wait for a full animation frame
    setTimeout(() => saveDesignFunction(targetBtn), 0);
  });

  // Export images separately
  // Print ceiling: an 8" disc printed at 300 DPI needs at most 8 * 300 = 2400px
  // on the long edge. Anything larger is beyond what the press can reproduce,
  // so we downscale to this cap to shrink the upload with zero visible quality
  // loss. Images at or under the cap are uploaded at their native resolution.
  const PRINT_MAX_EDGE = 8 * 300; // 2400px
  // JPEG quality for the re-encode path (downscaled images, or sources with no
  // stashed File — AI-generated / reloaded / WebP/GIF/BMP/SVG). Visually
  // lossless at print size.
  const ASSET_REENCODE_JPEG_QUALITY = 0.92;

  // Cheap transparency probe on a downscaled copy. Logo transparency is made
  // of large regions and survives downsampling, so a 128px test image is
  // enough to decide JPEG (opaque) vs PNG (has alpha) without scanning a
  // full-resolution photo. Returns true (→ keep PNG) on any error so we never
  // accidentally flatten a transparent logo onto a solid box.
  function assetHasTransparency(sourceEl) {
    try {
      const TEST = 128;
      const w = sourceEl.naturalWidth || sourceEl.width || 0;
      const h = sourceEl.naturalHeight || sourceEl.height || 0;
      if (!w || !h) return true;
      const s = Math.min(1, TEST / Math.max(w, h));
      const tc = document.createElement("canvas");
      tc.width = Math.max(1, Math.round(w * s));
      tc.height = Math.max(1, Math.round(h * s));
      const tctx = tc.getContext("2d");
      tctx.drawImage(sourceEl, 0, 0, tc.width, tc.height);
      const data = tctx.getImageData(0, 0, tc.width, tc.height).data;
      for (let i = 3; i < data.length; i += 4) {
        if (data[i] < 250) return true;
      }
      return false;
    } catch (e) {
      return true;
    }
  }

  function exportAssetsImages() {
    let images = [];

    const canvasObjects = canvas.getObjects();

    const imageObjects = canvasObjects.filter(
      (obj) =>
        obj.type === "image" && (obj.id || (obj.metadata && obj.metadata.id))
    );

    imageObjects.forEach((imgObj, index) => {
      const el = imgObj.getElement();

      // Native source pixel dimensions of the *uploaded* image (rotation/scale
      // live in canvas.json and are re-applied at render time).
      const srcW = el.naturalWidth || imgObj.width || 0;
      const srcH = el.naturalHeight || imgObj.height || 0;
      if (!srcW || !srcH) return;

      // Only downscale the part that exceeds 300 DPI for an 8" disc; never
      // upscale. At/under the cap, keep the customer's exact resolution.
      const maxEdge = Math.max(srcW, srcH);
      const needsDownscale = maxEdge > PRINT_MAX_EDGE;

      const meta = imgObj.metadata || {};
      let originalBlob = null;
      let uploadExt = "png";

      const srcFile = imgObj._dgsSourceFile;
      if (
        !needsDownscale &&
        srcFile &&
        (srcFile.type === "image/jpeg" || srcFile.type === "image/png")
      ) {
        // Best case: already within the print ceiling → upload the customer's
        // exact bytes. Full native resolution, zero recompression. A JPEG photo
        // stays its already-small self instead of being inflated into a
        // 15–30 MB lossless PNG (the old behaviour, and the main cause of slow
        // mobile Add-to-Cart).
        originalBlob = srcFile;
        uploadExt = srcFile.type === "image/png" ? "png" : "jpg";
      } else {
        // Re-encode via a canvas. This covers two cases:
        //   1. maxEdge > 2400px → downscale to the print ceiling (smaller upload,
        //      no visible loss at 300 DPI on an 8" disc).
        //   2. No stashed File (AI-generated / reloaded / WebP/GIF/BMP/SVG) →
        //      render at native size.
        // JPEG when the image is opaque (huge saving vs PNG); PNG when it has
        // any transparency, so logos never get a solid box behind them.
        const scale = Math.min(1, PRINT_MAX_EDGE / maxEdge);
        const outW = Math.max(1, Math.round(srcW * scale));
        const outH = Math.max(1, Math.round(srcH * scale));
        const outCanvas = document.createElement("canvas");
        outCanvas.width = outW;
        outCanvas.height = outH;
        outCanvas.getContext("2d").drawImage(el, 0, 0, outW, outH);

        if (assetHasTransparency(el)) {
          originalBlob = dataURLtoBlob(outCanvas.toDataURL("image/png"));
          uploadExt = "png";
        } else {
          originalBlob = dataURLtoBlob(
            outCanvas.toDataURL("image/jpeg", ASSET_REENCODE_JPEG_QUALITY)
          );
          uploadExt = "jpg";
        }
      }

      // Clean base name (strip any existing image extension) so the upload
      // loops append the *correct* extension instead of "photo.jpg.png".
      const rawName =
        meta.originalFileName ||
        meta.fileName ||
        imgObj.fileName ||
        `image_${index + 1}`;
      const originalFileName = String(rawName).replace(
        /\.(jpe?g|png|gif|webp|bmp|svg|heic|heif|pdf)$/i,
        ""
      );

      images.push({
        id: meta.id || imgObj.id,
        originalFileName: originalFileName,
        uploadExt: uploadExt,
        originalBlob: originalBlob, // ← native-resolution Blob for upload
        position: {
          left: imgObj.left,
          top: imgObj.top,
        },
        dimensions: {
          width: imgObj.width * imgObj.scaleX,
          height: imgObj.height * imgObj.scaleY,
          originalWidth: imgObj.width,
          originalHeight: imgObj.height,
        },
        transforms: {
          scaleX: imgObj.scaleX,
          scaleY: imgObj.scaleY,
          angle: imgObj.angle,
          skewX: imgObj.skewX,
          skewY: imgObj.skewY,
        },
      });
    });

    return images;
  }

  function addValuesToAssetContainer(container, values) {
    container.innerHTML = "";
    let valuesString = values.join(",");
    let input = document.createElement("input");
    input.type = "hidden";
    input.name = "properties[_DGS Design Assets]";
    input.value = valuesString;
    container.appendChild(input);
  }

  // Utility: Convert dataURL to Blob
  function dataURLtoBlob(dataurl) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  }

  // Helper: simple threshold (10MB)
  const CHUNK_THRESHOLD = 20 * 1024 * 1024;
  const CHUNK_SIZE = 5 * 1024 * 1024;

  // --- helper: same-origin rescue upload ---
  // The direct paths below PUT straight to *.amazonaws.com - a cross-origin
  // request that some in-app browsers (Android "wv", FB/IG, the Google app)
  // refuse, while same-origin traffic through the app proxy keeps working:
  // that exact split stranded a customer for 45 minutes on 2026-08-29 with
  // "(Failed to fetch)" on every save. The backend's /save-as-guest-design
  // accepts the file itself and does the S3 upload server-side, so route the
  // bytes through discgolfswag.com instead. Rescue only - the direct path
  // stays primary because the proxy adds a server round-trip per file.
  // The response's imageURL basename IS the S3 object name (both the presign
  // and guest-save backends build `uploads/<fileName>` the same way), which
  // /save-design and /update-design need back as canvas_json/preview_image.
  async function sameOriginRescueUpload(file, filename, product_name, user_name) {
    const fd = new FormData();
    fd.append(
      "preview_image",
      new File([file], filename || "preview.png", {
        type: file.type || "image/png",
      })
    );
    // Always send both: the live server stringifies missing fields into a
    // literal "undefined_undefined_..." S3 name instead of defaulting.
    fd.append("product_name", product_name || "disc");
    fd.append("user_name", user_name || "guest");
    const resp = await fetch(
      `${DGSAppBaseUrl}/disc-designs/save-as-guest-design`,
      { method: "POST", body: fd }
    );
    if (!resp.ok)
      throw new Error("Rescue upload failed (HTTP " + resp.status + ")");
    const json = await resp.json();
    const imageURL = json && json.data && json.data.imageURL;
    if (!json.status || !imageURL)
      throw new Error((json && json.message) || "Rescue upload failed");
    return { publicUrl: imageURL, fileName: imageURL.split("/").pop() };
  }

  // --- helper: upload via multipart ---
  async function uploadInChunks(
    file,
    filename,
    product_name = undefined,
    user_name = undefined
  ) {
    try {
      return await uploadInChunksDirect(file, filename, product_name, user_name);
    } catch (err) {
      console.warn("Direct chunked upload failed, retrying via app proxy:", err);
      return await sameOriginRescueUpload(file, filename, product_name, user_name);
    }
  }

  async function uploadInChunksDirect(
    file,
    filename,
    product_name = undefined,
    user_name = undefined
  ) {
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

    // 1️⃣ Ask backend to start multipart upload
    const startRes = await fetch(
      `${DGSAppBaseUrl}/disc-designs/multipart-upload/start`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filename,
          fileType: file.type || "image/png",
          totalChunks,
          product_name,
          user_name,
        }),
      }
    );
    const { data, status } = await startRes.json();
    if (!status) throw new Error("Failed to start multipart upload");

    const { uploadId, presignedUrls, key, publicUrl, fileName } = data;

    // 2️⃣ Upload chunks sequentially
    const parts = [];
    for (let i = 0; i < presignedUrls.length; i++) {
      const start = i * CHUNK_SIZE;
      const end = Math.min(file.size, start + CHUNK_SIZE);
      const chunk = file.slice(start, end);

      const uploadResp = await fetch(presignedUrls[i], {
        method: "PUT",
        body: chunk,
      });

      if (!uploadResp.ok) throw new Error(`Chunk ${i + 1} failed`);
      const eTag = uploadResp.headers.get("ETag")?.replace(/"/g, "");
      parts.push({ ETag: eTag, PartNumber: i + 1 });
    }

    // 3️⃣ Tell backend to complete upload
    const completeRes = await fetch(
      `${DGSAppBaseUrl}/disc-designs/multipart-upload/complete`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uploadId, key, parts }),
      }
    );

    const completeData = await completeRes.json();
    if (!completeData.status) throw new Error("Failed to complete upload");
    return { publicUrl: completeData.publicUrl, fileName };
  }

  // --- helper: simple single PUT upload ---
  async function simpleUpload(
    file,
    filename,
    product_name = undefined,
    user_name = undefined
  ) {
    try {
      return await simpleUploadDirect(file, filename, product_name, user_name);
    } catch (err) {
      console.warn("Direct S3 upload failed, retrying via app proxy:", err);
      return await sameOriginRescueUpload(file, filename, product_name, user_name);
    }
  }

  async function simpleUploadDirect(
    file,
    filename,
    product_name = undefined,
    user_name = undefined
  ) {
    let fileType = file.type || "image/png";
    let getPresignedUrl = `${DGSAppBaseUrl}/disc-designs/get-presigned-url?filename=${filename}&fileType=${fileType}`;
    if (product_name && user_name) {
      getPresignedUrl += `&product_name=${product_name}&user_name=${user_name}`;
    }
    const res = await fetch(getPresignedUrl);
    const { data, status, error } = await res.json();
    if (!status) throw new Error(error || "Failed to get upload URL");

    const { uploadUrl, publicUrl, fileName } = data;
    const putResp = await fetch(uploadUrl, {
      method: "PUT",
      headers: { "Content-Type": fileType },
      body: file,
    });

    if (!putResp.ok) throw new Error("Upload failed (HTTP " + putResp.status + ")");
    return { publicUrl, fileName };
  }

  // 240px round PNG cut from the print file, transparent outside the disc
  // like the old live-canvas thumb (a JPEG print file has white corners).
  const thumbFromPrintFile = async (printDataURL) => {
    const img = await decodeDataURL(printDataURL);
    const S = 240;
    const c = document.createElement("canvas");
    c.width = S;
    c.height = S;
    const ctx = c.getContext("2d");
    ctx.beginPath();
    ctx.arc(S / 2, S / 2, S / 2, 0, Math.PI * 2);
    ctx.clip();
    ctx.drawImage(img, 0, 0, S, S);
    return dataURLtoBlob(c.toDataURL("image/png"));
  };

  // Cosmetic only: uploads a ~240px copy of the design for the cart drawer's
  // line thumbnail (properties[_Disc Design Thumb]), which also shows in the
  // order confirmation email.
  // Fire-and-forget: never awaited by the save flow and never throws — the
  // drawer falls back to the full-size Disc Design Url when this is empty.
  //
  // Pass the print file's dataURL. The thumb must be cut from the exact file
  // production gets, never from the live canvas: the canvas stays editable
  // while the save uploads, so a live render can show edits the print file
  // never received (order #22438: thumb green, print file white).
  function uploadThumbnailQuietly(printDataURL) {
    const thumbInput = document.getElementById("disc-design-thumb-url");
    if (!thumbInput) return;
    thumbInput.value = "";
    try {
      let thumbBlobPromise;
      if (printDataURL) {
        thumbBlobPromise = thumbFromPrintFile(printDataURL);
      } else {
        const logicalW = canvas.getWidth() || 300;
        const mult = Math.min(1, 240 / logicalW);
        const thumbDataURL = canvas.toDataURL({ format: "png", multiplier: mult });
        thumbBlobPromise = Promise.resolve(dataURLtoBlob(thumbDataURL));
      }
      const product_name = (
        document.getElementById("disc-product-name")?.value || ""
      )
        .toLowerCase()
        .replace(/\s+/g, "_");
      const user_name = (document.getElementById("disc-user-name")?.value || "")
        .toLowerCase()
        .replace(/-/g, "_");
      // Exposed so the modal Add to Cart can wait for it: a line posted with
      // an empty thumb never merges with a later, identical add whose thumb
      // has filled in by then (the properties differ).
      window.DGS_thumbUploadPromise = thumbBlobPromise
        .then(function (thumbBlob) {
          return simpleUpload(thumbBlob, "thumb.png", product_name, user_name);
        })
        .then(function (res) {
          if (res && res.publicUrl) thumbInput.value = res.publicUrl;
        })
        .catch(function (err) {
          console.warn("Design thumb upload skipped:", err);
        });
    } catch (err) {
      window.DGS_thumbUploadPromise = null;
      console.warn("Design thumb export skipped:", err);
    }
  }


  async function saveDesignInDB(json, dataURL) {
    const jsonBlob = new Blob([JSON.stringify(json)], {
      type: "application/json",
    });
    const imageBlob = dataURLtoBlob(dataURL);

    let product_name = (
      document.getElementById("disc-product-name")?.value || ""
    )
      .toLowerCase()
      .replace(/\s+/g, "_");
    let user_name = (document.getElementById("disc-user-name")?.value || "")
      .toLowerCase()
      .replace(/-/g, "_");
    
    const uploadedFiles = [];

    try {
      // 1️⃣ Upload JSON
      const { publicUrl: jsonURL, fileName: jsonFileName } =
        jsonBlob.size > CHUNK_THRESHOLD
          ? await uploadInChunks(jsonBlob, "canvas.json")
          : await simpleUpload(jsonBlob, "canvas.json");

      // 2️⃣ Upload preview image
      const { publicUrl: imageURL, fileName: imageFileName } =
        imageBlob.size > CHUNK_THRESHOLD
          ? await uploadInChunks(
              imageBlob,
              previewUploadName(imageBlob),
              product_name,
              user_name
            )
          : await simpleUpload(
              imageBlob,
              previewUploadName(imageBlob),
              product_name,
              user_name
            );

      // 3️⃣ Upload asset images
      const assetImages = exportAssetsImages();
      for (let i = 0; i < assetImages.length; i++) {
        const img = assetImages[i];
        if (!img.originalBlob) continue;

        const filename = `${img.originalFileName || `asset_${i + 1}`}.${
          img.uploadExt || "png"
        }`;
        const { publicUrl: assetURL, fileName: assetFileName } =
          img.originalBlob.size > CHUNK_THRESHOLD
            ? await uploadInChunks(img.originalBlob, filename)
            : await simpleUpload(img.originalBlob, filename);

        uploadedFiles.push({ filename: assetFileName, url: assetURL });
      }

      // 4️⃣ Prepare JSON payload
      const payload = {
        email: window.ShopifyCustomerEmail || "",
        canvas_json: jsonFileName,
        preview_image: imageFileName,
        assetsFiles: uploadedFiles.map((asset) => asset.filename),
      };
      // 5️⃣ Send to backend
      const response = await fetch(
        `${DGSAppBaseUrl}/disc-designs/save-design`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) throw new Error(`Server error: ${response.status}`);

      const result = await response.json();
      let returnResponse = {
        status: true,
        message: "Files  uploaded successfully",
        imageURL,
        assets: uploadedFiles.map((asset) => asset.url),
      };
      
      return returnResponse;
    } catch (err) {
      console.error("❌ Failed to upload and save design:", err);
      return {
        status: false,
        message: err.message || "❌ Failed to upload and save design",
        product_name,
        user_name,
        uploadedFiles,
      };
    }
  }

  async function saveDesignAsGuestInDB(dataURL) {
    const imageBlob = dataURLtoBlob(dataURL);
    let product_name =
      document.getElementById("disc-product-name")?.value || "";
    if (product_name)
      product_name = product_name.toLowerCase().replace(/\s+/g, "_");

    let user_name = document.getElementById("disc-user-name")?.value || "";
    if (user_name) user_name = user_name.toLowerCase().replace(/-/g, "_");

    product_name = "";
    user_name = "";

    const uploadedFiles = [];

    try {
      // NB: uploads deliberately run SERIALLY. A parallel version (preview +
      // assets via Promise.all) was tried 2026-08-09 and real-phone uploads
      // started failing — reverted the same day. Suspect the multipart path
      // under concurrency; do not re-parallelize without device testing.
      let result;

      if (imageBlob.size > CHUNK_THRESHOLD) {
        result = await uploadInChunks(imageBlob, previewUploadName(imageBlob));
      } else {
        result = await simpleUpload(imageBlob, previewUploadName(imageBlob));
      }
      const { publicUrl: imageURL, fileName: imageFileName } = result;

      const assetImages = exportAssetsImages();
      for (let i = 0; i < assetImages.length; i++) {
        const img = assetImages[i];
        if (!img.originalBlob) continue;

        const filename = `${img.originalFileName || `asset_${i + 1}`}.${
          img.uploadExt || "png"
        }`;
        let assetResult;
        if (img.originalBlob.size > CHUNK_THRESHOLD) {
          assetResult = await uploadInChunks(
            img.originalBlob,
            filename,
            product_name,
            user_name
          );
        } else {
          assetResult = await simpleUpload(
            img.originalBlob,
            filename,
            product_name,
            user_name
          );
        }
        if (assetResult && assetResult.publicUrl) {
          uploadedFiles.push(assetResult.publicUrl);
        }
      }
      return {
        status: true,
        message: "✅ Design and assets uploaded successfully",
        imageURL,
        assets: uploadedFiles,
      };
    } catch (err) {
      console.error("❌ Failed to upload to S3:", err);
      return {
        status: false,
        message: err.message || "❌ Failed to upload to S3",
        product_name,
        user_name,
        uploadedFiles,
      };
    }
  }

  // --- Save As Design ---
  const saveAsDesignFunction = async (targetBtn) => {
    try {
      const assetContainer = targetBtn
        .closest(".customize-disc-container")
        .querySelector(".disc-assets-container");
      if (
        window.ShopifyCustomerLoggedIn !== true &&
        window.ShopifyCustomerLoggedIn !== "true"
      ) {
        // check user is logged in or not
        if (
          confirm(
            "You need to log in to save your design. Would you like to log in now?"
          )
        ) {
          window.location.href = window.ShopifyLoginUrl;
        }
        return;
      }
      canvas.discardActiveObject();
      canvas.renderAll();

      // Export with full metadata
      const canvasDataWithMetadata = exportCanvasWithMetadata();

      // Save JSON string of canvas with metadata
      const json = JSON.stringify(canvasDataWithMetadata);

      discDesign.json = json;
      discDesign.type = "json";

      const dataURL = await exportCanvasImage();

      let id = window.generateUniqueId();

      // let previousDesigns = window.previousDesigns;
      // previousDesigns.push({ id, src: dataURL, json });

      
      // create function is called
      result = await saveDesignInDB(json, dataURL);
      let { status, message, imageURL, assets } = result || {};

      // Handling response for add  case start here
      if (result.status === true) {        
        addUnqiueValueInProductProperty();
        // Save the canvas assets
        if (Array.isArray(assets) && assets.length > 0) {
          addValuesToAssetContainer(assetContainer, assets);
        }
        document.getElementById("disc-design-data-url").value = dataURL;
        // discDesign.dataURL = dataURL;

        const viewPreviewWrapper = document.getElementById("view-disc-design-preview-wrapper");
        if (viewPreviewWrapper) {
          viewPreviewWrapper.classList.remove("tw-hidden", "hidden");
        }
        // Update the latest image url in hidden input
        document.getElementById("disc-design-data-url").value = imageURL;
        document.getElementById("disc-design-data-url-type").value = "Internal";
        uploadThumbnailQuietly(dataURL);

        document
          .getElementById("save-as-continue-msg")
          .classList.add("text-green-700");

        document.getElementById("save-as-continue-msg").innerHTML =
          " Design is duplicated! Continuing to the next step...";

        clearSelectedDesigns();
        window.resetAndRefethDesigns();
        // Canvas left intact on purpose - see the note in saveDesignFunction.
      } else {
        document
          .getElementById("save-as-continue-msg")
          .classList.add("text-red-700");
        document.getElementById("save-as-continue-msg").innerHTML = message;
      }

      
      document
        .getElementById("save-as-continue-msg")
        .classList.remove("hidden");
      setTimeout(() => {
        document.getElementById("save-as-continue-msg").classList.add("hidden");

        window.closeModal();
      }, sucessMessageDisappearTime);
    } catch (error) {
      console.log("Error on saving the design : ", error);
    } finally {
      // Disable save btns and show the save-btn loader
      enableDisableSaveBtns(false, "save-as-btn");
    }
  };
  saveAsDesignBtn?.addEventListener("click", (event) => {
    const targetBtn = event.currentTarget;
    enableDisableSaveBtns(true, "save-as-btn"); // disable instantly

    // queue after current stack, but don't wait for a full animation frame
    setTimeout(() => saveAsDesignFunction(targetBtn), 0);
  });

  async function updateDesignInDB(id, json, dataURL) {
    const jsonBlob = new Blob([JSON.stringify(json)], {
      type: "application/json",
    });
    const imageBlob = dataURLtoBlob(dataURL);

    let product_name = (
      document.getElementById("disc-product-name")?.value || ""
    )
      .toLowerCase()
      .replace(/\s+/g, "_");
    let user_name = (document.getElementById("disc-user-name")?.value || "")
      .toLowerCase()
      .replace(/-/g, "_");

    const uploadedFiles = [];

    try {
      // 1️⃣ Upload JSON
      const jsonUpload =
        jsonBlob.size > CHUNK_THRESHOLD
          ? await uploadInChunks(jsonBlob, "canvas.json")
          : await simpleUpload(jsonBlob, "canvas.json");
      const { publicUrl: jsonURL, fileName: jsonFileName } = jsonUpload;

      // 2️⃣ Upload preview image
      const imageUpload =
        imageBlob.size > CHUNK_THRESHOLD
          ? await uploadInChunks(
              imageBlob,
              previewUploadName(imageBlob),
              product_name,
              user_name
            )
          : await simpleUpload(
              imageBlob,
              previewUploadName(imageBlob),
              product_name,
              user_name
            );
      const { publicUrl: imageURL, fileName: imageFileName } = imageUpload;

      // 3️⃣ Upload asset images
      const assetImages = exportAssetsImages();
      for (let i = 0; i < assetImages.length; i++) {
        const img = assetImages[i];
        if (!img.originalBlob) continue;

        const filename = `${img.originalFileName || `asset_${i + 1}`}.${
          img.uploadExt || "png"
        }`;
        const assetUpload =
          img.originalBlob.size > CHUNK_THRESHOLD
            ? await uploadInChunks(img.originalBlob, filename)
            : await simpleUpload(img.originalBlob, filename);
        const { publicUrl: assetURL, fileName: assetFileName } = assetUpload;
        uploadedFiles.push({ filename: assetFileName, url: assetURL });
      }

      // 4️⃣ Prepare JSON payload
      const payload = {
        id,
        email: window.ShopifyCustomerEmail || "",
        canvas_json: jsonFileName,
        preview_image: imageFileName,
        assets: uploadedFiles.map((asset) => asset.filename),
      };

      // 5️⃣ Send JSON to backend
      const response = await fetch(
        `${DGSAppBaseUrl}/disc-designs/update-design`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      const result = await response.json();

      let returnResponse = {
        status: true,
        message: "Design updated and files uploaded successfully",
        imageURL,
        assets: uploadedFiles.map((asset) => asset.url),
        serverResponse: result,
      };
     
      return returnResponse;
    } catch (err) {
      console.error("❌ Failed to update and upload design:", err);
      return {
        status: false,
        message: err.message || "❌ Failed to update and upload design",
        product_name,
        user_name,
        uploadedFiles,
      };
    }
  }

  // --- Upload progress (VISUAL ONLY). Simulated: eases toward 90% and only
  // reaches 100% after S3 actually confirms success. One 200ms interval
  // (requestAnimationFrame stalls in some in-app webviews — see the Clear
  // Canvas history), CSS transition smooths between ticks. Timers are
  // always cleared on success, failure or cancel. No effect on the upload
  // itself: same single fetch, image untouched.
  const uploadProgress = (() => {
    let timer = null;
    let slowTimer = null;
    let bar = null;
    let fill = null;
    let labelEl = null;
    let labelOriginal = "";
    const css = document.createElement("style");
    css.textContent =
      ".dgs-upload-bar{width:100%;height:6px;background:#e5e7eb;border-radius:3px;overflow:hidden;margin-top:10px;}" +
      ".dgs-upload-bar__fill{height:100%;width:0%;background:#f59e0b;border-radius:3px;transition:width .25s ease;}" +
      ".dgs-retry-btn{display:block;margin:10px auto 0;padding:8px 18px;background:#f59e0b;color:#111;font-weight:600;border:none;border-radius:6px;cursor:pointer;}";
    document.head.appendChild(css);
    function clearTimers() {
      if (timer) clearInterval(timer);
      if (slowTimer) clearTimeout(slowTimer);
      timer = null;
      slowTimer = null;
    }
    function restoreLabel() {
      if (labelEl && labelOriginal) labelEl.textContent = labelOriginal;
    }
    return {
      start(indicatorEl) {
        this.stop();
        if (!indicatorEl) return;
        labelEl = indicatorEl.querySelector("span");
        labelOriginal = labelEl ? labelEl.textContent : "";
        bar = document.createElement("div");
        bar.className = "dgs-upload-bar";
        bar.innerHTML = '<div class="dgs-upload-bar__fill"></div>';
        indicatorEl.insertAdjacentElement("afterend", bar);
        fill = bar.firstElementChild;
        let pct = 0;
        timer = setInterval(() => {
          // decelerating approach; hard ceiling at 90 until real success
          pct += Math.max(0.4, (90 - pct) * 0.06);
          if (pct >= 90) pct = 90;
          fill.style.width = pct.toFixed(1) + "%";
        }, 200);
        slowTimer = setTimeout(() => {
          if (labelEl)
            labelEl.textContent =
              "Still uploading — your connection seems a little slow. Hang tight…";
        }, 10000);
      },
      finish() {
        clearTimers();
        restoreLabel();
        if (fill) fill.style.width = "100%";
        const done = bar;
        bar = null;
        if (done) setTimeout(() => done.remove(), 600);
      },
      fail() {
        clearTimers();
        restoreLabel();
        if (bar) {
          bar.remove();
          bar = null;
        }
      },
      stop() {
        clearTimers();
        restoreLabel();
        if (bar) {
          bar.remove();
          bar = null;
        }
      },
    };
  })();

  // Failure recovery: one-tap retry that re-fires the original trigger —
  // never starts a second upload on its own.
  function showRetryOption(msgEl, triggerBtn) {
    if (!msgEl || !triggerBtn) return;
    let btn = msgEl.parentElement.querySelector(".dgs-retry-btn");
    if (!btn) {
      btn = document.createElement("button");
      btn.type = "button";
      btn.className = "dgs-retry-btn";
      btn.textContent = "\u21bb Try again";
      msgEl.insertAdjacentElement("afterend", btn);
    }
    btn.onclick = () => {
      btn.remove();
      msgEl.classList.add("hidden");
      triggerBtn.click();
    };
  }

  function enableDisableSaveBtns(enable, btnType) {
    
    if (enable === true) {
      // Save btn
      if (saveDesignBtn) {
        if (btnType === "save-btn") {
          saveLoadingIndicator.classList.remove("hidden");
          uploadProgress.start(saveLoadingIndicator);
        }
        saveDesignBtn.classList.add("opacity-50", "cursor-not-allowed");
        
      }

      // Save as btn
      if (saveAsDesignBtn) {
        if (btnType === "save-as-btn") {
          saveAsLoadingIndicator.classList.remove("hidden");
          uploadProgress.start(saveAsLoadingIndicator);
        }
        saveAsDesignBtn.classList.add("opacity-50", "cursor-not-allowed");
      }

      // Guest Btn
      if (saveGuestDesignBtn) {
        if (btnType === "save-guest-design") {
          saveGuuestLoadingIndicator.classList.remove("hidden");
          uploadProgress.start(saveGuuestLoadingIndicator);
        }
        saveGuestDesignBtn.classList.add("opacity-50", "cursor-not-allowed");
      }
    } else {
      // safety: clears the simulated-progress timers on any path that hides
      // the indicators (incl. cancel/close) without reaching finish/fail
      uploadProgress.stop();
      // Save design
      if (saveDesignBtn) {
        saveLoadingIndicator.classList.add("hidden");
        saveDesignBtn.classList.remove("opacity-50", "cursor-not-allowed");
      }
      if (saveAsDesignBtn) {
        // Save as design
        saveAsLoadingIndicator.classList.add("hidden");
        saveAsDesignBtn.classList.remove("opacity-50", "cursor-not-allowed");
      }

      // Save as guest design
      if (saveGuestDesignBtn) {
        saveGuuestLoadingIndicator.classList.add("hidden");
        saveGuestDesignBtn.classList.remove("opacity-50", "cursor-not-allowed");
      }
    }
  }

  function addUnqiueValueInProductProperty() {
    const uniqueId = Date.now() + Math.random().toString(36).substr(2, 9);
    const uniqueInput = document.getElementById('unique');
    if (uniqueInput) {
      uniqueInput.value = uniqueId;
    } else {
      console.warn('Element with id "unique" not found');
    }
  }

  // remove the design from product form
  document.getElementById('remove-dics-design-btn').addEventListener('click', function() {
    const container = document.getElementById('view-disc-design-preview-wrapper');    
    container.classList.add("hidden");
    document.getElementById('disc-design-data-url-type').value =""
    document.getElementById('disc-design-data-url').value =""
    var thumbClear = document.getElementById('disc-design-thumb-url');
    if (thumbClear) thumbClear.value = "";
    addUnqiueValueInProductProperty()
  });

  const testBtn = document.querySelector(".test-btn");
  testBtn?.addEventListener("click", async function (e) {
    alert("testBtn");
    return false;
  });

  const createDesignAddToCartBtn = document.querySelector(
    ".createDesignAddToCartBtn"
  );

  /**
   * Post-add confirmation fork. On a successful modal add the modal now stays
   * open (the cart drawer covers it, z-index 2147482001 vs the modal's 10002),
   * with quantity + Add to Cart swapped for "Design another disc" / "Done".
   * Closing the drawer therefore lands on the fork - the moment a shopper
   * ordering several different discs needs it. Returns false when the markup
   * is absent (e.g. Etsy portal) so callers can fall back to closing.
   */
  const dgsModalCartWrapper = createDesignAddToCartBtn?.closest(
    ".modal-cart-wrapper"
  );
  window.DGS_showAddedState = () => {
    if (!dgsModalCartWrapper || !document.getElementById("dgs-added-state")) {
      return false;
    }
    dgsModalCartWrapper.classList.add("dgs-added");
    // The confirmation says everything the banner says; drop the banner.
    updateCartStateBanner();
    return true;
  };
  window.DGS_hideAddedState = () => {
    dgsModalCartWrapper?.classList.remove("dgs-added");
  };

  document
    .getElementById("dgs-design-another-btn")
    ?.addEventListener("click", function () {
      window.DGS_hideAddedState();
      const qty = dgsModalCartWrapper?.querySelector(".modal-product-quantity");
      if (qty) qty.value = "1";
      // Clears without the confirm prompt; runs handleChangeInCanvas, which
      // re-disables Add to Cart and refreshes the banner.
      window.DGS_ResetDesigner();
    });

  document
    .getElementById("dgs-added-done-btn")
    ?.addEventListener("click", function () {
      window.DGS_hideAddedState();
      window.closeModal();
    });

  // The banner's escape hatch: blank disc, start over.
  document
    .getElementById("dgs-start-new-design-btn")
    ?.addEventListener("click", function () {
      window.DGS_ResetDesigner();
    });

  // Stock pre-flight for the designer's Add to Cart. The steppers are already
  // clamped to page-load stock (dgs-stock-guard.liquid); what they cannot see
  // is quantity of this mold ALREADY in the cart, which Shopify's DENY check
  // counts. Without this, that case uploaded the design and then failed at the
  // cart with the error rendered behind the modal. Fails open on any doubt -
  // a broken guard must never block a sale Shopify would accept.
  const dgsStockPreflight = async (qty) => {
    try {
      if (typeof window.DGS_stockAvailable !== "function") return { ok: true };
      const s = window.DGS_stockAvailable();
      if (!s || typeof s.qty !== "number") return { ok: true };
      qty = parseInt(qty, 10) || 1;
      if (s.qty <= 0) {
        return {
          ok: false,
          canAdd: 0,
          message:
            "This disc is sold out" +
            (s.title ? " (" + s.title + ")" : "") +
            " - please pick a different disc.",
        };
      }
      let inCart = 0;
      try {
        const cart = await (await fetch("/cart.js")).json();
        (cart.items || []).forEach((it) => {
          if (String(it.variant_id) === String(s.id)) inCart += it.quantity;
        });
      } catch (e) {
        /* cart unreachable: let Shopify be the judge */
      }
      if (qty + inCart > s.qty) {
        const canAdd = Math.max(0, s.qty - inCart);
        return {
          ok: false,
          canAdd,
          message:
            inCart > 0
              ? "Only " +
                s.qty +
                " in stock and your cart already has " +
                inCart +
                (canAdd > 0
                  ? " - quantity set to the " + canAdd + " you can still add. Press Add to Cart again to confirm."
                  : " - that is all of them. Adjust the quantity in your cart instead.")
              : "Only " +
                s.qty +
                " in stock - quantity set to " +
                canAdd +
                ". Press Add to Cart again to confirm.",
        };
      }
      return { ok: true };
    } catch (e) {
      return { ok: true };
    }
  };

  // Cart add failed AFTER a successful design upload (stock raced away, or a
  // cart-held quantity the pre-flight's fails-open path missed). The drawer
  // renders its warning on the PAGE - behind this modal - while the modal's
  // "added" fork only ever reflected the upload. Surface the truth in here.
  document.addEventListener("cart:add-error", function (e) {
    const modal = document.getElementById("custom-modal-overlay");
    if (!modal || modal.style.display !== "block") return;
    window.DGS_hideAddedState?.();
    const message =
      (e.detail && e.detail.message) ||
      "Could not add this to your cart. Please try again.";
    if (!(window.DGS_showStockMsg && window.DGS_showStockMsg(message))) {
      alert(message);
    }
  });

  // Mold/plastic/weight gate, Special Order product only (the mirror input in
  // create-disc-design.liquid renders just for it). The value posts from the
  // PAGE form's required textarea, which sits invisible behind this modal - so
  // an empty field here would otherwise mean the browser silently blocks the
  // programmatic .add_to_cart click below and the press looks dead. Block it
  // OURSELVES with a visible shake instead. Either copy counts (they are
  // two-way synced); the page copy is backfilled as a belt in case the sync
  // script ever failed to run.
  const dgsMoldGate = (retry) => {
    const wrap = document.getElementById("dgs-modal-mold");
    if (!wrap) return true; // product without the field
    const mirror = document.getElementById("dgs-modal-mold-input");
    const page = document.querySelector(
      'textarea[name="properties[Mold / Plastic / Weight]"]'
    );
    const val = ((mirror && mirror.value) || (page && page.value) || "").trim();
    if (val) {
      if (page && !page.value.trim() && mirror) page.value = mirror.value;
      return dgsLeadtimeGate(retry);
    }
    wrap.classList.remove("dgs-mold-shake");
    void wrap.offsetWidth; // restart the animation on repeat presses
    wrap.classList.add("dgs-mold-shake");
    wrap.scrollIntoView({ block: "center", behavior: "smooth" });
    if (mirror) mirror.focus();
    setTimeout(() => wrap.classList.remove("dgs-mold-shake"), 600);
    return false;
  };
  // Special Order's required "Ship time" acknowledgement. The page checkbox
  // (dgs-personalizer) is the one that posts; inside the designer there is no
  // copy of it (it cost the canvas too much room), so an unticked box opens
  // the #dgs-leadtime-tpl dialog instead. "I understand" ticks the page box
  // and calls retry() to press Add to Cart again. Checked only after the mold
  // field passes, so the shopper fixes one thing at a time.
  const dgsLeadtimeGate = (retry) => {
    const page = document.querySelector("input[data-dgs-leadtime]");
    if (!page || page.checked) return true; // other product, or already ticked
    const tpl = document.getElementById("dgs-leadtime-tpl");
    if (!tpl) return false;
    let dlg = document.getElementById("dgs-leadtime-dialog");
    if (!dlg) {
      // body, not the buy bar: v2 restyles everything inside .v2-buy
      document.body.appendChild(tpl.content.cloneNode(true));
      dlg = document.getElementById("dgs-leadtime-dialog");
      dlg.addEventListener("click", (e) => {
        const act = e.target.closest("[data-dgs-lt]")?.dataset.dgsLt;
        if (!act) return;
        dlg.close();
        if (act !== "ok") return;
        page.checked = true;
        page.dispatchEvent(new Event("change", { bubbles: true }));
        if (typeof dlg._retry === "function") dlg._retry();
      });
    }
    dlg._retry = retry;
    dlg.showModal();
    return false;
  };
  // The Design Link tab's Add to Cart (customize-disc-design-1.js) clicks the
  // same hidden .add_to_cart and needs the same gate - exposed so it does not
  // hit the native-required silent block this gate exists to prevent.
  window.DGS_moldGate = dgsMoldGate;

  // Handle click event to create design tab add to cart button
  createDesignAddToCartBtn?.addEventListener("click", function (event) {
    let This = this;

    if (!dgsMoldGate(() => This.click())) return;


    const modalCartWrapper = this.closest(".modal-cart-wrapper");
    const productQuantity = modalCartWrapper.querySelector(".modal-product-quantity").value;
    document.querySelector("input.product-qunatity[name='quantity']").value = productQuantity;



    This.classList.add("opacity-50", "cursor-not-allowed");
    const targetBtn = event.currentTarget;
    // Only add to the cart if the design actually attached — proceeding on a
    // failed save silently created no-design custom lines.
    const clickAtcIfDesignAttached = async () => {
      const attachedUrl =
        document.getElementById("disc-design-data-url")?.value || "";
      if (attachedUrl.indexOf("http") === 0) {
        // Wait (bounded) for the quiet thumbnail upload so the posted
        // properties are complete: with the thumb still empty the line can
        // never merge with a later identical add, and the cart drawer has no
        // thumbnail to show. On timeout post anyway - old behavior.
        if (window.DGS_thumbUploadPromise) {
          await Promise.race([
            window.DGS_thumbUploadPromise,
            new Promise((resolve) => setTimeout(resolve, 4000)),
          ]);
        }
        This.closest(".atc-btn-container").querySelector(".add_to_cart").click();
      }
      This.classList.remove("opacity-50", "cursor-not-allowed");
    };

    const proceed = () => {
      // Canvas untouched since the last successful add: reuse the committed
      // design instead of uploading a copy under a fresh URL. Identical
      // properties mean Shopify merges into the existing cart line (quantity
      // bump) rather than creating a lookalike duplicate line.
      const committedUrl =
        document.getElementById("disc-design-data-url")?.value || "";
      if (
        window.DGS_canvasDirty === false &&
        committedUrl.indexOf("http") === 0
      ) {
        clickAtcIfDesignAttached();
        window.DGS_showAddedState();
        return;
      }

      if (
        window.ShopifyCustomerLoggedIn !== true &&
        window.ShopifyCustomerLoggedIn !== "true"
      ) {
        enableDisableSaveBtns(true, "save-guest-design"); // disable instantly
        // queue after current stack, but don't wait for a full animation frame
        setTimeout(async () => {
          await saveGuestDesignFunction(targetBtn)
          clickAtcIfDesignAttached();
        }, 0);
      } else {
        enableDisableSaveBtns(true, "save-btn"); // disable instantly
        // queue after current stack, but don't wait for a full animation frame
        setTimeout(async () => {
          // upload-only: Add to Cart no longer creates/updates a saved design
          await attachDesignForCart(targetBtn)
          clickAtcIfDesignAttached();
        }, 0);
      }
    };

    // Adjust-and-confirm on a failed pre-flight (never adjust-and-proceed:
    // silently buying fewer discs than asked for is worse than a second press).
    dgsStockPreflight(productQuantity).then((verdict) => {
      if (verdict.ok) {
        proceed();
        return;
      }
      This.classList.remove("opacity-50", "cursor-not-allowed");
      if (verdict.canAdd > 0) {
        const q = modalCartWrapper.querySelector(".modal-product-quantity");
        if (q) q.value = verdict.canAdd;
        document.querySelector("input.product-qunatity[name='quantity']").value =
          verdict.canAdd;
      }
      if (!(window.DGS_showStockMsg && window.DGS_showStockMsg(verdict.message))) {
        alert(verdict.message);
      }
    });
  });

  // Function to add metadata and index to objects
  function addMetadataToObject(object, customMetadata = {}) {
    // Add current index
    const currentIndex = canvas.getObjects().indexOf(object);

    // Add metadata property with default values and custom data
    object.metadata = {
      id: window.generateUniqueId(),
      createdAt: new Date().toISOString(),
      type: object.type,
      currentIndex: currentIndex,
      originalIndex: currentIndex,
      isLocked: false,
      category: getObjectCategory(object.type),
      ...customMetadata, // Spread any additional custom metadata
    };

    // Update index in metadata whenever object position changes
    updateObjectIndex(object);

    return object;
  }

  // Get category based on object type
  function getObjectCategory(type) {
    const categories = {
      "i-text": "text",
      textbox: "text",
      image: "image",
      rect: "shape",
      circle: "shape",
      path: "shape",
    };
    return categories[type] || "other";
  }

  // Update object index in metadata
  function updateObjectIndex(object) {
    if (object.metadata) {
      object.metadata.currentIndex = canvas.getObjects().indexOf(object);
      object.metadata.lastUpdated = new Date().toISOString();
    }
  }

  // Update all objects' indices
  function updateAllObjectIndices() {
    canvas.getObjects().forEach((obj, index) => {
      if (obj.metadata) {
        obj.metadata.currentIndex = index;
        obj.metadata.lastUpdated = new Date().toISOString();
      }
    });
  }

  // Enhanced lock/unlock button handler
  lockUnlockBtn?.addEventListener("click", () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      toggleObjectLock(activeObject);
      updateControls();
    }
  });

  // Enhanced toggleObjectLock function
  function toggleObjectLock(object) {
    if (!object.metadata) {
      addMetadataToObject(object);
    }

    const currentIndex = canvas.getObjects().indexOf(object);

    if (object.metadata.isLocked) {
      // Unlock object
      object.metadata.isLocked = false;
      object.locked = false;
      object.selectable = true;
      object.evented = true;
      object.lockMovementX = false;
      object.lockMovementY = false;
      object.lockScalingX = false;
      object.lockScalingY = false;
      object.lockRotation = false;

      // Clear stored index and flags
      delete object.metadata.storedIndex;
      delete object._preventBringToFront;
      delete object._needsPositionRestore;
      delete object._originalIndex;

      // Update visual indicators
      object.set({
        borderColor: "rgba(66, 153, 225, 0.8)",
        cornerColor: "#4299e1",
      });

      // console.log(`Object unlocked at index ${currentIndex}`);
    } else {
      // Lock object
      object.metadata.isLocked = true;
      object.locked = true;
      object.lockMovementX = true;
      object.lockMovementY = true;
      object.lockScalingX = true;
      object.lockScalingY = true;
      object.lockRotation = true;

      // Store current index as the locked position
      object.metadata.storedIndex = currentIndex;
      object.metadata.lockedAt = new Date().toISOString();

      // Update visual indicators
      object.set({
        borderColor: "rgba(255, 193, 7, 0.8)",
        cornerColor: "#ffc107",
      });

      // console.log(`Object locked at index ${currentIndex}`);
    }

    // Update metadata
    object.metadata.currentIndex = currentIndex;
    object.metadata.lastUpdated = new Date().toISOString();

    canvas.renderAll();
  }

  // Activate locak if object is locked, activate unlock if object is unlocked
  function activateObjectLockUnlock(object) {
    if (!object.metadata) {
      addMetadataToObject(object);
    }

    const currentIndex = canvas.getObjects().indexOf(object);

    if (object.metadata.isLocked === false) {
      // Unlock object
      object.metadata.isLocked = false;
      object.locked = false;
      object.selectable = true;
      object.evented = true;
      object.lockMovementX = false;
      object.lockMovementY = false;
      object.lockScalingX = false;
      object.lockScalingY = false;
      object.lockRotation = false;

      // Clear stored index and flags
      delete object.metadata.storedIndex;
      delete object._preventBringToFront;
      delete object._needsPositionRestore;
      delete object._originalIndex;

      // Update visual indicators
      object.set({
        borderColor: "rgba(66, 153, 225, 0.8)",
        cornerColor: "#4299e1",
      });

      // console.log(`Object unlocked at index ${currentIndex}`);
    } else {
      // Lock object
      object.metadata.isLocked = true;
      object.locked = true;
      object.lockMovementX = true;
      object.lockMovementY = true;
      object.lockScalingX = true;
      object.lockScalingY = true;
      object.lockRotation = true;

      // Store current index as the locked position
      object.metadata.storedIndex = currentIndex;
      object.metadata.lockedAt = new Date().toISOString();

      // Update visual indicators
      object.set({
        borderColor: "rgba(255, 193, 7, 0.8)",
        cornerColor: "#ffc107",
      });

      // console.log(`Object locked at index ${currentIndex}`);
    }

    // Update metadata
    object.metadata.currentIndex = currentIndex;
    object.metadata.lastUpdated = new Date().toISOString();

    canvas.renderAll();
  }

  // Function that runs when an object becomes active
  // Enhanced handleObjectActivation function
  function handleObjectActivation(activeObject) {
    // console.log("Object activated:", activeObject.type);

    if (activeObject.metadata) {
      // console.log("Object lock status:", activeObject.metadata.isLocked);
      // console.log("Current index:", activeObject.metadata.currentIndex);

      // If object is locked, restore its position immediately
      if (activeObject.metadata.isLocked || activeObject.locked) {
        // console.log("Object is locked - maintaining current position");
        // Force position restoration
        restoreObjectToOriginalPosition(activeObject);
      } else {
        // console.log("Object is unlocked - allowing reshuffling");
        handleUnlockedObjectSelection(activeObject);
      }
    } else {
      // console.log("No metadata found - treating as unlocked");
      handleUnlockedObjectSelection(activeObject);
    }
  }

  // Restore locked object to its original/stored position
  // Enhanced restoreObjectToOriginalPosition function
  function restoreObjectToOriginalPosition(object) {
    if (object.metadata && object.metadata.storedIndex !== undefined) {
      const currentIndex = canvas.getObjects().indexOf(object);
      const targetIndex = object.metadata.storedIndex;

      if (currentIndex !== targetIndex && targetIndex >= 0) {
        // console.log(
        //   `Restoring locked object from index ${currentIndex} to ${targetIndex}`
        // );

        // Use moveTo instead of remove/insert for better performance
        canvas.moveTo(object, targetIndex);

        // Update metadata
        object.metadata.currentIndex = targetIndex;
        object.metadata.lastRestored = new Date().toISOString();

        // Clear restoration flags
        delete object._needsPositionRestore;
        delete object._originalIndex;

        // Force re-render
        canvas.renderAll();
      }
    }
  }

  // Handle unlocked object selection (allow bringing to front)
  // Enhanced handleUnlockedObjectSelection function
  function handleUnlockedObjectSelection(object) {
    // Do NOT reorder the selected object. Selecting used to bring it to the
    // front ("for better interaction"), but that silently undid Send Backward /
    // Bring Forward — selecting an image you had pushed behind another snapped
    // it straight back on top. Fabric lets you drag/resize a selected object at
    // any z-index, so the raise isn't needed. We only keep TEXT above images so
    // it stays readable while a photo underneath is manipulated (owner rule).
    const isText =
      object.type === "i-text" ||
      object.type === "text" ||
      object.type === "textbox";
    if (isText) return;

    const texts = canvas
      .getObjects()
      .filter(
        (o) => o.type === "i-text" || o.type === "text" || o.type === "textbox"
      );
    if (!texts.length) return;

    texts.forEach((t) => canvas.bringToFront(t));
    if (object.metadata) {
      object.metadata.currentIndex = canvas.getObjects().indexOf(object);
    }
    canvas.renderAll();
  }

  // Override ALL Fabric.js methods that could change object order
  const originalBringToFront = fabric.Object.prototype.bringToFront;
  fabric.Object.prototype.bringToFront = function () {
    if ((this.metadata && this.metadata.isLocked) || this.locked) {
      // console.log("Prevented bringToFront for locked object");
      return this;
    }
    return originalBringToFront.call(this);
  };

  const originalBringForward = fabric.Object.prototype.bringForward;
  fabric.Object.prototype.bringForward = function (intersecting) {
    if ((this.metadata && this.metadata.isLocked) || this.locked) {
      // console.log("Prevented bringForward for locked object");
      return this;
    }
    return originalBringForward.call(this, intersecting);
  };

  const originalSendToBack = fabric.Object.prototype.sendToBack;
  fabric.Object.prototype.sendToBack = function () {
    if ((this.metadata && this.metadata.isLocked) || this.locked) {
      // console.log("Prevented sendToBack for locked object");
      return this;
    }
    return originalSendToBack.call(this);
  };

  const originalSendBackwards = fabric.Object.prototype.sendBackwards;
  fabric.Object.prototype.sendBackwards = function (intersecting) {
    if ((this.metadata && this.metadata.isLocked) || this.locked) {
      // console.log("Prevented sendBackwards for locked object");
      return this;
    }
    return originalSendBackwards.call(this, intersecting);
  };

  // Utility function to force restore all locked objects
  function forceRestoreAllLockedObjects() {
    // console.log("Force restoring all locked objects...");
    canvas.getObjects().forEach((obj, currentIndex) => {
      if ((obj.metadata && obj.metadata.isLocked) || obj.locked) {
        if (
          obj.metadata &&
          obj.metadata.storedIndex !== undefined &&
          obj.metadata.storedIndex !== currentIndex
        ) {
          // console.log(
          //   `Force restoring object from ${currentIndex} to ${obj.metadata.storedIndex}`
          // );
          canvas.moveTo(obj, obj.metadata.storedIndex);
        }
      }
    });
    updateAllObjectIndices();
    canvas.renderAll();
  }

  // Call this function periodically if needed (for debugging)
  // setInterval(forceRestoreAllLockedObjects, 1000);

  // --- Initialize everything ---
  initializeCanvas();
  updateControls();

  window.addEventListener("disc-customizer:opened", function () {
    requestAnimationFrame(() => {
      if (wrapper.offsetWidth > 0) {
        resizeCanvas();
      }
    });
  });

  // Function to clear the canvas with various options
  function clearCanvas(options = {}) {
    const {
      confirmBeforeClear = false,
      resetBackground = true,
      resetToDefaultBackground = "#ffffff",
      clearMetadata = true,
      showNotification = false,
      animateTransition = false,
    } = options;

    // Confirmation dialog
    if (confirmBeforeClear) {
      const confirmed = confirm(
        "Clear the entire canvas?\n\nYou can bring it back with the Undo button."
      );
      if (!confirmed) {
        return false; // User cancelled
      }
    }

    // Record what is about to be wiped so Undo can restore it.
    if (typeof window.DGS_snapshotAllForUndo === "function") {
      window.DGS_snapshotAllForUndo("clear canvas");
    }

    // Store current state for potential undo (optional)
    const beforeClearState = {
      objects: canvas.getObjects().length,
      backgroundColor: canvas.backgroundColor,
      metadata: canvas.canvasMetadata || null,
    };

    try {
      // Animate transition if requested
      if (animateTransition && canvas.getObjects().length > 0) {
        // Fade out all objects
        canvas.getObjects().forEach((obj, index) => {
          setTimeout(() => {
            obj.animate("opacity", 0, {
              duration: 300,
              onChange: canvas.renderAll.bind(canvas),
              onComplete: () => {
                if (index === canvas.getObjects().length - 1) {
                  // After last object fades, clear everything
                  performClear();
                }
              },
            });
          }, index * 50); // Stagger the animations
        });
      } else {
        // Clear immediately
        performClear();
      }

      // Internal function to perform the actual clearing
      function performClear() {
        // Clear all objects from canvas
        canvas.clear();

        // Defence in depth. canvas.clear() has been observed to intermittently
        // leave an uploaded image behind, which then re-renders as a ghost the
        // shopper cannot select. Force-remove anything that survived, and drop
        // the tracked image references so nothing can re-add them.
        canvas.getObjects().slice().forEach(function (o) {
          canvas.remove(o);
        });
        if (Array.isArray(images)) images.length = 0;

        // GHOST FIX. canvas.clear() only wipes fabric's LOGICAL area. When
        // fabric's retina scaling has desynced from the backing store - which
        // the resize path can cause after a rotate, an address-bar move or a tab
        // switch - clear() and the white background only paint part of the
        // oversized backing, so a centred photo survives in the rest. Reported
        // from a phone: after Clear Canvas the previous photo was still visible
        // but not selectable, with "Click to Add Image" on top of it.
        //
        // resyncCanvasSize() hands sizing back to fabric via setDimensions,
        // which re-runs its retina init so the transform (and thus the placeholder
        // and any future edit) is correct. The raw pixel wipe that actually
        // guarantees no ghost survives happens at the END of this function, after
        // every fabric render, so nothing can repaint a stale pixel afterwards.
        resyncCanvasSize();

        // Reset background if requested
        if (resetBackground) {
          canvas.setBackgroundColor(
            resetToDefaultBackground,
            canvas.renderAll.bind(canvas)
          );

          // Update UI background color selector if it exists
          updateBackgroundColorUI(resetToDefaultBackground);
        }

        // Clear canvas metadata if requested
        if (clearMetadata) {
          canvas.canvasMetadata = null;
          canvas.meta = {};
        }

        // Clear any active selections
        canvas.discardActiveObject();

        // Reset zoom and pan if they exist
        if (canvas.getZoom && canvas.getZoom() !== 1) {
          canvas.setZoom(1);
        }
        if (
          canvas.viewportTransform &&
          (canvas.viewportTransform[4] !== 0 ||
            canvas.viewportTransform[5] !== 0)
        ) {
          canvas.viewportTransform[4] = 0;
          canvas.viewportTransform[5] = 0;
        }
        
        // Update UI controls
        if (typeof updateControls === "function") {
          updateControls();
        }

        // Trigger canvas change handler if it exists
        if (typeof handleChangeInCanvas === "function") {
          handleChangeInCanvas();
        }

        // AUTHORITATIVE FINALISE.
        // Removing the objects and wiping the pixels once is not enough: within
        // ~50ms of a clear an uploaded image re-inserts itself into the object
        // list WITHOUT going through canvas.add() - a fabric layering op
        // (moveTo/sendToBack) acting on a stale reference splices the removed
        // image straight back into the internal array, and it then re-renders
        // as the ghost. It re-inserts once and stays, so a short deferred sweep
        // settles it for good.
        //
        // finaliseClear removes everything except the placeholder, drops tracked
        // image refs, wipes both canvas layers to bare pixels and repaints. Run
        // now and again on timers (setTimeout, not rAF - rAF does not fire in
        // some in-app webviews) to catch the late re-insertion.
        function finaliseClear() {
          canvas.getObjects().slice().forEach(function (o) {
            if (!o.isImagePlaceholder) canvas.remove(o);
          });
          if (Array.isArray(images)) images.length = 0;
          wipeCanvasLayers();
          canvas.renderAll();
        }
        finaliseClear();
        setTimeout(finaliseClear, 120);
        setTimeout(finaliseClear, 400);

        // Show notification if requested
        if (showNotification) {
          let message = `
              <strong>✅ Canvas is cleared successfully.</strong><br>
              <small>Removed ${beforeClearState.objects} object(s)</small>
            `;
          showCanvasNotification((success = true), message);
        }

        // console.log("Canvas cleared successfully");
      }
      return true; // Successfully cleared
    } catch (error) {
      console.error("Error clearing canvas:", error);

      // Show error notification
      if (showNotification) {
        let message = "Failed to clear canvas. Please try again.";
        showCanvasNotification((success = false), message);
      }

      return false; // Failed to clear
    }
  }
  // Helper function to update background color UI
  function updateBackgroundColorUI(color) {
    const bgPalette = document.getElementById("bg-color-palette");
    if (bgPalette) {
      // Remove 'selected' class from all color swatches
      bgPalette.querySelectorAll(".color-swatch").forEach((swatch) => {
        swatch.classList.remove("selected");
      });

      // Add 'selected' class to the matching color
      const matchingColor = bgPalette.querySelector(`[data-color="${color}"]`);
      if (matchingColor) {
        matchingColor.classList.add("selected");
      }
    }
  }

  // Helper function to show success notification
  function showCanvasNotification(success, message) {
    // Try to find existing notification area or create one
    let notificationWrapper = document.getElementById(
      "canvas-clear-notification-wrapper"
    );
    let notification = document.getElementById("canvas-clear-notification");

    notification.innerHTML = message;
    notificationWrapper.classList.remove("hidden");
    if (success === true) {
      notification.classList.remove("alert-danger");
      notification.classList.add("alert-success");
    } else {
      notification.classList.add("alert-danger");
      notification.classList.remove("alert-success");
    }

    // Hide after 1.5 seconds
    setTimeout(() => {
      notificationWrapper.classList.add("hidden");
    }, 1500);
  }

  const clearCanvasBtn = document.getElementById("clear-canvas-button");
  clearCanvasBtn.addEventListener("click", () => {
    clearCanvas({ confirmBeforeClear: true, showNotification: true });
  });

  /**
   * Resets the designer to an empty disc, without prompting.
   *
   * For the Etsy portal's multi-disc orders. The upload helpers used to call
   * clearCanvas() themselves, which happened to blank the canvas between
   * slots; removing those calls (so a storefront shopper keeps the design they
   * just saved) left the portal showing disc 1's artwork while the shopper was
   * meant to be designing disc 2. The portal now asks for the reset explicitly
   * at the point it advances a slot, which is where the decision belongs.
   */
  window.DGS_ResetDesigner = function () {
    clearCanvas({ confirmBeforeClear: false, showNotification: false });
    // The committed-design URL belongs to the PREVIOUS design (already safely
    // on its cart line / portal slot). Left in place it told the close guard
    // in customize-disc-design-1.js that the shopper's NEW work was already
    // committed, so "Design another" -> design -> close discarded it without
    // the confirm. The portal never reads this input (it submits via
    // DGS_SubmitDesign directly), so clearing is safe for every caller.
    const urlInput = document.getElementById("disc-design-data-url");
    if (urlInput) urlInput.value = "";
    const typeInput = document.getElementById("disc-design-data-url-type");
    if (typeInput) typeInput.value = "";
  };

  function scrollToDivWithOffset(divId = "disc-canvas", offset = 200) {
    // scrollToDivWithOffsetMobileAlert();return

    const element = document.getElementById(divId);
    if (element) {
      const modal = element.closest(".customize-dics-modal");
      const container = modal
        ? modal.querySelector(".create-disc-wrapper")
        : null;

      if (container) {
        const y = element.offsetTop + offset;
        container.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }

  function scrollToDivWithOffsetMobileAlert(
    divId = "disc-canvas",
    offset = 200
  ) {
    const element = document.getElementById(divId);

    if (!element) {
      alert("❌ Element not found: " + divId);
      return;
    }

    const modal = element.closest(".customize-dics-modal");
    if (!modal) {
      alert("❌ Modal not found");
      return;
    }

    const container = modal.querySelector(".create-disc-wrapper");
    if (!container) {
      alert("❌ Container not found");
      return;
    }

    const info = `
      Container Info:
      - ScrollTop: ${container.scrollTop}
      - ScrollHeight: ${container.scrollHeight}
      - ClientHeight: ${container.clientHeight}
      - Element offsetTop: ${element.offsetTop}
      - Target Y: ${element.offsetTop + offset}
          `.trim();

    // alert(info);

    container.scrollTo({ top: element.offsetTop + offset, behavior: "smooth" });

    // setTimeout(() => {
    //     alert(`After scroll: ${container.scrollTop}`);
    // }, 1000);
  }

  /* ------------------------------------------------------------------------JS for creeate design tab end here------------------------------------------------------------------------------*/

  /* ------------------------------------------------------------------------JS for load designs start here------------------------------------------------------------------------------*/
  // Sample image data — add more src values as needed
  let defaultSelectedDesignValues = { id: null, json: null, src: null };
  let selectedDesign = defaultSelectedDesignValues;
  window.selectedDesign = selectedDesign;

  

  // clear the selected design before loading
  function clearSelectedDesigns() {
    window.selectedDesign = defaultSelectedDesignValues;
    // hide the use design btn
    UseSavedDesignBtn.classList.add("!hidden");
  }  

  // const loadDesignBtn = document.getElementById("loadDesignBtn");
  const UseSavedDesignBtn = document.getElementById("UseSavedDesignBtn");

  // Helper function to scale objects during import
  const scaleObjectForImport = (obj, scaleFactor, currentCanvasSize) => {
    // Scale position
    if (obj.left !== undefined) obj.left = obj.left * scaleFactor;
    if (obj.top !== undefined) obj.top = obj.top * scaleFactor;

    // Scale based on object type
    if (obj.type === "i-text" || obj.type === "text") {
      // Scale font size with limits
      if (obj.fontSize) {
        const newFontSize = obj.fontSize * scaleFactor;
        const minFontSize = 12;
        const maxFontSize = 48;
        obj.fontSize = Math.min(
          Math.max(newFontSize, minFontSize),
          maxFontSize
        );
      }

      // Scale curved text paths
      if (obj.path?.path) {
        obj.path.path.forEach((command) => {
          for (let i = 1; i < command.length; i++) {
            if (typeof command[i] === "number") {
              command[i] *= scaleFactor;
            }
          }
        });
      }
    } else if (obj.type === "image") {
      // Scale image dimensions
      if (obj.scaleX) obj.scaleX = obj.scaleX * scaleFactor;
      if (obj.scaleY) obj.scaleY = obj.scaleY * scaleFactor;
    }

    // Ensure objects stay within bounds
    const padding = currentCanvasSize * 0.05;
    obj.left = Math.max(
      padding,
      Math.min(currentCanvasSize - padding, obj.left)
    );
    obj.top = Math.max(padding, Math.min(currentCanvasSize - padding, obj.top));
  };

  let handleUseSavedDesignAction = async () => {
    let loadDesignError = document.getElementById("load-design-error");

    let { id, src, json } = window.selectedDesign;

    if (json === null) {
      let message = "Kindly select at least one design.";
      loadDesignError.innerHTML = message;
    } else {
      loadDesignError.innerHTML = "";
    }

    isImporting = true;
    try {
      // 1. DEEP CLONE the JSON to avoid mutations
      let originalJson;
      if (typeof json === "string") {
        originalJson = JSON.parse(json);
      } else {
        originalJson = JSON.parse(JSON.stringify(json)); // Deep clone if object
      }

      // **NEW: Preload all fonts before loading JSON**
      if (originalJson.objects) {
        const fontPromises = originalJson.objects
          .filter((obj) => obj.type === "i-text" || obj.type === "textbox")
          .map((obj) => {
            const fontFamily =
              obj.fontFamily || obj.metadata?.textInfo?.fontFamily;
            if (fontFamily) {
              return ensureFontLoaded(fontFamily);
            }
            return Promise.resolve();
          });

        await Promise.all(fontPromises);
      }

      // 2. Determine scaling
      let originalCanvasSize =
        originalJson.canvasMetadata?.canvasSize || originalJson.width || 500;

      const currentCanvasSize = canvas.width;
      const scaleFactor = currentCanvasSize / originalCanvasSize;

      // 3. Clear canvas completely with fabric.js method
      canvas.clear();
      canvas.setViewportTransform([1, 0, 0, 1, 0, 0]); // Reset viewport
      curvedTextStates.clear();
      images = [];

      // Set background color
      if (originalJson.background) {
        canvas.setBackgroundColor(originalJson.background);
        updateBackgroundColorUI(originalJson.background);
      }

      // 4. Scale a COPY of objects, not originals
      const scaledObjects = originalJson.objects
        ? originalJson.objects.map((obj) => {
            const scaledObj = JSON.parse(JSON.stringify(obj)); // Deep clone each object
            if (scaleFactor !== 1) {
              scaleObjectForImport(scaledObj, scaleFactor, currentCanvasSize);
            }
            return scaledObj;
          })
        : [];

      // First, clean the JSON to prevent loading issues
      const cleanedJson = { ...originalJson };
      const metadataStore = []; // Store metadata for restoration

      if (cleanedJson.objects) {
        cleanedJson.objects = scaledObjects.map((obj, index) => {
          const cleanObj = JSON.parse(JSON.stringify(obj)); // Another deep clone

          // **IMPORTANT: Preserve fontFamily in the cleaned object**
          const fontFamily =
            obj.fontFamily || obj.metadata?.textInfo?.fontFamily;
          if (fontFamily) {
            cleanObj.fontFamily = fontFamily;
          }

          // Store all metadata for later restoration
          metadataStore[index] = {
            metadata: cleanObj.metadata,
            curveMetadata: cleanObj.curveMetadata,
            originalPath: cleanObj.path, // Store the SCALED path
            lockInfo: cleanObj.metadata?.lockInfo,
            hasCustomProperties: true,
            fontFamily: fontFamily,
            // Store original position and curve data
            originalLeft: obj.left,
            originalTop: obj.top,
            scaledLeft: cleanObj.left,
            scaledTop: cleanObj.top,
          };

          if (obj.type === "i-text" && obj.path) {
            cleanObj._originalPath = obj.path;
            cleanObj._curveMetadata = obj.curveMetadata;
            delete cleanObj.path; // This prevents fabric.js loading errors
          }

          // Remove custom metadata that might cause loading issues
          delete cleanObj.metadata;
          delete cleanObj.curveMetadata;

          return cleanObj;
        });
      }

      // Load the cleaned JSON
      canvas.loadFromJSON(cleanedJson, () => {
        setTimeout(async () => {
          // Now restore curves to text objects
          canvas.getObjects().forEach((canvasObj, index) => {
            const storedMetadata = metadataStore[index];
            const originalObj = originalJson.objects[index];

            if (!storedMetadata || !originalObj) return;

            // **Restore fontFamily first**
            if (
              storedMetadata.fontFamily &&
              (canvasObj.type === "i-text" || canvasObj.type === "textbox")
            ) {
              canvasObj.set("fontFamily", storedMetadata.fontFamily);
            }

            // Restore base metadata
            if (storedMetadata.metadata) {
              canvasObj.metadata = storedMetadata.metadata;
            }

            // Restore lock functionality
            if (storedMetadata.lockInfo?.isLocked) {
              canvasObj.locked = true;
              canvasObj.set({
                borderColor: "rgba(255, 193, 7, 0.8)",
                cornerColor: "#ffc107",
              });

              if (storedMetadata.lockInfo.storedIndex !== undefined) {
                canvasObj.metadata.storedIndex =
                  storedMetadata.lockInfo.storedIndex;
              }
            }

            // **FIX: Restore curved text with proper scaling**
            if (
              canvasObj.type === "i-text" &&
              originalObj &&
              originalObj.path
            ) {
              try {
                // Use the stored path data with proper scaling
                let pathToRestore;
                
                if (storedMetadata.originalPath) {
                  // If we have a stored scaled path, use it directly
                  if (typeof storedMetadata.originalPath === 'string') {
                    pathToRestore = new fabric.Path(storedMetadata.originalPath, {
                      visible: false,
                    });
                  } else if (storedMetadata.originalPath.path) {
                    // If it's a path object, reconstruct it
                    pathToRestore = new fabric.Path(storedMetadata.originalPath.path, {
                      visible: false,
                    });
                  }
                  
                  // Scale the path if needed
                  if (scaleFactor !== 1 && pathToRestore) {
                    pathToRestore.scale(scaleFactor);
                  }
                } else {
                  // Fallback: recreate path (your original logic)
                  const radius = canvas.width * 0.4;
                  const cx = canvasObj.left;
                  const cy = canvasObj.top;

                  let direction = 0;
                  if (originalObj.curveMetadata) {
                    direction = originalObj.curveMetadata.direction;
                  }

                  const pathDataStr = `M ${
                    cx - radius
                  }, ${cy} A ${radius},${radius} 0 0,${direction} ${
                    cx + radius
                  },${cy}`;
                  pathToRestore = new fabric.Path(pathDataStr, {
                    visible: false,
                  });
                }

                // Calculate character spacing
                const textLength = canvasObj.text ? canvasObj.text.length : 1;
                const baseSpacing = canvas.width < 400 ? 20 : 30;
                const dynamicSpacing = Math.max(
                  baseSpacing - textLength * 2,
                  10
                );

                if (pathToRestore) {
                  canvasObj.set({
                    path: pathToRestore,
                    textAlign: "center",
                    charSpacing: dynamicSpacing,
                  });

                  storeCurvedTextState(canvasObj);
                }
              } catch (error) {
                console.warn("Failed to restore curve for text:", error);
              }
            }

            // Restore image-specific properties
            if (
              canvasObj.type === "image" &&
              storedMetadata.metadata?.imageInfo
            ) {
              const imageInfo = storedMetadata.metadata.imageInfo;
              canvasObj.metadata.imageInfo = imageInfo;
              images.push(canvasObj);
            }

            // Restore text-specific properties
            if (
              (canvasObj.type === "i-text" || canvasObj.type === "textbox") &&
              storedMetadata.metadata?.textInfo
            ) {
              const textInfo = storedMetadata.metadata.textInfo;
              canvasObj.metadata.textInfo = textInfo;
            }

            canvasObj.setCoords();
            activateObjectLockUnlock(canvasObj);
          });

          // Set canvas metadata
          if (json.canvasMetadata) {
            canvas.canvasMetadata = json.canvasMetadata;
          }

          // Set design ID
          canvas.meta = canvas.meta || {};
          canvas.meta.designId = id;

          // Update clip path
          updateClipPath(currentCanvasSize);

          canvas.renderAll();
          handleChangeInCanvas();
          isImporting = false;

          // Update UI controls if there's a selected object
          const activeObject = canvas.getActiveObject();
          if (activeObject && typeof updateControls === "function") {
            updateControls();
          }

          let tabId = "tab1";
          document
            .getElementById("save-as-continue-btn")
            ?.classList?.remove("hidden");

          if (typeof window.activeGivenTab === "function") {
            window.activeGivenTab(tabId);
          }
        }, 300);
      });
    } catch (error) {
      console.error("Import error:", error);
      alert("Error importing design. Please check the file format.");
      isImporting = false;
    }
  };
  
  window.handleUseSavedDesignAction = handleUseSavedDesignAction

  function validateImportedDesign(canvas) {
    const objects = canvas.getObjects();
    let validationReport = {
      totalObjects: objects.length,
      lockedObjects: 0,
      curvedTextObjects: 0,
      objectsWithMetadata: 0,
    };

    objects.forEach((obj) => {
      if (obj.locked) validationReport.lockedObjects++;
      if (obj.curveMetadata) validationReport.curvedTextObjects++;
      if (obj.metadata) validationReport.objectsWithMetadata++;
    });

    // console.log("Design Import Validation:", validationReport);
    return validationReport;
  }

  // Call validation after import (optional)
  // validateImportedDesign(canvas);

  UseSavedDesignBtn.addEventListener("click", handleUseSavedDesignAction);

  function handleChangeInCanvas() {
    // Covers the mutation paths that don't fire object events (background
    // color, clear canvas, import).
    window.DGS_markCanvasDirty();

    hasValidObjects();
    scrollToDivWithOffset();
    updatePlaceholders();
    updateSectionSummaries();
    updateMiniPreview();
  }
  function getFormDataSize(formData) {
    let totalSize = 0;

    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        totalSize += value.size; // File size in bytes
      } else {
        // Approximate size for string fields (UTF-8)
        totalSize += new Blob([value]).size;
      }
    }

    return totalSize; // in bytes
  }
})();

/* ------------------------------------------------------------------------JS for load designs end here------------------------------------------------------------------------------*/
